<template>
    <div style="background:#FAFAFA;" class="policeLato">
    
      <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
      <section class="mt-5" v-if="isMobile()">
        <div class="paralax-cover-image_mobile has-background-dim_mobile">
          <p class="paralax-cover-image-text_mobile">
          <div class="content_home" style="z-index: 1!important;margin-top: 10%">
            <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{
              $t('devis.devis_auto.header_title[0]') }}</span></h1>
            <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{
              $t('devis.devis_auto.header_title[1]') }}</span></h1>
          </div>
          </p>
        </div>
      </section>
  
      <div>
        <div class="container" style="background:#FAFAFA">
          <div class="container justify-content-center row text-center mb-5 mt-5">
            <p class="mb-3"  style="font-weight: 300;color: #ffa409;font-family: Open Sans, sans-serif;font-size:25px!important;">
              {{$t('devis.devis_auto.title[0]') }} <span class="font-weight-bold">{{ $t('devis.devis_auto.title[1]') }}</span>
              {{ $t('devis.devis_auto.title[2]') }} <span class="font-weight-bold">{{ $t('devis.devis_auto.title[3]') }}</span>
            </p> <br>
          </div>
          <br>
  
          <div class="row" style="background:#FAFAFA" v-if="isMobile()">
            <div class="col-md-10" style="background:#FAFAFA">
              <div class="form" style="background:#FAFAFA">
                <div class="wizard-navigation">
                  <div class="wizard-progress-with-circle">
                    <div class="wizard-progress-bar"
                      style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                  </div>
                  <div class="progress-bar-group">
                    <div class="progress-bar-custom" id="testup"></div>
                  </div>
                  <ul role="tablist" class="wizard-nav wizard-nav-pills">
                    <li class="step" id="firstStep">
                      <div class="step-title text-center mr-4">{{ $t('devis.devis_auto.stepper_title[0]') }}</div>
                    </li>
                    <li class="step" id="secondStep">
                      <div class="step-title text-center mr-4">{{ $t('devis.devis_auto.stepper_title[1]') }}</div>
                    </li>
                    <li class="step" id="thirstStep">
                      <div class="step-title text-center mr-4">{{ $t('devis.devis_auto.stepper_title[2]') }}</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     ================= -->
          <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
          <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
          <!-- ========================================================================================= -->
          <div v-responsive.sm.xs>
            <div class="mt-5" style="background:#FAFAFA">
              <div class="row" style="background:#FAFAFA">
                <div class="col-md-10" style="background:#FAFAFA">
                  <div class="form" style="background:#FAFAFA">
                    <div class="page" v-show="step === 0">
                      <div class="wizard-tab-content">
                        <div role="tabpanel" id="Step1_mobile" aria-labelledby="step-Step1_mobile"
                          class="wizard-tab-container">
                          <div>
                            <div class="fields">
                              <div class="field-title">{{ $t('devis.devis_auto.stepper_one_subtitle_one') }}</div>
                              <div class="field-group justify-content-center row flex-column flex-sm-row">
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input :disabled="disableMyCars" v-model="myCars" value="mes_vehicule" type="radio"
                                    id="Stepper1_1_2_mobile" name="Step1_mobile" @click="getListVehicule"
                                    class="field-input">
                                  <label for="Stepper1_1_2_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/the_cars.png" class="mr-4 mr-md-0" alt="Mes véhicules">
                                    <p>{{ $t('devis.devis_auto.my_vehicule') }}</p>
                                  </label>
                                </div>
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input v-model="myCars" type="radio" value="nouveau" id="Stepper2_2_3_mobile"
                                    name="Step1_mobile" class="field-input" @click="myCars = 'nouveau'; myCarValidator()">
                                  <label for="Stepper2_2_3_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/mycars.png" class="mr-4 mr-md-0" alt="Nouveau véhicule">
                                    <p>{{ $t('devis.devis_auto.new_vehicule') }}</p>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
  
                    <div class="page" v-show="step === 1">
                      <div class="wizard-tab-content">
                        <div role="tabpanel" id="Step1_mobile" aria-labelledby="step-Step1_mobile"
                          class="wizard-tab-container">
                          <div>
                            <div class="fields">
                              <div class="field-title">{{ $t('devis.devis_auto.stepper_one_subtitle_one') }}</div>
                              <div class="field-group justify-content-center row flex-column flex-sm-row">
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input v-model="flotte_mono" value="mono" type="radio" id="Stepper1_mobile"
                                    name="Step1_mobile" @click="flotte_mono = 'mono'; Stepper1Validator()" class="field-input">
                                  <label for="Stepper1_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/car.png" class="mr-4 mr-md-0" alt="Véhicule individuel">
                                    <p>{{ $t('devis.devis_auto.vehicule_indivi') }}</p>
                                  </label>
                                </div>
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input disabled v-model="flotte_mono" type="radio" value="flotte" id="Stepper2_mobile"
                                    name="Step1_mobile" class="field-input">
                                  <label for="Stepper2_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/cars.png" class="mr-4 mr-md-0" alt="Flotte de véhicules">
                                    <p>{{ $t('devis.devis_auto.flotte') }}</p>
                                  </label>
                                </div>
                              </div>
                              <div class="field-group field-default flex-sm-row mt-5 " v-show="flotte_mono === 'flotte'">
                                <label for="Stepper3_mobile" class="field-label">{{ $t('devis.devis_auto.nbre_vehicule')
                                }}</label>
                                <select id="Stepper3_mobile" name="Step1_mobile" class="field-select"
                                  v-model="nombreVehicules">
                                  <option v-for="item in itemsFlotte" :key="item" :value="item" @change="Stepper1Validator">
                                    {{ item }}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="wizard-card-footer clearfix">
                        <div class="wizard-footer-left">
                          <button @click="backToFirstStep()" type="button" class="wizard-btn">
                            <span class="fas fa-arrow-left"></span>
                            {{ $t('devis.devis_auto.bouton_retour') }}
                          </button>
                        </div>
                        <div class="wizard-footer-right">
                          <button @click="Stepper1Validator()" type="button" class="wizard-btn">
                            {{ $t('devis.devis_auto.bouton_suivant') }}
                          </button>
                        </div>
                        <!---->
                      </div>
  
                    </div>
  
                    <div class="page" v-show="step === 2">
                      <div class="wizard-tab-content">
                        <!-- OCR Carte Grise Section Mobile -->
                        <div role="tabpanel" class="wizard-tab-container">
                          <div class="fields" v-if="!ocrMode">
                            <div class="field-title">{{ $t('devis.devis_auto.ocr_carte_grise.mode_title') }}</div>
                            <div class="field-group justify-content-center row flex-column flex-sm-row mb-3">
                              <div class="btn-choice btn-choice-icon sm-no-change">
                                <input type="radio" v-model="ocrMode" value="ocr" id="ocrModeOcr_mobile" name="ocrMode_mobile" class="field-input">
                                <label for="ocrModeOcr_mobile" class="flex-row flex-md-column field-label">
                                  <i class="fas fa-camera fa-2x mr-3 mr-md-0 mb-md-2" style="color: #ffa409;"></i>
                                  <p>{{ $t('devis.devis_auto.ocr_carte_grise.ocr_mode') }}</p>
                                </label>
                              </div>
                              <div class="btn-choice btn-choice-icon sm-no-change">
                                <input type="radio" v-model="ocrMode" value="manual" id="ocrModeManual_mobile" name="ocrMode_mobile" class="field-input">
                                <label for="ocrModeManual_mobile" class="flex-row flex-md-column field-label">
                                  <i class="fas fa-edit fa-2x mr-3 mr-md-0 mb-md-2" style="color: #ffa409;"></i>
                                  <p>{{ $t('devis.devis_auto.ocr_carte_grise.manual_mode') }}</p>
                                </label>
                              </div>
                            </div>
                          </div>

                          <!-- Lien discret pour changer de mode -->
                          <div v-if="ocrMode" class="mb-2">
                            <button type="button" @click="changeOcrMode" style="background: none; border: none; color: #666; font-size: 13px; cursor: pointer; padding: 4px 0;">
                              <i class="fas fa-arrow-left mr-2"></i>Changer de mode
                            </button>
                          </div>

                          <!-- OCR Upload Section Mobile -->
                          <div v-if="ocrMode === 'ocr' && !extractedCarteGriseData && !ocrDataValidated" class="ocr-upload-section mt-3">
                            <div class="fields">
                              <div class="field-title">{{ $t('devis.devis_auto.ocr_carte_grise.upload_title') }}</div>
                              <p class="text-muted small">{{ $t('devis.devis_auto.ocr_carte_grise.upload_subtitle') }}</p>

                              <!-- Recto Upload Mobile -->
                              <div class="upload-box mt-3" :class="{ 'upload-success': carteGriseRectoFile }">
                                <input type="file" @change="handleCarteGriseRectoUpload" accept="image/*,.pdf" :disabled="carteGriseOcrLoading" style="display: none" ref="carteGriseRectoInputMobile">
                                <div class="upload-content" @click="$refs.carteGriseRectoInputMobile.click()">
                                  <i class="fas fa-id-card fa-2x mb-2" :style="{ color: carteGriseRectoFile ? '#28a745' : '#ffa409' }"></i>
                                  <p class="font-weight-bold">{{ $t('devis.devis_auto.ocr_carte_grise.recto') }} <span style="color: #e74c3c;">*</span></p>
                                  <p v-if="carteGriseRectoFile" class="text-success small">{{ carteGriseRectoFile.name }}</p>
                                </div>
                              </div>

                              <!-- Verso Upload Mobile -->
                              <div class="upload-box mt-3" :class="{ 'upload-success': carteGriseVersoFile }">
                                <input type="file" @change="handleCarteGriseVersoUpload" accept="image/*,.pdf" :disabled="carteGriseOcrLoading" style="display: none" ref="carteGriseVersoInputMobile">
                                <div class="upload-content" @click="$refs.carteGriseVersoInputMobile.click()">
                                  <i class="fas fa-id-card fa-2x mb-2" :style="{ color: carteGriseVersoFile ? '#28a745' : '#ffa409' }"></i>
                                  <p class="font-weight-bold">{{ $t('devis.devis_auto.ocr_carte_grise.verso') }} <span style="color: #e74c3c;">*</span></p>
                                  <p v-if="carteGriseVersoFile" class="text-success small">{{ carteGriseVersoFile.name }}</p>
                                </div>
                              </div>

                              <!-- Analyze Button Mobile -->
                              <div class="text-center mt-3">
                                <button type="button" @click="analyzeCarteGrise" :disabled="!carteGriseRectoFile || !carteGriseVersoFile || carteGriseOcrLoading" class="wizard-btn analyze-cg-btn">
                                  <span v-if="!carteGriseOcrLoading"><i class="fas fa-search mr-2"></i>{{ $t('devis.devis_auto.ocr_carte_grise.analyze_btn') }}</span>
                                  <span v-else><i class="fas fa-spinner fa-spin mr-2"></i>{{ $t('devis.devis_auto.ocr_carte_grise.analyzing') }}</span>
                                </button>
                              </div>

                              <!-- OCR Error Mobile -->
                              <div v-if="carteGriseOcrError" class="alert alert-warning mt-3" style="background-color: #fff3cd; border-left: 4px solid #ffc107; padding: 10px; font-size: 12px;">
                                <i class="fas fa-exclamation-triangle mr-2"></i>{{ carteGriseOcrError }}
                              </div>
                            </div>
                          </div>

                          <!-- OCR Recap Section Mobile - Always visible when data exists -->
                          <div v-if="ocrMode === 'ocr' && extractedCarteGriseData" class="ocr-recap-section mt-3">
                            <div class="fields">
                              <div class="field-title">{{ $t('devis.devis_auto.ocr_carte_grise.recap_title') }}</div>

                              <!-- Récap lecture seule -->
                              <div v-if="!isEditingOcr" class="row mt-2">
                                <div class="col-6 mb-2">
                                  <small class="text-muted">Immatriculation</small><br>
                                  <span class="font-weight-bold">{{ extractedCarteGriseData.immatriculation || '—' }}</span>
                                </div>
                                <div class="col-6 mb-2">
                                  <small class="text-muted">Marque</small><br>
                                  <span class="font-weight-bold">{{ extractedCarteGriseData.marque || '—' }}</span>
                                </div>
                                <div class="col-6 mb-2">
                                  <small class="text-muted">Modèle</small><br>
                                  <span class="font-weight-bold">{{ extractedCarteGriseData.modele || '—' }}</span>
                                </div>
                                <div class="col-6 mb-2">
                                  <small class="text-muted">Carburant</small><br>
                                  <span class="font-weight-bold">{{ extractedCarteGriseData.carburant || '—' }}</span>
                                </div>
                                <div class="col-6 mb-2">
                                  <small class="text-muted">Puissance</small><br>
                                  <span class="font-weight-bold">{{ extractedCarteGriseData.puissanceFiscale || '—' }} CV</span>
                                </div>
                                <div class="col-6 mb-2">
                                  <small class="text-muted">Places</small><br>
                                  <span class="font-weight-bold">{{ extractedCarteGriseData.nombrePlaces || '—' }}</span>
                                </div>
                              </div>

                              <!-- Formulaire d'édition pré-rempli (aligné sur les champs du parcours manuel) -->
                              <div v-else class="mt-2">
                                <div class="field-group field-default mb-3">
                                  <label for="OcrImmatMobile" class="field-label">{{ $t('devis.devis_auto.immatriculation') }}</label>
                                  <input type="text" v-model="extractedCarteGriseData.immatriculation" id="OcrImmatMobile" class="field-input">
                                </div>
                                <div class="field-group field-default mb-3">
                                  <label for="OcrMarqueMobile" class="field-label">{{ $t('devis.devis_auto.marque') }}</label>
                                  <select v-model="extractedCarteGriseData.marque" id="OcrMarqueMobile" class="field-select">
                                    <option v-for="m in ocrEditMarques" :key="m" :value="m">{{ m }}</option>
                                  </select>
                                </div>
                                <div class="field-group field-default mb-3">
                                  <label for="OcrModeleMobile" class="field-label">{{ $t('devis.devis_auto.model') }}</label>
                                  <select v-model="extractedCarteGriseData.modele" id="OcrModeleMobile" class="field-select">
                                    <option v-for="t in ocrEditModeles" :key="t" :value="t">{{ t }}</option>
                                  </select>
                                </div>
                                <div class="field-group field-default mb-3">
                                  <label for="OcrDateMobile" class="field-label">{{ $t('devis.devis_auto.date_mis_en_circule') }}</label>
                                  <div class="input-group value-loan">
                                    <date-picker :disabled-date="disabledBeforeToday" class="field-input ml-2 mb-1 mt-1"
                                      placeholder="Cliquer ici" id="OcrDateMobile"
                                      v-model="extractedCarteGriseData.dateCirculation"
                                      valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                  </div>
                                </div>
                                <div class="field-group field-default mb-3">
                                  <label for="OcrCarburantMobile" class="field-label">{{ $t('devis.devis_auto.carburant_title') }}</label>
                                  <select v-model="extractedCarteGriseData.carburant" id="OcrCarburantMobile" class="field-select">
                                    <option value="">—</option>
                                    <option value="Essence">{{ $t('devis.devis_auto.essence') }}</option>
                                    <option value="Diésel">{{ $t('devis.devis_auto.diesel') }}</option>
                                    <option value="Hybride">{{ $t('devis.devis_auto.hybride') }}</option>
                                    <option value="Electrique">{{ $t('devis.devis_auto.electrique') }}</option>
                                  </select>
                                </div>
                                <div class="field-group field-default mb-3">
                                  <label for="OcrPuissMobile" class="field-label">{{ $t('devis.devis_auto.puissance_fiscale') }}</label>
                                  <select v-model="extractedCarteGriseData.puissanceFiscale" id="OcrPuissMobile" class="field-select">
                                    <option v-for="item in PuissanceFinscaleItems" :key="item" :value="item">{{ item }}</option>
                                  </select>
                                </div>
                                <div class="field-group field-default mb-3">
                                  <label for="OcrPlacesMobile" class="field-label">{{ $t('devis.devis_auto.nbre_place') }}</label>
                                  <select v-model="extractedCarteGriseData.nombrePlaces" id="OcrPlacesMobile" class="field-select">
                                    <option v-for="item in items" :key="item" :value="item">{{ item }}</option>
                                  </select>
                                </div>
                                <div class="field-group field-default mb-3">
                                  <label for="OcrChassisMobile" class="field-label">{{ $t('devis.devis_auto.numero_chassis') }}</label>
                                  <input type="text" maxlength="17" v-model="extractedCarteGriseData.numeroChassis" id="OcrChassisMobile" class="field-input">
                                </div>
                              </div>

                              <!-- Buttons before validation (read-only recap) -->
                              <div v-if="!ocrDataValidated && !isEditingOcr" class="text-center mt-3">
                                <button type="button" @click="resetCarteGriseOcr" class="wizard-btn mr-2 mb-2" style="background-color: #6c757d; color: white; padding: 8px 20px; border-radius: 50px; font-size: 14px;">
                                  <i class="fas fa-redo mr-1"></i>Réessayer
                                </button>
                                <button type="button" @click="startEditCarteGriseOcr" class="wizard-btn mr-2 mb-2" style="background-color: #fff; color: #ffa409; border: 2px solid #ffa409; padding: 8px 20px; border-radius: 50px; font-size: 14px;">
                                  <i class="fas fa-edit mr-1"></i>Modifier
                                </button>
                                <button type="button" @click="validateCarteGriseOcr" class="wizard-btn mb-2" style="background-color: #ffa409; color: white; padding: 8px 20px; border-radius: 50px; font-size: 14px;">
                                  <i class="fas fa-check mr-1"></i>Valider
                                </button>
                              </div>

                              <!-- Buttons during edit -->
                              <div v-if="isEditingOcr" class="text-center mt-3">
                                <button type="button" @click="cancelEditCarteGriseOcr" class="wizard-btn mr-2 mb-2" style="background-color: #6c757d; color: white; padding: 8px 20px; border-radius: 50px; font-size: 14px;">
                                  <i class="fas fa-times mr-1"></i>Annuler
                                </button>
                                <button type="button" @click="saveEditCarteGriseOcr" class="wizard-btn mb-2" style="background-color: #ffa409; color: white; padding: 8px 20px; border-radius: 50px; font-size: 14px;">
                                  <i class="fas fa-check mr-1"></i>Enregistrer
                                </button>
                              </div>

                              <!-- After validation: show Valeur actuelle field -->
                              <div v-if="ocrDataValidated" class="mt-3">
                                <div class="alert alert-success mb-3" style="background-color: #d4edda; border-left: 4px solid #28a745; padding: 10px; font-size: 12px;">
                                  <i class="fas fa-check-circle mr-2"></i>{{ $t('devis.devis_auto.ocr_carte_grise.data_validated') }}
                                </div>

                                <div class="field-title">{{ $t('devis.devis_auto.valeur_immatricule_title') }}&nbsp;:</div>
                                <div class="field-group field-default mt-2">
                                  <label class="field-label">{{ $t('devis.devis_auto.valeur_actuelle') }} <span style="color: #e74c3c;">*</span></label>
                                  <div class="input-group value-loan">
                                    <input v-money="money" maxlength="11" v-model="valeur_venale" class="field-input" placeholder="Ex: 5 000 000">
                                    <div class="input-group-append">
                                      <div class="input-group-text">FCFA</div>
                                    </div>
                                  </div>
                                </div>
                                <!-- VIN field: only show input if not returned by OCR -->
                                <div class="field-group field-default mt-2" v-if="!extractedCarteGriseData.numeroChassis">
                                  <label class="field-label">{{ $t('devis.devis_auto.numero_chassis') }}</label>
                                  <input type="text" maxlength="17" v-model="numeroChassis" class="field-input" placeholder="Numéro de châssis (VIN)">
                                </div>

                                <div class="text-center mt-3">
                                  <button type="button" @click="reopenOcrEdit" class="wizard-btn mr-2 mb-2" style="background-color: #fff; color: #ffa409; border: 2px solid #ffa409; padding: 8px 20px; border-radius: 50px; font-size: 14px;">
                                    <i class="fas fa-edit mr-1"></i>Modifier les infos
                                  </button>
                                  <button type="button" @click="goToPacksFromOcr" class="wizard-btn mb-2" style="background-color: #ffa409; color: white; padding: 10px 30px; border-radius: 50px;">
                                    {{ $t('devis.devis_auto.bouton_suivant') }}
                                    <i class="fas fa-arrow-right ml-2"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Categorization (show only in manual mode) -->
                        <div v-show="ocrMode === 'manual'" role="tabpanel" id="Step2_mobile" aria-hidden="true" aria-labelledby="step-Step2_mobile"
                          class="wizard-tab-container">
                          <div>
                            <div class="fields">
                              <div class="field-title">
                                {{ $t('devis.devis_auto.categorisation_title') }}&nbsp;:
                              </div>
                              <div class="field-group justify-content-center row flex-column flex-sm-row">
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input type="radio" v-model="categorie" value="tourisme" id="Stepper4_mobile"
                                    name="Step2_mobile" class="field-input">
                                  <label for="Stepper4_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/car.png" class="mr-4 mr-md-0" alt="Véhicule particulier">
                                    <p>{{ $t('devis.devis_auto.vehicule_particulier') }}</p>
                                  </label>
                                </div>
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input type="radio" v-model="categorie" value="2_roues" id="Stepper5_mobile"
                                    name="Step2_mobile" class="field-input">
                                  <label for="Stepper5_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/2_roues.png" class="mr-4 mr-md-0" alt="2 roues">
                                    <p>{{ $t('devis.devis_auto.2_roues') }}</p>
                                  </label>
                                </div>
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input type="radio" v-model="categorie" value="utilitaire" id="Stepper6_mobile"
                                    name="Step2_mobile" class="field-input">
                                  <label for="Stepper6_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/utilitaire.png" class="mr-4 mr-md-0" alt="Véhicule utilitaire">
                                    <p>{{ $t('devis.devis_auto.vehicule_utilitaire') }}</p>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
  
                        <div role="tabpanel" id="Step5_mobile" aria-hidden="true" aria-labelledby="step-Step5_mobile"
                          class="wizard-tab-container" v-show="categorie === 'utilitaire'">
                          <div>
                            <div class="fields">
                              <div class="field-title">
                                {{ $t('devis.devis_auto.option_utilitaire_title') }}&nbsp;:
                              </div>
                              <div class="field-group justify-content-center row flex-column flex-sm-row">
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input type="radio" v-model="optionUtilitaire" value="Pour Compte" id="Stepper14_mobile"
                                    name="Step5_mobile" class="field-input">
                                  <label for="Stepper14_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/owner.png" class="mr-4 mr-md-0" alt="Pour Compte">
                                    <p>{{ $t('devis.devis_auto.materiel_perso') }}</p>
                                  </label>
                                </div>
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input type="radio" v-model="optionUtilitaire" value="Pour Tiers" id="Stepper15_mobile"
                                    name="Step5_mobile" class="field-input">
                                  <label for="Stepper15_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/tiers.png" class="mr-4 mr-md-0" alt="Pour Tiers">
                                    <p>{{ $t('devis.devis_auto.materiel_tiers') }}</p>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
  
                        <div role="tabpanel" id="Step3_mobile" aria-hidden="true" aria-labelledby="step-Step3_mobile"
                          class="wizard-tab-container" v-show="categorie === 'utilitaire'">
                          <div>
                            <div class="fields">
                              <div class="field-title">
                                {{ $t('devis.devis_auto.tonnage_carosserie_title') }}&nbsp;:
                              </div>
                              <div class="field-group justify-content-center row flex-column flex-sm-row">
                                <div class="btn-choice btn-choice-icon sm-no-change"
                                  v-show="optionUtilitaire != 'Pour Tiers'">
                                  <input type="radio" v-model="tonnage_carosserie" value="carosserie tourisme"
                                    id="Stepper7_mobile" name="Step3_mobile" class="field-input">
                                  <label for="Stepper7_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/tourism_bodycar.png" class="mr-4 mr-md-0" alt="Carrosserie Tourisme">
                                    <p class="justify-content-center row text-center">{{
                                      $t('devis.devis_auto.carosserie_tourisme') }}</p>
                                  </label>
                                </div>
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input type="radio" v-model="tonnage_carosserie"
                                    value="Autre carosserie jusqu'à 3,5 tonnes" id="Stepper8_mobile" name="Step3_mobile"
                                    class="field-input">
                                  <label for="Stepper8_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/3_5_tonnes.png" class="mr-4 mr-md-0" alt="Autre Carrosserie jusqu'à 3,5 tonnes">
                                    <p class="justify-content-center row text-center">{{
                                      $t('devis.devis_auto.autre_carosserie') }}</p>
                                  </label>
                                </div>
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input type="radio" v-model="tonnage_carosserie"
                                    value="Autre carosserie plus de 3,5 tonnes" id="Stepper9_mobile" name="Step3_mobile"
                                    class="field-input">
                                  <label for="Stepper9_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/plus_3_5_tonnes.png" class="mr-4 mr-md-0" alt="Autre Carrosserie plus de 3,5 tonnes">
                                    <p class="justify-content-center row text-center">{{
                                      $t('devis.devis_auto.autre_carosserie_plus') }}</p>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                         <div role="tabpanel" id="Step6_mobile" aria-hidden="true" aria-labelledby="step-Step6_mobile"
                          class="wizard-tab-container" v-show="ocrMode === 'manual'">
                          <div>
                            <div class="fields">
                              <div class="field-title">
                                {{ $t('devis.devis_auto.carburation_title') }}&nbsp;:
                              </div>
                              <div class="field-group justify-content-center row flex-column flex-sm-row">
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input type="radio" v-model="carburant" value="Essence" id="Stepper16_mobile"
                                    name="Step6_mobile" class="field-input" @change="Stepper2Validator()">
                                  <label for="Stepper16_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/oil.png" class="mr-4 mr-md-0" alt="Essence">
                                    <p class="justify-content-center row text-center">{{ $t('devis.devis_auto.essence') }}
                                    </p>
                                  </label>
                                </div>
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input type="radio" v-model="carburant" value="Diésel" id="Stepper17_mobile"
                                    name="Step6_mobile" class="field-input" @change="Stepper2Validator()">
                                  <label for="Stepper17_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/oil_diesel.png" class="mr-4 mr-md-0" alt="Diesel">
                                    <p class="justify-content-center row text-center">{{ $t('devis.devis_auto.diesel') }}
                                    </p>
                                  </label>
                                </div>
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input type="radio" v-model="carburant" value="Hybride" id="Stepper18_mobile"
                                    name="Step6_mobile" class="field-input" @change="Stepper2Validator()">
                                  <label for="Stepper18_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/hubrid.png" class="mr-4 mr-md-0" alt="Hybride">
                                    <p class="justify-content-center row text-center">{{ $t('devis.devis_auto.hybride') }}
                                    </p>
                                  </label>
                                </div>
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input type="radio" v-model="carburant" value="Electrique" id="Stepper19_mobile"
                                    name="Step6_mobile" class="field-input" @change="Stepper2Validator()">
                                  <label for="Stepper19_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/electrique.png" class="mr-4 mr-md-0" alt="Electrique">
                                    <p class="justify-content-center row text-center">{{ $t('devis.devis_auto.electrique')
                                    }}</p>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div role="tabpanel" id="Step4_mobile" aria-hidden="true" aria-labelledby="step-Step4_mobile"
                          class="wizard-tab-container" v-show="categorie === '2_roues'">
                          <div>
                            <div class="fields">
                              <div class="field-title">
                                {{ $t('devis.devis_auto.volumetrie_title') }}&nbsp;:
                              </div>
                              <div class="field-group justify-content-center row flex-column flex-sm-row">
                                <div class="btn-choice btn-choice-icon sm-no-change"
                                  v-show="optionUtilitaire != 'Pour Tiers'">
                                  <input type="radio" v-model="volumetrie2_roues" value="50" id="Stepper10_mobile"
                                    name="Step4_mobile" class="field-input" @change="Stepper2Validator()">
                                  <label for="Stepper10_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/volumetrie_50.png" class="mr-4 mr-md-0" alt="50 cm3">
                                    <p>{{ $t('devis.devis_auto.50_cm3') }}</p>
                                  </label>
                                </div>
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input type="radio" v-model="volumetrie2_roues" value="125" id="Stepper11_mobile"
                                    name="Step4_mobile" class="field-input" @change="Stepper2Validator()">
                                  <label for="Stepper11_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/volumetrie_125.png" class="mr-4 mr-md-0" alt="125 cm3">
                                    <p>{{ $t('devis.devis_auto.125_cm3') }}</p>
                                  </label>
                                </div>
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input type="radio" v-model="volumetrie2_roues" value="126" id="Stepper12_mobile"
                                    name="Step4_mobile" class="field-input" @change="Stepper2Validator()">
                                  <label for="Stepper12_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/volumetrie_plus_125.png" class="mr-4 mr-md-0" alt="400 cm3">
                                    <p>{{ $t('devis.devis_auto.400_cm3') }}</p>
                                  </label>
                                </div>
  
                                <div class="btn-choice btn-choice-icon sm-no-change">
                                  <input type="radio" v-model="volumetrie2_roues" value="401" id="Stepper13_mobile"
                                    name="Step4_mobile" class="field-input" @change="Stepper2Validator()">
                                  <label for="Stepper13_mobile" class="flex-row flex-md-column field-label">
                                    <img src="../../assets/img/icones/side-car.png" class="mr-4 mr-md-0" alt="Plus de 400 cm3">
                                    <p>{{ $t('devis.devis_auto.plus_400_cm3') }}</p>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="wizard-card-footer clearfix" v-show="ocrMode">
                        <div class="wizard-footer-left">
                          <button @click="BacktoFirstStep()" type="button" class="wizard-btn">
                            <span class="fas fa-arrow-left"></span>
                            {{ $t('devis.devis_auto.bouton_retour') }}
                          </button>
                        </div>
                        <div class="wizard-footer-right" v-show="ocrMode === 'manual'">
                          <button @click="Stepper2Validator()" type="button" class="wizard-btn">
                            {{ $t('devis.devis_auto.bouton_suivant') }}
                          </button>
                        </div>
                        <!---->
                      </div>
                    </div>

                    <div class="page" v-show="step === 3">
                      <div class="wizard-tab-content">
                        <div role="tabpanel" id="Step7_mobile" aria-hidden="true" aria-labelledby="step-Step7_mobile"
                          class="wizard-tab-container">
                          <div>
                            <div class="loan-group loan-group-0">
                              <div class="fields" v-if="categorie == '2_roues'">
                                <div class="field-title">{{ $t('devis.devis_auto.marque_model_title') }}&nbsp;:</div>
                                <div class="justify-content-center row">
                                  <div class="field-radio field-radio-center mr-4 ml-4">
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque2roues" type="radio" v-model="marque"
                                        value="Peugeot" id="hyundai" name="marque_model_mobile" class="field-input">
                                      <label for="hyundai" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/peugeot_2.png" alt="marque peugeot" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">PEUGEOT</span>
                                      </label>
                                    </div>
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque2roues" v-model="marque" type="radio"
                                        value="Honda" id="audi" name="marque_model_mobile" class="field-input">
                                      <label for="audi" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/honda.png" alt="marque honda" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">HONDA</span>
                                      </label>
                                    </div>
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque2roues" v-model="marque" type="radio"
                                        value="Aprilia" id="bmw" name="marque_model_mobile" class="field-input">
                                      <label for="bmw" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/aprilia.png" alt="marque aprilia" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">APRILIA</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div class="justify-content-center row mt-3">
                                  <div class="field-radio field-radio-center ml-4 mr-4">
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque2roues" v-model="marque" type="radio"
                                        value="Piaggio" id="ford" name="marque_model_mobile" class="field-input">
                                      <label for="ford" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/piaggio.png" alt="marque piaggio" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">PIAGGIO</span>
                                      </label>
                                    </div>
  
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque2roues" v-model="marque" type="radio"
                                        value="Yamaha" id="citroen" name="marque_model_mobile" class="field-input">
                                      <label for="citroen" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/yamaha.png" alt="marque yamaha" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">YAMAHA</span>
                                      </label>
                                    </div>
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque2roues" v-model="marque" type="radio"
                                        value="Suzuki" id="dacia" name="marque_model_mobile" class="field-input">
                                      <label for="dacia" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/suzuki_2.png" alt="marque suzuki" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">SUZUKI</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div class="justify-content-center row mt-3">
                                  <div class="field-radio field-radio-center mr-4 ml-4">
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque2roues" v-model="marque" type="radio"
                                        value="KTM" id="mitsubishi" name="marque_model_mobile" class="field-input">
                                      <label for="mitsubishi" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/ktm.png" alt="marque ktm" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">KTM</span>
                                      </label>
                                    </div>
  
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque2roues" v-model="marque" type="radio"
                                        value="Kawasaki" id="mercedes" name="marque_model_mobile" class="field-input">
                                      <label for="mercedes" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/kawasaki.png" alt="marque kawasaki" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">KAWASAKI</span>
                                      </label>
                                    </div>
  
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque2roues" v-model="marque" type="radio"
                                        value="BMW Motorrad" id="jeep" name="marque_model_mobile" class="field-input">
                                      <label for="jeep" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/BMW.png" alt="marque bmw" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">BMW</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div class="justify-content-center row mt-3 mb-3">
                                  <div class="field-radio field-radio-center mr-4 ml-4">
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque2roues" v-model="marque" type="radio"
                                        value="Kymco" id="nissan" name="marque_model_mobile" class="field-input">
                                      <label for="nissan" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/kymco.png" alt="marque kymco" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">KYMCO</span>
                                      </label>
                                    </div>
  
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque2roues" v-model="marque" type="radio"
                                        value="OPEL" id="opel" name="marque_model_mobile" class="field-input">
                                      <label for="opel" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/lifan.png" alt="marque lifan" width="50"
                                          height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">LIFAN</span>
                                      </label>
                                    </div>
  
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque2roues" v-model="marque" type="radio"
                                        value="Gilera" id="peugeot" name="marque_model_mobile" class="field-input">
                                      <label for="peugeot" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/Gilera.png" alt="marque gilera" width="50"
                                          height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">GILERA</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
  
                                <div class="justify-content-center row mt-3 mb-3">
                                  <div class="field-radio field-radio-center mr-4 ml-4">
  
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque2roues" v-model="marque" type="radio"
                                        value="Malaguti" id="renault" name="marque_model_mobile" class="field-input">
                                      <label for="renault" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/malaguti.png" alt="marque malaguti" width="50"
                                          height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">MALAGUTI</span>
                                      </label>
                                    </div>
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque2roues" v-model="marque" type="radio"
                                        value="Sym" id="suzuki" name="marque_model_mobile" class="field-input">
                                      <label for="suzuki" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/sym.png" alt="marque sym" width="50"
                                          height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">SYM</span>
                                      </label>
                                    </div>
  
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque2roues" v-model="marque" type="radio"
                                        value="Vespa" id="toyota" name="marque_model_mobile" class="field-input">
                                      <label for="toyota" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/vespa.png" alt="marque vespa" width="50"
                                          height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">VESPA</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div class="justify-content-center row mt-3 mb-3">
                                  <div class="field-radio field-radio-center mr-4 ml-4">
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque2roues" v-model="marque" type="radio"
                                        value="Mash" id="volkswagen" name="marque_model_mobile" class="field-input">
                                      <label for="volkswagen" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/mash.png" alt="marque mash" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">MASH</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
  
                                <div class="justify-content-center row">
                                  <div class="col-lg-12 text-center"><button type="button" @click="showMarque2roue"
                                      class="btn btn-loan btn-add-loan">
                                      {{ $t('devis.devis_auto.bouton_autre_label') }} <i class="fas fa-arrow-down"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
  
                              <div class="fields" v-if="categorie != '2_roues'">
                                <div class="field-title">{{ $t('devis.devis_auto.marque_model_title') }}&nbsp;:</div>
                                <div class="justify-content-center row">
                                  <div class="field-radio field-radio-center mr-4 ml-4">
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque" type="radio" v-model="marque" value="HYUNDAI"
                                        id="hyundai" name="marque_model_mobile" class="field-input">
                                      <label for="hyundai" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/HYUNDAI.png" alt="marque hyndai" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">HYUNDAI</span>
                                      </label>
                                    </div>
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque" v-model="marque" type="radio" value="AUDI"
                                        id="audi" name="marque_model_mobile" class="field-input">
                                      <label for="audi" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/AUDI.png" alt="marque audi" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">AUDI</span>
                                      </label>
                                    </div>
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque" v-model="marque" type="radio" value="BMW"
                                        id="bmw" name="marque_model_mobile" class="field-input">
                                      <label for="bmw" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/BMW.png" alt="marque bmw" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">BMW</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div class="justify-content-center row mt-3">
                                  <div class="field-radio field-radio-center ml-4 mr-4">
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque" v-model="marque" type="radio" value="FORD"
                                        id="ford" name="marque_model_mobile" class="field-input">
                                      <label for="ford" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/FORD.png" alt="marque ford" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">FORD</span>
                                      </label>
                                    </div>
  
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque" v-model="marque" type="radio" value="CITROEN"
                                        id="citroen" name="marque_model_mobile" class="field-input">
                                      <label for="citroen" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/CITROEN.png" alt="marque citroen" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">CITROEN</span>
                                      </label>
                                    </div>
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque" v-model="marque" type="radio" value="DACIA"
                                        id="dacia" name="marque_model_mobile" class="field-input">
                                      <label for="dacia" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/DACIA.png" alt="marque dacia" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">DACIA</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div class="justify-content-center row mt-3">
                                  <div class="field-radio field-radio-center mr-4 ml-4">
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque" v-model="marque" type="radio"
                                        value="MITSUBISHI" id="mitsubishi" name="marque_model_mobile" class="field-input">
                                      <label for="mitsubishi" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/MITSUBISHI.png" alt="marque mitsubishi" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">MITSUBISHI</span>
                                      </label>
                                    </div>
  
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque" v-model="marque" type="radio" value="MERCEDES"
                                        id="mercedes" name="marque_model_mobile" class="field-input">
                                      <label for="mercedes" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/MERCEDES.png" alt="marque mercedes" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">MERCEDES</span>
                                      </label>
                                    </div>
  
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque" v-model="marque" type="radio" value="JEEP"
                                        id="jeep" name="marque_model_mobile" class="field-input">
                                      <label for="jeep" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/JEEP.png" alt="marque jeep" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">JEEP</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div class="justify-content-center row mt-3 mb-3">
                                  <div class="field-radio field-radio-center mr-4 ml-4">
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque" v-model="marque" type="radio" value="NISSAN"
                                        id="nissan" name="marque_model_mobile" class="field-input">
                                      <label for="nissan" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/NISSAN.png" alt="marque nissan" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">NISSAN</span>
                                      </label>
                                    </div>
  
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque" v-model="marque" type="radio" value="OPEL"
                                        id="opel" name="marque_model_mobile" class="field-input">
                                      <label for="opel" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/OPEL.png" alt="marque opel" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">OPEL</span>
                                      </label>
                                    </div>
  
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque" v-model="marque" type="radio" value="PEUGEOT"
                                        id="peugeot" name="marque_model_mobile" class="field-input">
                                      <label for="peugeot" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/PEUGEOT.png" alt="marque peugeot" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">PEUGEOT</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
  
                                <div class="justify-content-center row mt-3 mb-3">
                                  <div class="field-radio field-radio-center mr-4 ml-4">
  
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque" v-model="marque" type="radio" value="RENAULT"
                                        id="renault" name="marque_model_mobile" class="field-input">
                                      <label for="renault" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/RENAULT.png" alt="marque renault" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">RENAULT</span>
                                      </label>
                                    </div>
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque" v-model="marque" type="radio" value="SUZUKI"
                                        id="suzuki" name="marque_model_mobile" class="field-input">
                                      <label for="suzuki" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/SUZUKI.png" alt="marque suzuki" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">SUZUKI</span>
                                      </label>
                                    </div>
  
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque" v-model="marque" type="radio" value="TOYOTA"
                                        id="toyota" name="marque_model_mobile" class="field-input">
                                      <label for="toyota" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/TOYOTA.png" alt="marque toyota" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">TOYOTA</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div class="justify-content-center row mt-3 mb-3">
                                  <div class="field-radio field-radio-center mr-4 ml-4">
                                    <div class="btn-choice">
                                      <input @change="onChangeSelectedMarque" v-model="marque" type="radio"
                                        value="VOLKSWAGEN" id="volkswagen" name="marque_model_mobile" class="field-input">
                                      <label for="volkswagen" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/VOLKSWAGEN.png" alt="marque volkswagen" height="50">
                                        <span class="font-weight-bold" style="font-size: 8px">VOLKSWAGEN</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
  
                                <div class="justify-content-center row">
                                  <div class="col-lg-12 text-center"><button type="button" @click="showMarque()"
                                      class="btn btn-loan btn-add-loan">
                                      {{ $t('devis.devis_auto.bouton_autre_label') }} <i class="fas fa-arrow-down"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
  
                              <div class="fields">
                                <div class="field-title" v-show="showMarqueSelect">{{
                                  $t('devis.devis_auto.marque_model_title') }}&nbsp;:</div>
                                <div class="justify-content-center row" v-if="categorie != '2_roues'">
                                  <div class="col-sm-6" v-show="showMarqueSelect">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="Stepper20" class="field-label">{{ $t('devis.devis_auto.marque') }}</label>
                                      <v-overflow-btn flat v-model="marque" :items="listeMarque" editable id="Stepper20"
                                        item-text="Marque" item-value="Marque" @change="onChangeSelectedMarque"
                                        style="width: 100%;height: 65px;padding: 8px;line-height: 1;font-size: 1.6rem;background-color: #fff;border: 1px solid #d9dee3;border-radius: 12px;"></v-overflow-btn>
                                    </div>
                                  </div>
                                  <div class="col-sm-6" v-show="marque" v-if="marque">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="Stepper21" class="field-label">{{ $t('devis.devis_auto.model') }}</label>
                                      <v-overflow-btn flat v-model="model" :items="listeModeles" editable item-text="Type"
                                        id="Stepper21" item-value="Type" @change="onChangeSelectedModele"
                                        style="width: 100%;height: 65px;padding: 8px;line-height: 1;font-size: 1.6rem;background-color: #fff;border: 1px solid #d9dee3;border-radius: 12px;"></v-overflow-btn>
                                    </div>
                                  </div>
                                </div>
  
                                <div class="row" v-if="categorie == '2_roues'">
                                  <div class="col-sm-6" v-show="showMarque2roueSelect">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="Stepper22" class="field-label">{{ $t('devis.devis_auto.marque') }}</label>
                                      <v-overflow-btn flat v-model="marque" :items="listeMarque2roues" editable
                                        item-text="Marque" id="Stepper22" item-value="Marque"
                                        @change="onChangeSelectedMarque2roues"
                                        style="width: 100%;height: 65px;padding: 8px;line-height: 1;font-size: 1.6rem;background-color: #fff;border: 1px solid #d9dee3;border-radius: 12px;"></v-overflow-btn>
                                    </div>
                                  </div>
                                  <div class="col-sm-6" v-show="marque" v-if="marque">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="Stepper23" class="field-label">{{ $t('devis.devis_auto.model') }}</label>
                                      <v-overflow-btn flat v-model="model" :items="listeModeles2roues" editable
                                        item-text="Type" id="Stepper23" item-value="Type"
                                        @change="onChangeSelectedModele2roues"
                                        style="width: 100%;height: 65px;padding: 8px;line-height: 1;font-size: 1.6rem;background-color: #fff;border: 1px solid #d9dee3;border-radius: 12px;"></v-overflow-btn>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="wizard-card-footer clearfix">
                        <div class="wizard-footer-left">
                          <button @click="BacktoSecondStep()" type="button" class="wizard-btn">
                            <span class="fas fa-arrow-left"></span>
                            {{ $t('devis.devis_auto.bouton_retour') }}
                          </button>
                        </div>
                        <div class="wizard-footer-right">
                          <button @click="Stepper3Validator()" type="button" class="wizard-btn">
                            {{ $t('devis.devis_auto.bouton_suivant') }}
                          </button>
                        </div>
                      </div>
                    </div>
  
                    <div class="page" v-show="step === 4" v-if="categorie !== '2_roues'">
                      <div class="wizard-tab-content">
                        <div role="tabpanel" id="Step8_mobile" aria-hidden="true" aria-labelledby="step-Step8_mobile"
                          class="wizard-tab-container">
                          <div>
                            <div class="loan-group loan-group-0">
                              <div class="fields">
                                <div class="field-title">{{ $t('devis.devis_auto.detail_vehicule_title') }}&nbsp;:</div>
                                <div class="row">
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="Stepper24_mobile" class="field-label">{{
                                        $t('devis.devis_auto.puissance_fiscale') }}</label>
                                      <select @change="checkPuissanceFiscale(force)" v-model="force" id="Stepper24_mobile" name="Step8_mobile"
                                        class="field-select">
                                        <option v-for="item in PuissanceFinscaleItems" :key="item" :value="item">{{ item }}
                                        </option>
                                      </select>
                                      <p v-if="forceFiscaleValue > 24 ">Puissance fiscale renseignée : <span class="font-weight-bold">{{ forceFiscaleValue }}</span></p>
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default">
                                      <label for="Stepper25_mobile" class="field-label">
                                        {{ $t('devis.devis_auto.date_mis_en_circule') }}
                                        <!---->
                                      </label>
                                      <div class="input-group value-loan">
                                        <date-picker :editable="false" :disabled-date="disabledBeforeToday"
                                          class="field-input mb-1 mt-1" placeholder="Cliquer ici" id="Stepper25_mobile"
                                          @change="yearsDiff()" v-model="dateCircule" valueType="format" format="YYYY-MM-DD"
                                          lang="fr-fr"></date-picker>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mt-3">
                                      <label for="Stepper26_mobile" class="field-label">{{ $t('devis.devis_auto.nbre_place')
                                      }}
                                      </label>
                                      <select v-model="nbplace" id="Stepper26_mobile" name="Step8_mobile"
                                        class="field-select">
                                        <option v-for="item in items" :key="item" :value="item">{{ item }}</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="fields">
                                <div class="field-title">{{ $t('devis.devis_auto.valeur_immatricule_title') }}&nbsp;:</div>
                                <div class="row">
                                  <div class="col-sm-4" v-if="categorie !== '2_roues'">
                                    <div class="field-group field-default">
                                      <label for="Stepper27_mobile" class="field-label">
                                        {{ $t('devis.devis_auto.valeur_actuelle') }}
                                        <!---->
                                      </label>
                                      <div class="input-group value-loan">
                                        <input v-money="money" maxlength="11" v-model="valeur_venale" id="Stepper27_mobile"
                                          name="Step8_mobile" class="field-input">
                                        <div class="input-group-append">
                                          <div class="input-group-text">FCFA</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mt-3 mb-4 mb-sm-0">
                                      <label for="Stepper28_mobile" class="field-label">{{
                                        $t('devis.devis_auto.immatriculation') }}</label>
                                      <input maxlength="10" @input="validateImmatriculation" v-model="immatriculation"
                                        placeholder="Votre plaque" id="Stepper28_mobile" name="Step8_mobile"
                                        class="field-input">
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="Stepper38_mobile" class="field-label">{{
                                        $t('devis.devis_auto.numero_chassis') }}</label>
                                      <input maxlength="17" @input="validateNumeroChassis" v-model="numeroChassis"
                                        placeholder="Votre numéro de châssis" id="Stepper38_mobile" name="Step8_mobile"
                                        class="field-input">
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="wizard-card-footer clearfix">
                        <div class="wizard-footer-left">
                          <button @click="BacktoThirstStep()" type="button" class="wizard-btn">
                            <span class="fas fa-arrow-left"></span>
                            {{ $t('devis.devis_auto.bouton_retour') }}
                          </button>
                        </div>
                        <div class="wizard-footer-right">
                          <button @click="Stepper4Validator()" type="button" class="wizard-btn">
                            {{ $t('devis.devis_auto.bouton_suivant') }}
                          </button>
                        </div>
                        <!---->
                      </div>
                    </div>
  
                    <div class="page" v-show="step === 4" v-if="categorie == '2_roues'">
                      <div class="wizard-tab-content">
                        <div role="tabpanel" id="Step8_mobile" aria-hidden="true" aria-labelledby="step-Step8_mobile"
                          class="wizard-tab-container">
                          <div>
                            <div class="loan-group loan-group-0">
                              <div class="fields">
                                <div class="field-title">{{ $t('devis.devis_auto.immatriculation') }}&nbsp;:</div>
                                <div class="row">
                                  <div class="col-sm-6">
                                    <div class="field-group field-default">
                                      <label for="Stepper25_mobile" class="field-label">
                                        {{ $t('devis.devis_auto.date_mis_en_circule') }}
                                        <!---->
                                      </label>
                                      <div class="input-group value-loan">
                                        <date-picker :editable="false" :disabled-date="disabledBeforeToday"
                                          class="field-input mb-1 mt-1" placeholder="Cliquer ici" id="Stepper25_mobile"
                                          @change="yearsDiff()" v-model="dateCircule" valueType="format" format="YYYY-MM-DD"
                                          lang="fr-fr"></date-picker>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-sm-6">
                                    <div class="field-group field-default mt-3 mb-4 mb-sm-0">
                                      <label for="Stepper28_mobile" class="field-label">{{
                                        $t('devis.devis_auto.immatriculation') }}</label>
                                      <input maxlength="10" @input="validateImmatriculation" v-model="immatriculation"
                                        placeholder="Votre plaque" id="Stepper28_mobile" name="Step8_mobile"
                                        class="field-input">
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="wizard-card-footer clearfix">
                        <div class="wizard-footer-left">
                          <button @click="BacktoThirstStep()" type="button" class="wizard-btn">
                            <span class="fas fa-arrow-left"></span>
                            {{ $t('devis.devis_auto.bouton_retour') }}
                          </button>
                        </div>
                        <div class="wizard-footer-right">
                          <button @click="Stepper4Validator()" type="button" class="wizard-btn">
                            {{ $t('devis.devis_auto.bouton_suivant') }}
                          </button>
                        </div>
                        <!---->
                      </div>
                    </div>
  
                    <div class="page" v-show="step === 5">
                      <div class="wizard-tab-content">
                        <div role="tabpanel" id="Step9_mobile" aria-hidden="true" aria-labelledby="step-Step9_mobile"
                          class="wizard-tab-container">
                          <div>
                            <div class="fields">
                              <div class="row">
                                <div class="col-sm-12">
                                  <div class="col-sm-12 field-radio field-radio-center" v-show="showOffre">
                                    <div class="btn-choice" v-if="categorie !== '2_roues'">
                                      <input v-model="offre" type="radio" value="offre_pack" id="pack_mobile"
                                        name="offre_mobile" class="field-input" @change="show_offre">
                                      <label for="pack_mobile" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/pack.png" alt="pack" width="50">{{ $t('devis.devis_auto.pack')
                                        }}</label>
                                    </div>
                                    <div class="btn-choice">
                                      <input v-model="offre" type="radio" value="offre_carte" id="carte_mobile"
                                        name="offre_mobile" class="field-input" @change="show_offre">
                                      <label for="carte_mobile" class="field-label btn-choice-hide-dot">
                                        <img src="../../assets/img/icones/carte.png" alt="carte" width="50">{{ $t('devis.devis_auto.carte')
                                        }}</label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="fields" v-show="offre_pack" v-if="categorie !== '2_roues'">
                              <div class="field-title mb-0">
                                {{ $t('devis.devis_auto.liste_pack_title') }}&nbsp;:
                              </div>
                              <p class="field-sub-title mb-5">{{ $t('devis.devis_auto.liste_pack_substitle') }}</p>
                                  <!-- ===========================================A Dynamiser =============================================== -->
                          <div class="field-group row field-bank">
                            <div v-for="(i,x) in filteredGaranties" :key="x" class="btn-choice col-sm-3 col-12 tool" :data-tip="$t(i.tooltip_content)" tabindex="1" :class="{ disabled: age > 5 && i.id === 'pack_full_tous_risques' }">
                              <input type="radio" v-model="SelectedPack" :value="i" :id="i.id" name="Step09" class="field-input" @change="showGaranties">
                              <label :for="i.id" class="field-label">
                                <h3 class="mt-3 text-center">
                                  <span>{{ $t(i.packname) }}</span>
                                </h3>
                              </label>
                            </div>
                          </div>
                           <!-- ===========================================Fin A Dynamiser =============================================== -->
                            </div>
  
                            <div class="fields" v-show="offre_carte">
                              <div class="field-title mb-0">
                                {{ $t('devis.devis_auto.liste_garantie_title') }}&nbsp;:
                              </div>
                              <p class="field-sub-title mb-5">{{ $t('devis.devis_auto.liste_garantie_substitle') }}</p>
                              <div class="field-group row field-bank" v-show="categorie != '2_roues'">
                                <div class="btn-choice sm-no-change col-sm-6">
                                  <input type="checkbox" v-model="garanties" value="RESPONSABILITE CIVILE" id="rc_mobile"
                                    name="Step9_mobile" class="field-input">
                                  <label for="rc_mobile" class="field-label">
                                    <h5 class="mt-3 text-center">{{ $t('devis.devis_auto.rc') }}</h5>
                                  </label>
                                </div>
                                <div class="btn-choice sm-no-change col-sm-6">
                                  <input type="checkbox" v-model="garanties" value="VOL" id="vol_mobile" name="Step9_mobile"
                                    class="field-input">
                                  <label for="vol_mobile" class="field-label">
                                    <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.vol') }}</h3>
                                  </label>
                                </div>
                                <div class="btn-choice sm-no-change col-sm-6">
                                  <input type="checkbox" v-model="garanties" value="DEFENSE ET RECOURS"
                                    id="defense_recours_mobile" name="Step9_mobile" class="field-input">
                                  <label for="defense_recours_mobile" class="field-label">
                                    <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.defense_recours') }}</h3>
                                  </label>
                                </div>
                                <div class="btn-choice sm-no-change col-sm-6">
                                  <input type="checkbox" v-model="garanties" value="INCENDIE" id="incendie_mobile"
                                    name="Step9_mobile" class="field-input">
                                  <label for="incendie_mobile" class="field-label">
                                    <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.incendie') }}</h3>
                                  </label>
                                </div>
                                <div class="btn-choice sm-no-change col-sm-6">
                                  <input type="checkbox" v-model="garanties" value="PERSONNES TRANSPORTEES"
                                    id="Personnes_Transportees_mobile" name="Step9_mobile" class="field-input"
                                    @change="PersoTransporteModalFunction">
                                  <label for="Personnes_Transportees_mobile" class="field-label">
                                    <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.personnes_transportee') }}</h3>
                                  </label>
                                </div>
                                <div class="btn-choice sm-no-change col-sm-6">
                                  <input type="checkbox" v-model="garanties" value="AVANCE SUR RECOURS"
                                    id="avance_sur_recours_mobile" name="Step9_mobile" class="field-input"
                                    @change="AvRecModalFunction">
                                  <label for="avance_sur_recours_mobile" class="field-label">
                                    <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.avance_sur_recours') }}</h3>
                                  </label>
                                </div>
                                <div class="btn-choice sm-no-change col-sm-6">
                                  <input type="checkbox" v-model="garanties" value="BRIS DE GLACES"
                                    id="bris_de_glace_mobile" name="Step9_mobile" class="field-input">
                                  <label for="bris_de_glace_mobile" class="field-label">
                                    <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.bris_de_glaces') }}</h3>
                                  </label>
                                </div>
                                <div class="btn-choice sm-no-change col-sm-6" v-if="annee <= 5">
                                  <input type="checkbox" v-model="garanties" value="TIERCE COMPLETE"
                                    id="tierce_complete_mobile" name="Step9_mobile" class="field-input"
                                    @change="tierceControl">
                                  <label for="tierce_complete_mobile" class="field-label">
                                    <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.tierce_complete') }}</h3>
                                  </label>
                                </div>
                                <div class="btn-choice sm-no-change col-sm-6" v-if="annee <= 5">
                                  <input type="checkbox" v-model="garanties" value="TIERCE COLLISION"
                                    id="tierce_colision_mobile" name="Step9_mobile" class="field-input"
                                    @change="tierceControl">
                                  <label for="tierce_colision_mobile" class="field-label">
                                    <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.tierce_collision') }}</h3>
                                  </label>
                                </div>
                                <div class="btn-choice sm-no-change col-sm-6" v-if="annee <= 5">
                                  <input type="checkbox" v-model="garanties" value="TIERCE PLAFONNEE"
                                    id="tierce_plafonné_mobile" name="Step9_mobile" class="field-input"
                                    @change="tierceControl" disabled>
                                  <label for="tierce_plafonné_mobile" class="field-label">
                                    <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.tierce_plafonne') }}</h3>
                                  </label>
                                </div>
                              </div>
  
                              <div class="field-group row field-bank" v-show="categorie == '2_roues'">
                                <div class="btn-choice sm-no-change col-sm-6">
                                  <input type="checkbox" v-model="garanties" value="RESPONSABILITE CIVILE"
                                    id="garanties_11_mobile" name="Step9_mobile" class="field-input">
                                  <label for="garanties_11_mobile" class="field-label">
                                    <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.rc') }}</h3>
                                  </label>
                                </div>
                                <div class="btn-choice sm-no-change col-sm-6">
                                  <input type="checkbox" v-model="garanties" value="PERSONNES TRANSPORTEES"
                                    id="garanties_12_mobile" name="Step9_mobile" class="field-input"
                                    @change="PersoTransporteModalFunction">
                                  <label for="garanties_12_mobile" class="field-label">
                                    <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.personnes_transportee') }}</h3>
                                  </label>
                                </div>
                                <div class="btn-choice sm-no-change col-sm-6">
                                  <input type="checkbox" v-model="garanties" value="DEFENSE ET RECOURS"
                                    id="garanties_13_mobile" name="Step9_mobile" class="field-input">
                                  <label for="garanties_13_mobile" class="field-label">
                                    <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.defense_recours') }}</h3>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="wizard-tab-content" v-if="categorie !== '2_roues' && SelectedPack!=null">
                        <div role="tabpanel" id="text_pack_Standart_mobile" aria-hidden="true"
                          aria-labelledby="step-text_pack_Standart_mobile" class="wizard-tab-container">
                          <div>
                            <div class="fields" v-if="SelectedPack.pack_content">
                              <div class="field-title mb-0">
                                {{ $t(SelectedPack.packname) }}
                              </div>
                              <p class="field-sub-title mb-5">{{ $t(SelectedPack.pack_content[0]) }}
                                <br> <span class="font-weight-bold">{{ $t(SelectedPack.pack_content[1]) }}</span>
                            <br>
                            <span>
                                {{ $t(SelectedPack.pack_content[2]) }} 
                                <span class="font-weight-bold" style="color:#ffa409">
                                    {{ $t(SelectedPack.pack_content[3]) }}
                                </span>
                            </span>
                            <br>
                            <span>
                                {{ $t(SelectedPack.pack_content[4]) }} 
                                <span class="font-weight-bold" style="color:#ffa409">
                                    {{ $t(SelectedPack.pack_content[5])}}
                                </span>
                            </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
  
  
                      <div class="wizard-tab-content" v-show="text_packStandart" v-if="categorie !== '2_roues'">
                        <div role="tabpanel" id="text_pack_Standart_mobile" aria-hidden="true"
                          aria-labelledby="step-text_pack_Standart_mobile" class="wizard-tab-container">
                          <div>
                            <div class="fields">
                              <div class="field-title mb-0">
                                {{ $t('devis.devis_auto.pack_standard') }}
                              </div>
                              <p class="field-sub-title mb-5">{{ $t('devis.devis_auto.pack_standard_content[0]') }}
                                <br> <span class="font-weight-bold">{{ $t('devis.devis_auto.pack_standard_content[1]')
                                }}</span><br>
                                <span>{{ $t('devis.devis_auto.pack_standard_content[2]') }} <span class="font-weight-bold"
                                    style="color:#ffa409">{{ $t('devis.devis_auto.pack_standard_content[3]')
                                    }}</span></span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="wizard-tab-content" v-show="text_packInter" v-if="categorie !== '2_roues'">
                        <div role="tabpanel" id="text_pack_Inter_mobile" aria-hidden="true"
                          aria-labelledby="step-text_pack_Inter_mobile" class="wizard-tab-container">
                          <div>
                            <div class="fields">
                              <div class="field-title mb-0">
                                {{ $t('devis.devis_auto.pack_intermediaire') }}
                              </div>
                              <p class="field-sub-title mb-5">{{ $t('devis.devis_auto.pack_intermediaire_content[0]') }}
                                <br> <span class="font-weight-bold">{{ $t('devis.devis_auto.pack_intermediaire_content[1]')
                                }}</span><br>
                                <span>{{ $t('devis.devis_auto.pack_intermediaire_content[2]') }} <span
                                    class="font-weight-bold" style="color:#ffa409">{{
                                      $t('devis.devis_auto.pack_intermediaire_content[3]') }}</span></span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="wizard-tab-content" v-show="text_packAvance" v-if="categorie !== '2_roues'">
                        <div role="tabpanel" id="text_pack_Avance_mobile" aria-hidden="true"
                          aria-labelledby="step-text_pack_Avance_mobile" class="wizard-tab-container">
                          <div>
                            <div class="fields">
                              <div class="field-title mb-0">
                                {{ $t('devis.devis_auto.pack_avance') }}
                              </div>
                              <p class="field-sub-title mb-5">{{ $t('devis.devis_auto.pack_avance_content[0]') }}
                                <br> <span class="font-weight-bold">{{ $t('devis.devis_auto.pack_avance_content[0]')
                                }}</span><br>
                                <span>Option P.T : <span class="font-weight-bold" style="color:#ffa409">{{
                                  $t('devis.devis_auto.pack_avance_content[3]') }}</span></span> <br>
                                <span>{{ $t('devis.devis_auto.pack_avance_content[4]') }} <span class="font-weight-bold"
                                    style="color:#ffa409">{{ $t('devis.devis_auto.pack_avance_content[5]') }}</span></span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="wizard-tab-content" v-show="text_packFull_1">
                        <div role="tabpanel" id="text_pack_full_1" aria-hidden="true"
                          aria-labelledby="step-text_pack_full_1" class="wizard-tab-container">
                          <div>
                            <div class="fields">
                              <div class="field-title mb-0">
                                {{ $t('devis.devis_auto.pack_full_tous_risques') }}
                              </div>
                              <p class="field-sub-title mb-5">{{ $t('devis.devis_auto.pack_full_tous_risques_content[0]') }}
                                <br> <span class="font-weight-bold">{{
                                  $t('devis.devis_auto.pack_full_tous_risques_content[0]') }}</span><br>
                                <span>Option P.T : <span class="font-weight-bold" style="color:#ffa409">{{
                                  $t('devis.devis_auto.pack_full_tous_risques_content[2]') }}</span></span> <br>
                                <span>Choix Capital A.R : <span class="font-weight-bold" style="color:#ffa409">{{
                                  $t('devis.devis_auto.pack_full_tous_risques_content[4]') }}</span></span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="wizard-tab-content" v-show="text_packFull_2">
                        <div role="tabpanel" id="text_pack_full_2" aria-hidden="true"
                          aria-labelledby="step-text_pack_full_2" class="wizard-tab-container">
                          <div>
                            <div class="fields">
                              <div class="field-title mb-0">
                                {{ $t('devis.devis_auto.pack_full_collision') }}
                              </div>
                              <p class="field-sub-title mb-5">{{ $t('devis.devis_auto.pack_full_collision_content[0]') }}
                                <br> <span class="font-weight-bold">{{ $t('devis.devis_auto.pack_full_collision_content[1]')
                                }}</span><br>
                                <span>Option P.T : <span class="font-weight-bold" style="color:#ffa409">{{
                                  $t('devis.devis_auto.pack_full_collision_content[3]') }}</span></span> <br>
                                <span>Choix Capital A.R : <span class="font-weight-bold" style="color:#ffa409">{{
                                  $t('devis.devis_auto.pack_full_collision_content[5]') }}</span></span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="wizard-tab-content" v-show="text_packFull_3">
                        <div role="tabpanel" id="text_pack_full_3" aria-hidden="true"
                          aria-labelledby="step-text_pack_full_3" class="wizard-tab-container">
                          <div>
                            <div class="fields">
                              <div class="field-title mb-0">
                                Pack Full 3
                              </div>
                              <p class="field-sub-title mb-5">Ce pack comprend les garanties suivantes :
                                <br> <span class="font-weight-bold">RESPONSABILITE CIVILE, PERSONNES TRANSPORTEES, DEFENSE
                                  ET RECOURS, BRIS DE GLACES, VOL, INCENDIE, AVANCE SUR RECOURS</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="wizard-card-footer clearfix">
                        <div class="wizard-footer-left">
                          <button @click="BacktoFourStep()" type="button" class="wizard-btn">
                            <span class="fas fa-arrow-left"></span>
                            {{ $t('devis.devis_auto.bouton_retour') }}
                          </button>
                        </div>
                        <div class="wizard-footer-right">
                          <button v-show="nbAutoAdded < nombreVehicules" @click="ListAutoCreate()" type="button"
                            class="wizard-btn mr-2" style="background:green;border: 2px solid green">
                            {{ $t('devis.devis_auto.bouton_ajouter') }} ({{ nbAutoAdded }} / {{ nombreVehicules }})
                          </button>
                          <button :disabled="suivant" v-show="nbAutoAdded == nombreVehicules || flotte_mono == 'mono'"
                            @click="createTable()" type="button" class="wizard-btn">
                            {{ $t('devis.devis_auto.bouton_suivant') }}
                          </button>
                        </div>
                        <!---->
                      </div>
  
                    </div>
  
                    <div class="page review_page" v-show="step === 6">
                      <div class="wizard-tab-content">
                        <div role="tabpanel" id="Step10_mobile" aria-hidden="true" aria-labelledby="step-Step10_mobile"
                          class="wizard-tab-container">
                          <div>
                            <div class="justify-content-center row field-title" style="color:#ffa409">
                              {{ $t('devis.devis_auto.recap_title') }}
                            </div>
                            <div class="field-title">
                              {{ $t('devis.devis_auto.vehicule_enregistre') }}&nbsp;:
                            </div>
                            <div class="fields" v-for="(item, index) in ListAuto" :key="index">
                              <div class="field-group row align-items-center">
                                <div class="col-lg-4"><label for="Stepper29_mobile" class="field-label">{{
                                  $t('devis.devis_auto.vehicule_enregistre_content[0]') }}</label></div>
                                <div class="col-lg-8 field-default">
                                  <input disabled type="text" id="Stepper29_mobile" name="Step10_mobile"
                                    :value="item.marque" class="field-input pac-target-input">
                                  <div class="field-error">
                                    <!---->
                                  </div>
                                </div>
                              </div>
                              <div class="field-group row align-items-center">
                                <div class="col-lg-4"><label for="Stepper30_mobile" class="field-label">{{
                                  $t('devis.devis_auto.vehicule_enregistre_content[1]') }}</label></div>
                                <div class="col-lg-8 field-default">
                                  <input disabled type="text" id="Stepper30_mobile" name="Step10_mobile" :value="item.model"
                                    class="field-input pac-target-input">
                                  <div class="field-error">
                                    <!---->
                                  </div>
                                </div>
                              </div>
                              <div class="field-group row align-items-center">
                                <div class="col-lg-4"><label for="Stepper31_mobile" class="field-label">{{
                                  $t('devis.devis_auto.vehicule_enregistre_content[2]') }}</label></div>
                                <div class="col-lg-8 field-default">
                                  <input disabled type="tel" id="Stepper31_mobile" name="Step10_mobile"
                                    :value="item.immatriculation" class="field-input">
                                  <div class="field-error">
                                    <!---->
                                  </div>
                                </div>
                              </div>
                              <div v-if="item.numeroChassis != null && item.numeroChassis != ''" class="field-group row align-items-center">
                                <div class="col-lg-4"><label for="Stepper31_mobile" class="field-label">{{
                                  $t('devis.devis_auto.vehicule_enregistre_content[3]') }}</label></div>
                                <div class="col-lg-8 field-default">
                                  <input disabled type="tel" id="Stepper31_mobile" name="Step10_mobile"
                                    :value="item.numeroChassis" class="field-input">
                                  <div class="field-error">
                                    <!---->
                                  </div>
                                </div>
                              </div>
                              <div class="field-group row align-items-center">
                                <div class="col-lg-4"><label for="Stepper32_mobile" class="field-label">{{
                                  $t('devis.devis_auto.vehicule_enregistre_content[4]') }}</label></div>
                                <div class="col-lg-8 field-default">
                                  <input disabled type="text" id="Stepper32_mobile" name="Step10_mobile"
                                    :value="item.categorie" class="field-input">
                                  <div class="field-error">
                                    <!---->
                                  </div>
                                </div>
                              </div>
                              <div class="field-group row align-items-center" v-if="item.categorie !== 'categorie 5'">
                                <div class="col-lg-4"><label for="Stepper33_mobile" class="field-label">{{
                                  $t('devis.devis_auto.vehicule_enregistre_content[5]') }}</label></div>
                                <div class="col-lg-8 field-default">
                                  <input disabled type="text" id="Stepper33_mobile" name="Step10_mobile" :value="item.force"
                                    class="field-input">
                                  <div class="field-error">
                                    <!---->
                                  </div>
                                </div>
                              </div>
                              <div class="field-group row align-items-center">
                                <div class="col-lg-4"><label for="Stepper34_mobile" class="field-label">{{
                                  $t('devis.devis_auto.vehicule_enregistre_content[6]') }}</label></div>
                                <div class="col-lg-8 field-default">
                                  <input disabled type="text" id="Stepper34_mobile" name="Step10_mobile"
                                    :value="DateFormater(item.dateCircule)" class="field-input">
                                  <div class="field-error">
                                    <!---->
                                  </div>
                                </div>
                              </div>

                              <div class="field-group row align-items-center" v-if="item.categorie == 'categorie 5'">
                                <div class="col-lg-4"><label for="Stepper34_mobile" class="field-label">{{
                                  $t('devis.devis_auto.vehicule_enregistre_content[16]') }}</label></div>
                                <div class="col-lg-8 field-default">
                                  <input disabled type="text" id="Stepper34_mobile" name="Step10_mobile"
                                    :value="item.volumetrie2_roues" class="field-input">
                                  <div class="field-error">
                                    <!---->
                                  </div>
                                </div>
                              </div>
                              <div class="field-group row align-items-center" v-if="item.categorie !== 'categorie 5'">
                                <div class="col-lg-4"><label for="Stepper35_mobile" class="field-label">{{
                                  $t('devis.devis_auto.vehicule_enregistre_content[7]') }}</label></div>
                                <div class="col-lg-8 field-default">
                                  <input disabled type="text" id="Stepper35_mobile" name="Step10_mobile"
                                    :value="item.valeur_venale" class="field-input">
                                  <div class="field-error">
                                    <!---->
                                  </div>
                                </div>
                              </div>
                              <div class="field-group row align-items-center" v-if="item.categorie !== 'categorie 5'">
                                <div class="col-lg-4"><label for="Stepper36_mobile" class="field-label">{{
                                  $t('devis.devis_auto.vehicule_enregistre_content[8]') }}</label></div>
                                <div class="col-lg-8 field-default">
                                  <input disabled type="text" id="Stepper36_mobile" name="Step10_mobile"
                                    :value="item.nbplace" class="field-input">
                                  <div class="field-error">
                                    <!---->
                                  </div>
                                </div>
                              </div>
                              <div class="field-group row align-items-center">
                                <div class="col-lg-4"><label for="Stepper37_mobile" class="field-label">{{
                                  $t('devis.devis_auto.vehicule_enregistre_content[9]') }}</label></div>
                                <div class="col-lg-8 field-default">
                                  <input style="margin-bottom:4px" v-for="garantie in item.garanties" :key="garantie"
                                    disabled type="text" id="Stepper37_mobile" name="Step10_mobile" :value="garantie"
                                    class="field-input">
                                </div>
                              </div>
                              <div class="wizard-card-footer clearfix">
                                <div class="wizard-footer-left">
                                </div>
                                <div class="wizard-footer-right">
                                  <button @click="editAuto(item)" type="button" class="wizard-btn">
                                    {{ $t('devis.devis_auto.bouton_modifier') }}
                                  </button>
                                  <button @click="AddGaranties(item)" type="button" class="mt-3 wizard-btn">
                                    {{ $t('devis.devis_auto.bouton_ajouter_garanties') }}
                                  </button>
                                </div>
                                <!---->
                              </div>
                            </div>
  
  
                            <div class="fields">
                              <div class="field-title">
                                {{ $t('devis.devis_auto.choix_assureurs') }}&nbsp;:
                              </div>

                              <!-- Grid moderne pour les assureurs -->
                              <div class="insurers-grid">
                                <!-- Bouton "Tous" -->
                                <div class="insurer-card all-insurers" :class="{ 'selected': selectAll }">
                                  <input v-model="selectAll" type="checkbox" id="tous_mobile" class="insurer-input">
                                  <label for="tous_mobile" class="insurer-label">
                                    <div class="insurer-icon">
                                      <img src="../../assets/img/icones/all.png" alt="Tous les assureurs" class="insurer-logo">
                                    </div>
                                    <div class="insurer-info">
                                      <h4 class="insurer-name">{{ $t('devis.devis_auto.bouton_tous') }}</h4>
                                      <span class="insurer-badge">Tous</span>
                                    </div>
                                    <div class="selection-indicator">
                                      <i class="fas fa-check"></i>
                                    </div>
                                  </label>
                                </div>

                                <!-- Cartes des assureurs -->
                                <div 
                                  class="insurer-card" 
                                  v-for="assure in listeAssureurs" 
                                  :key="assure._id"
                                  :class="{ 'selected': assureurs.includes(assure.societe) }"
                                >
                                  <input 
                                    v-model="assureurs" 
                                    type="checkbox" 
                                    :value="assure.societe" 
                                    :id="assure.societe"
                                    class="insurer-input"
                                  >
                                  <label :for="assure.societe" class="insurer-label">
                                    <div class="insurer-icon">
                                      <img :src="assure.logo" :alt="assure.societe" class="insurer-logo">
                                    </div>
                                    <div class="insurer-info">
                                      <h4 class="insurer-name">{{ assure.societe }}</h4>
                                      <span class="insurer-badge">Assureur</span>
                                    </div>
                                    <img v-if="assure.is_car_attestation_ready" class="lightning-box" src="../../assets/img/lightning.png" width="20" alt="lightning_logo">
                                    <div class="selection-indicator">
                                      <i class="fas fa-check"></i>
                                    </div>
                                  </label>
                                </div>
                              </div>

                              <!-- Résumé de la sélection -->
                              <div class="selection-summary" v-if="assureurs.length > 0">
                                <div class="summary-content">
                                  <i class="fas fa-info-circle"></i>
                                  <span>{{ assureurs.length }} {{ $t('devis.devis_auto.assureur_label') }}{{ assureurs.length > 1 ? 's' : '' }} {{ $t('devis.devis_auto.selectionne_label') }}{{ assureurs.length > 1 ? 's' : '' }}</span>
                                </div>
                              </div>

                              <!-- <div class="field-group row field-bank">
                                <div class="btn-choice col-sm-6 col-6">
                                  <input v-model="selectAll" type="checkbox" id="tous_mobile" class="field-input">
                                  <label for="tous_mobile" class="field-label" label="Tous">
                                    <img src="../../assets/img/icones/all.png" alt="Tous_mobile" height="60" width="60">
                                    <p class="field-title" style="margin-top:-12px;margin-bottom:-10px;color:#ffa409">{{
                                      $t('devis.devis_auto.bouton_tous') }}</p>
                                  </label>
                                </div>
                                <div class="btn-choice col-sm-6 col-6" v-for="assure in listeAssureurs" :key="assure._id">
                                  <input v-model="assureurs" type="checkbox" :value="assure.societe" :id="assure.societe"
                                    class="field-input">
                                  <label :for="assure.societe" class="field-label" :label="assure.societe">
                                      <span v-if="assure.is_car_attestation_ready">
                                        <img class="lightning-box" src="../../assets/img/lightning.png" width="20" alt="lightning_logo">
                                    </span>
                                    <img :src="assure.logo" alt="partenaire logo" height="50">
                                    <p class="field-title" style="margin-top:-3px;margin-bottom:-10px">
                                      {{ assure.societe }}</p>
                                  </label>
                                </div>
                              </div> -->
                            </div>
                          </div>
                        </div>
  
                        <div role="tabpanel" id="Step11_mobile" aria-hidden="true" aria-labelledby="step-Step11_mobile"
                          class="wizard-tab-container">
                          <div>
                            <div class="loan-group loan-group-0">
                              <div class="fields">
                                <div class="field-title">{{ $t('devis.devis_auto.periode_garantie_title') }}&nbsp;:</div>
                                <div class="row">
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="Stepper38_mobile" class="field-label">{{
                                        $t('devis.devis_auto.duree_garantie') }}
                                        <button type="button" tabindex="-1" title="" class="field-help"
                                          data-original-title="Taux d'intérêt"></button></label>
                                      <div class="input-group rate-loan">
                                        <select @change="dateDiff()" v-model="duree" id="Stepper24" name="Step8"
                                          class="field-select">
                                          <option v-for="item in DureeMois" :key="item" :value="item">{{ item }}</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
  
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="Stepper39_mobile" class="field-label">{{ $t('devis.devis_auto.date_effet')
                                      }}
                                        <button type="button" tabindex="-1" title="" class="field-help"
                                          data-original-title="Taux d'intérêt"></button></label>
                                      <div class="input-group rate-loan">
                                        <date-picker id="Stepper39_mobile" :disabled-date="disabledAfterToday"
                                          :editable="false" class="field-input mb-1 mt-1" placeholder="Cliquer ici"
                                          @change="dateDiff()" :min="new Date().toISOString().substr(0, 10)"
                                          v-model="dateEffet" valueType="format" format="YYYY-MM-DD"
                                          lang="fr-fr"></date-picker>
                                      </div>
                                    </div>
                                  </div>
  
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="Stepper40_mobile" class="field-label">{{
                                        $t('devis.devis_auto.date_echeance') }}
                                        <button type="button" tabindex="-1" title="" class="field-help"
                                          data-original-title="Taux d'intérêt"></button></label>
                                      <div class="input-group rate-loan">
                                        <input disabled placeholder="Date d'échéance" v-model="dateEcheance"
                                          id="Stepper40_mobile" name="Step11_mobile" class="field-input">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
  
                        <div role="tabpanel" id="Step12_mobile" aria-hidden="true" aria-labelledby="step-Step12_mobile"
                          class="wizard-tab-container">
                          <div>
                            <div class="loan-group loan-group-0">
                              <div class="fields">
                                <div class="field-title">{{ $t('devis.devis_auto.beneficiaire') }}&nbsp;:</div>
                                <div class="row">
                                  <div class="col-sm-4 mt-5">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <div class="field-checkbox">
                                        <div class="field-label">
                                          {{ $t('devis.devis_auto.idem_compte') }}
                                        </div>
                                        <div class="switch">
                                          <label for="Stepper41_mobile">
                                            <input @change="switchBenef()" v-model="switch1" type="checkbox"
                                              id="Stepper41_mobile" name="Step12_mobile">
                                            <span class="lever"></span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
  
                                  <div class="col-sm-6">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="Stepper42_mobile" class="field-label">{{ $t('devis.devis_auto.nom_carte_grise_label') }}
                                        <button type="button" tabindex="-1" title="" class="field-help"
                                          data-original-title="Taux d'intérêt"></button></label>
                                      <div class="input-group rate-loan">
                                        <input :disabled="disabledBenefInput" @click="dialogInfoBeneficiaire = true" :placeholder="$t('devis.devis_auto.nom_et_prenom')" v-model="proprietaire"
                                          id="Stepper42_mobile" name="Step12_mobile" class="field-input">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="wizard-card-footer clearfix">
                        <div class="wizard-footer-left">
                          <button @click="BacktoFiveStep()" type="button" class="wizard-btn">
                            <span class="fas fa-arrow-left"></span>
                            {{ $t('devis.devis_auto.bouton_retour') }}
                          </button>
                        </div>
                        <div class="wizard-footer-right">
                          <button :disabled="disabledButtonValidate" v-if="nbAutoAdded >= nombreVehicules"
                            @click="SendData()" type="button" class="wizard-btn">
                            {{ $t('devis.devis_auto.bouton_valider') }}
                          </button>
                        </div>
                        <!---->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!--    ==========================Modal for cars mobile ============================================ -->
      <v-dialog persistent v-model="ModalListeContrat" v-if="isMobile()" style="width:100%!important">
        <v-card tile class="border-radius policeLato">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="UserCarTable" aria-hidden="true" aria-labelledby="step-UserCarTable"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">{{ $t('devis.devis_auto.my_vehicule') }}&nbsp;:</div>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="col-sm-12">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <input v-model="searchCarDesktop" :placeholder="$t('devis.devis_auto.chercher')"
                                id="Stepper288" name="Step8" class="field-input">
                            </div>
                          </div>
  
                          <v-flex style="background-color: #FAFAFA!important;z-index:10000">
                            <v-data-table :headers="$t('devis.devis_auto.headerContratMobile')" :items="listCars"
                              :search="searchCarDesktop" class="border-radius mt-2 mb-5"
                              style="background-color: #FAFAFA!important">
                              <template slot="items" slot-scope="props">
                                <td @click="getCarForDevis(props.item)">{{ props.item.marque }}</td>
                                <td @click="getCarForDevis(props.item)">{{ props.item.immatriculation }}</td>
                                <td><v-btn small icon @click="deleteUserCar(props.item)">
                                        <img src="../../assets/img/devis/delete.png" width="45" alt="delete_button">
                                      </v-btn>
                                      <v-btn small icon @click="openEditVehicle(props.item)" title="Modifier le véhicule">
                                        <span class="fa fa-edit" style="color: #ffa409; font-size: 18px;"></span>
                                      </v-btn></td>
                              </template>
                            </v-data-table>
                          </v-flex>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="closePopupCar()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('devis.devis_auto.bouton_retour') }}
                </button>
              </div>
              <div class="wizard-footer-right">
              </div>
              <!---->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <!-- ========= DIALOG CAPITAL AVANCE RECOURS MOBILE============ -->
      <!-- ========= DIALOG CAPITAL AVANCE RECOURS MOBILE============ -->
      <v-dialog v-model="AvRec" persistent max-width="800px" v-if="isMobile()">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="choixAvanc_mobile" aria-hidden="true" aria-labelledby="step-choixAvanc_mobile"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title">{{ $t('devis.devis_auto.choix_capital_title_mobile') }}&nbsp;:</div>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="field-group row field-bank">
                            <div class="btn-choice col-sm-6">
                              <input v-model="capital_AvRec" type="radio" value="500000" id="Option_1_AV_mobile"
                                name="choixAvance_mobile" class="field-input">
                              <label for="Option_1_AV_mobile" class="field-label btn-choice-hide-dot">500 000 FCFA</label>
                            </div>
                            <div class="btn-choice col-sm-6">
                              <input v-model="capital_AvRec" type="radio" value="1000000" id="Option_2_AV_mobile"
                                name="choixAvance_mobile" class="field-input">
                              <label for="Option_2_AV_mobile" class="field-label btn-choice-hide-dot">1 000 000 FCFA</label>
                            </div>
                            <div class="btn-choice col-sm-6">
                              <input disabled v-model="capital_AvRec" type="radio" value="0" id="Option_3_AV_mobile"
                                name="choixAvance_mobile" class="field-input">
                              <label for="Option_3_AV_mobile" class="field-label btn-choice-hide-dot">{{
                                $t('devis.devis_auto.plus_million[0]') }} <span>{{ $t('devis.devis_auto.plus_million[1]')}}</span></label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="CloseModalAvRec()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('devis.devis_auto.bouton_retour') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="CheckCapitalAvRe()" type="button" class="wizard-btn">
                  {{ $t('devis.devis_auto.bouton_suivant') }}
                </button>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <!-- ========= DIALOG ADD_GARANTIE CAPITAL AVANCE RECOURS MOBILE============ -->
      <!-- ========= DIALOG ADD_GARANTIE CAPITAL AVANCE RECOURS MOBILE============ -->
      <v-dialog v-model="AvRecAddNew" persistent max-width="800px" v-if="isMobile() && CarToUpdate">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="choixAvanc_mobile" aria-hidden="true" aria-labelledby="step-choixAvanc_mobile"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title">{{ $t('devis.devis_auto.choix_capital_title_mobile') }}&nbsp;:</div>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="field-group row field-bank">
                            <div class="btn-choice col-sm-6">
                              <input v-model="CarToUpdate.capital_AvRec" type="radio" value="500000" id="Option_1_AV_mobile"
                                name="choixAvance_mobile" class="field-input">
                              <label for="Option_1_AV_mobile" class="field-label btn-choice-hide-dot">500 000 FCFA</label>
                            </div>
                            <div class="btn-choice col-sm-6">
                              <input v-model="CarToUpdate.capital_AvRec" type="radio" value="1000000"
                                id="Option_2_AV_mobile" name="choixAvance_mobile" class="field-input">
                              <label for="Option_2_AV_mobile" class="field-label btn-choice-hide-dot">1 000 000 FCFA</label>
                            </div>
                            <div class="btn-choice col-sm-6">
                              <input disabled v-model="CarToUpdate.capital_AvRec" type="radio" value="0"
                                id="Option_3_AV_mobile" name="choixAvance_mobile" class="field-input">
                              <label for="Option_3_AV_mobile" class="field-label btn-choice-hide-dot">{{
                                $t('devis.devis_auto.plus_million[0]') }} <span>{{ $t('devis.devis_auto.plus_million[1]')}}</span></label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="CloseModalAvRec()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('devis.devis_auto.bouton_retour') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="CheckCapitalAvRe()" type="button" class="wizard-btn">
                  {{ $t('devis.devis_auto.bouton_suivant') }}
                </button>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <!-- ========= DIALOG VALEUR A NEUF ============ -->
      <!-- ========= DIALOG VALEUR A NEUF ============ -->
      <v-dialog v-model="VNeuf" persistent max-width="600px">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="valeurNeuf" aria-hidden="true" aria-labelledby="step-valeurNeuf"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">{{ $t('devis.devis_auto.valeur_neuf_title') }}&nbsp;:</div>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="field-group field-default">
                            <label for="valeur_venale" class="field-label">
                              {{ $t('devis.devis_auto.valeur_neuf_title') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-money="money" maxlength="11" v-model="valeur" placeholder="Valeur à neuf"
                                id="valeur_venale" name="valeurNeuf" class="field-input">
                              <div class="input-group-append">
                                <div class="input-group-text">FCFA</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="CloseModalVNeuf()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('devis.devis_auto.bouton_retour') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="CheckValeurNeuf()" type="button" class="wizard-btn">
                  {{ $t('devis.devis_auto.bouton_valider') }}
                </button>
              </div>
              <!---->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  
     
      <!-- ========= DIALOG OPTION INDIVIDUEL ACCIDENT ============ -->
      <!-- ========= DIALOG OPTION INDIVIDUEL ACCIDENT ============ -->
      <v-dialog v-model="PersoTransporteModal" persistent max-width="600px" v-if="isMobile()">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="personTransporte_mobile" aria-hidden="true"
                aria-labelledby="step-personTransporte_mobile" class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">{{ $t('devis.devis_auto.option_transportee_mobile')
                      }}&nbsp;:</div>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="field-group row field-bank">
                            <div class="btn-choice col-sm-6">
                              <input v-model="optionPersoTrans" type="radio" value="option 1" id="Option_1_mobile"
                                name="personTransporte_mobile" class="field-input">
                              <label for="Option_1_mobile" class="field-label btn-choice-hide-dot">Option 1</label>
                            </div>
                            <div class="btn-choice col-sm-6">
                              <input v-model="optionPersoTrans" type="radio" value="option 2" id="Option_2_mobile"
                                name="personTransporte_mobile" class="field-input">
                              <label for="Option_2_mobile" class="field-label btn-choice-hide-dot">Option 2</label>
                            </div>
                            <div class="btn-choice col-sm-6">
                              <input v-model="optionPersoTrans" type="radio" value="option 3" id="Option_3_mobile"
                                name="personTransporte_mobile" class="field-input">
                              <label for="Option_3_mobile" class="field-label btn-choice-hide-dot">Option 3</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="fields">
                      <v-flex xs12 sm12 md6 lg6 pl-2 v-show="optionPersoTrans === 'option 1'">
                        <ul style="list-style:none">
                          <li>{{ $t('devis.devis_auto.option_transportee_liste[0]') }} : <span class="font-weight-bold"
                              style="color:#ffa409">1 000 000 FCFA</span></li>
                          <li>{{ $t('devis.devis_auto.option_transportee_liste[1]') }} : <span class="font-weight-bold"
                              style="color:#ffa409">1 000 000 FCFA</span></li>
                          <li>{{ $t('devis.devis_auto.option_transportee_liste[2]') }} : <span class="font-weight-bold"
                              style="color:#ffa409">100 000 FCFA</span></li>
                        </ul>
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6 pl-2 v-show="optionPersoTrans === 'option 2'">
                        <ul style="list-style:none">
                          <li>{{ $t('devis.devis_auto.option_transportee_liste[0]') }} : <span class="font-weight-bold"
                              style="color:#ffa409">2 000 000 FCFA</span></li>
                          <li>{{ $t('devis.devis_auto.option_transportee_liste[1]') }} : <span class="font-weight-bold"
                              style="color:#ffa409">2 000 000 FCFA</span></li>
                          <li>{{ $t('devis.devis_auto.option_transportee_liste[2]') }} : <span class="font-weight-bold"
                              style="color:#ffa409">200 000 FCFA</span></li>
                        </ul>
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6 pl-2 v-show="optionPersoTrans === 'option 3'">
                        <ul style="list-style:none">
                          <li>{{ $t('devis.devis_auto.option_transportee_liste[0]') }} : <span class="font-weight-bold"
                              style="color:#ffa409">3 000 000 FCFA</span></li>
                          <li>{{ $t('devis.devis_auto.option_transportee_liste[1]') }} : <span class="font-weight-bold"
                              style="color:#ffa409">3 000 000 FCFA</span></li>
                          <li>{{ $t('devis.devis_auto.option_transportee_liste[2]') }} : <span class="font-weight-bold"
                              style="color:#ffa409">300 000 FCFA</span></li>
                        </ul>
                      </v-flex>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="CloseModalOptionTrans()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('devis.devis_auto.bouton_retour') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="optionPersonneTransControl()" type="button" class="wizard-btn">
                  {{ $t('devis.devis_auto.bouton_suivant') }}
                </button>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <v-dialog v-model="Individuel_Accident_Modal" persistent max-width="600px">
        <v-card elevation="24" class="border-radius">
          <v-toolbar color="#ffa409">
            <v-toolbar-title class="text-white">
              {{ $t('devis.devis_auto.option_individuel_title') }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="Individuel_Accident_Modal = false" class="float-lg-right" style="color: #fff">
              <v-icon>&#xe5cd;</v-icon>
            </v-btn>
          </v-toolbar>
  
          <v-container grid-list-md>
            <v-radio-group class="answer" v-model="option_Individuel_Accident">
              <v-layout row>
                <v-flex xs3 sm3 md3 lg4>
                  <v-radio color="#ffa409" class="highlight" label="Option 1" value="option 1"></v-radio>
                </v-flex>
                <v-flex xs3 sm3 md3 lg4>
                  <v-radio color="#ffa409" class="highlight" label="Option 2" value="option 2"></v-radio>
                </v-flex>
                <v-flex xs3 sm3 md3 lg4>
                  <v-radio color="#ffa409" class="highlight" label="Option 3" value="option 3"></v-radio>
                </v-flex>
              </v-layout>
            </v-radio-group>
          </v-container>
          <v-card-actions border>
            <v-flex xs12 sm12 md6 lg6 pl-2 v-show="option_Individuel_Accident === 'option 1'">
              <ul style="list-style:none">
                <li>{{ $t('devis.devis_auto.option_transportee_liste[0]') }} : <span class="font-weight-bold"
                    style="color:#ffa409">1 000 000 FCFA</span></li>
                <li>{{ $t('devis.devis_auto.option_transportee_liste[1]') }} : <span class="font-weight-bold"
                    style="color:#ffa409">1 000 000 FCFA</span></li>
                <li>{{ $t('devis.devis_auto.option_transportee_liste[2]') }} : <span class="font-weight-bold"
                    style="color:#ffa409">100 000 FCFA</span></li>
              </ul>
            </v-flex>
            <v-flex xs12 sm12 md6 lg6 pl-2 v-show="option_Individuel_Accident === 'option 2'">
              <ul style="list-style:none">
                <li>{{ $t('devis.devis_auto.option_transportee_liste[0]') }} : <span class="font-weight-bold"
                    style="color:#ffa409">2 000 000 FCFA</span></li>
                <li>{{ $t('devis.devis_auto.option_transportee_liste[1]') }} : <span class="font-weight-bold"
                    style="color:#ffa409">2 000 000 FCFA</span></li>
                <li>{{ $t('devis.devis_auto.option_transportee_liste[2]') }} : <span class="font-weight-bold"
                    style="color:#ffa409">200 000 FCFA</span></li>
              </ul>
            </v-flex>
            <v-flex xs12 sm12 md6 lg6 pl-2 v-show="option_Individuel_Accident === 'option 3'">
              <ul style="list-style:none">
                <li>{{ $t('devis.devis_auto.option_transportee_liste[0]') }} : <span class="font-weight-bold"
                    style="color:#ffa409">3 000 000 FCFA</span></li>
                <li>{{ $t('devis.devis_auto.option_transportee_liste[1]') }} : <span class="font-weight-bold"
                    style="color:#ffa409">3 000 000 FCFA</span></li>
                <li>{{ $t('devis.devis_auto.option_transportee_liste[2]') }} : <span class="font-weight-bold"
                    style="color:#ffa409">300 000 FCFA</span></li>
              </ul>
            </v-flex>
            <v-spacer></v-spacer>
            <v-btn round color="#ffa409" class="font-weight-bold text-white" @click="Individuel_Accident_Modal = false">{{
              $t('devis.devis_auto.bouton_valider') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <!-- ========= DIALOG de modifications ============ -->
      <!-- ========= DIALOG de modifications ============ -->
      <v-dialog v-model="dialogEditItem" persistent max-width="80%">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="popupEditedInfo" aria-hidden="true" aria-labelledby="step-popupEditedInfo"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">{{ $t('devis.devis_auto.popup_modif_title') }}&nbsp;:</div>
                      <div class="row">
                        <div class="col-sm-4">
                          <div class="field-group field-default">
                            <label for="marque_edited" class="field-label">
                              {{ $t('devis.devis_auto.vehicule_enregistre_content[0]') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="editedItem.marque" id="marque_edited" name="Step4_edited" class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 mt-3">
                          <div class="field-group field-default">
                            <label for="model_edited" class="field-label">
                              {{ $t('devis.devis_auto.vehicule_enregistre_content[1]') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="editedItem.model" id="model_edited" name="Step4_edited" class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 mt-3">
                          <div class="field-group field-default">
                            <label for="imma_edited" class="field-label">
                              {{ $t('devis.devis_auto.vehicule_enregistre_content[2]') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input maxlength="10" @input="validateImmatriculation" v-model="editedItem.immatriculation" id="imma_edited" name="Step4_edited"
                                class="field-input">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
  
                    <div class="fields">
                      <div class="row">
                        <div class="col-sm-4">
                          <div class="field-group field-default">
                            <label for="force_edited" class="field-label">
                              {{ $t('devis.devis_auto.vehicule_enregistre_content[5]') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="editedItem.force" @keypress="onlyNumber" id="force_edited" name="Step4_edited" class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 mt-3">
                          <div class="field-group field-default">
                            <label for="age_edited" class="field-label">
                              {{ $t('devis.devis_auto.vehicule_enregistre_content[10]') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="editedItem.age" id="age_edited" name="Step4_edited" disabled
                                class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 mt-3">
                          <div class="field-group field-default">
                            <label for="valeur_neuf_edited" class="field-label">
                              {{ $t('devis.devis_auto.vehicule_enregistre_content[11]') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input :disabled="editedItem.categorie == 'categorie 5'" v-model="editedItem.valeur" @keypress="onlyNumber" maxlength="11" id="valeur_neuf_edited" name="Step4_edited"
                                class="field-input">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
  
                    <div class="fields">
                      <div class="row">
                        <div class="col-sm-4">
                          <div class="field-group field-default">
                            <label for="valeur_actuelle_edited" class="field-label">
                              {{ $t('devis.devis_auto.vehicule_enregistre_content[7]') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input :disabled="editedItem.categorie == 'categorie 5'" v-model="editedItem.valeur_venale" @keypress="onlyNumber" maxlength="11" id="valeur_actuelle_edited"
                                name="Step4_edited" class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 mt-3" v-if="categorie === '2_roues' && editedItem.volumetrie2_roues !== null">
                          <div class="field-group field-default">
                            <label for="volumetrie_edited" class="field-label">
                              {{ $t('devis.devis_auto.vehicule_enregistre_content[11]') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="editedItem.volumetrie2_roues" id="volumetrie_edited" name="Step4_edited"
                                disabled class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 mt-3" v-if="categorie === 'utilitaire' && editedItem.tonnage !== null">
                          <div class="field-group field-default">
                            <label for="tonnage_edited" class="field-label">
                              {{ $t('devis.devis_auto.vehicule_enregistre_content[12]') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="editedItem.tonnage" @keypress="onlyNumber" id="tonnage_edited" name="Step4_edited" disabled
                                class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 mt-3" v-if="categorie === 'utilitaire' && editedItem.optionUtilitaire !== null">
                          <div class="field-group field-default">
                            <label for="option_utilitaire_edited" class="field-label">
                              {{ $t('devis.devis_auto.vehicule_enregistre_content[15]') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="editedItem.optionUtilitaire" id="option_utilitaire_edited" name="Step4_edited"
                                disabled class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 mt-3">
                          <div class="field-group field-default">
                            <label for="categorie_edited" class="field-label">
                              {{ $t('devis.devis_auto.vehicule_enregistre_content[15]') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="editedItem.categorie" id="categorie_edited" name="Step4_edited" disabled
                                class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 mt-3">
                          <div class="field-group field-default">
                            <label for="carburation_edited" class="field-label">
                              {{ $t('devis.devis_auto.vehicule_enregistre_content[16]') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="editedItem.carburation" id="carburation_edited" name="Step4_edited" disabled
                                class="field-input">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="dialogEditItem = false" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('devis.devis_auto.bouton_retour') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="dialogEditItem = false" type="button" class="wizard-btn">
                  {{ $t('devis.devis_auto.bouton_valider') }}
                </button>
              </div>
              <!---->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- ========= DIALOG SI LA VOITURE N'EXISTE PAS DANS LA LISTE ============ -->
      <!-- ========= DIALOG SI LA VOITURE N'EXISTE PAS DANS LA LISTE ============ -->
      <v-dialog v-model="popupAutre" width="500" persistent>
        <!-- ========= DIALOG SI LA VOITURE N'EXISTE PAS DANS LA LISTE ============ -->
        <v-card elevation="24" class="border-radius" v-if="categorie != '2_roues'">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="Popup_autre" aria-hidden="true" aria-labelledby="step-Popup_autre"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">{{ $t('devis.devis_auto.saisir_marque_title') }}&nbsp;:
                      </div>
                      <div class="row">
                        <div class="col-sm-6" v-if="categorie !== '2_roues'">
                          <div class="field-group field-default">
                            <label for="autreMarque" class="field-label">
                              {{ $t('devis.devis_auto.marque') }}
                            </label>
                            <div class="input-group value-loan">
                              <input placeholder="Marque de votre véhicule" v-model="marque" id="autreMarque"
                                name="Popup_autre" class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="autreModel" class="field-label">{{ $t('devis.devis_auto.model') }}</label>
                            <input v-model="model" placeholder="Modèle de votre véhicule" id="autreModel" name="Popup_autre"
                              class="field-input">
                          </div>
                        </div>
                      </div>
                    </div>
  
                    <div class="wizard-card-footer clearfix">
                      <div class="wizard-footer-left">
                        <button @click="popupAutre = false" type="button" class="wizard-btn">
                          <span class="fas fa-arrow-left"></span>
                          {{ $t('devis.devis_auto.bouton_retour') }}
                        </button>
                      </div>
                      <div class="wizard-footer-right">
                        <button @click="validMarqueModel()" type="button" class="wizard-btn">
                          {{ $t('devis.devis_auto.bouton_valider') }}
                        </button>
                      </div>
                      <!---->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
  
        <!-- ========= DIALOG SI LE 2ROUES N'EXISTE PAS DANS LA LISTE ============ -->
        <v-card elevation="24" class="border-radius" v-if="categorie == '2_roues'">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="Popup_autre_2_roues" aria-hidden="true" aria-labelledby="step-Popup_autre_2_roues"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">{{ $t('devis.devis_auto.saisir_marque_title') }}&nbsp;:
                      </div>
                      <div class="row">
                        <div class="col-sm-4">
                          <div class="field-group field-default">
                            <label for="autreMarque_2_roues" class="field-label">
                              {{ $t('devis.devis_auto.marque') }}
                            </label>
                            <div class="input-group value-loan">
                              <input placeholder="Marque de votre véhicule" v-model="marque" id="autreMarque_2_roues"
                                name="Popup_autre_2_roues" class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="autreModel_2_roues" class="field-label">{{ $t('devis.devis_auto.model') }}</label>
                            <input v-model="model" placeholder="Modèle de votre véhicule" id="autreModel_2_roues"
                              name="Popup_autre_2_roues" class="field-input">
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="autreCylinde_2_roues" class="field-label">{{ $t('devis.devis_auto.cylindre')
                            }}</label>
                            <input type="number" v-model="cylindre" placeholder="Cylindree(cm3) du véhicule"
                              id="autreCylinde_2_roues" name="Popup_autre_2_roues" class="field-input">
                          </div>
                        </div>
                      </div>
                    </div>
  
                    <div class="wizard-card-footer clearfix">
                      <div class="wizard-footer-left">
                        <button @click="popupAutre = false" type="button" class="wizard-btn">
                          <span class="fas fa-arrow-left"></span>
                          {{ $t('devis.devis_auto.bouton_retour') }}
                        </button>
                      </div>
                      <div class="wizard-footer-right">
                        <button @click="validMarqueModel()" type="button" class="wizard-btn">
                          {{ $t('devis.devis_auto.bouton_valider') }}
                        </button>
                      </div>
                      <!---->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- ========= DIALOG POUR RAJOUT DE GARANTIES ============ -->
      <!-- ========= DIALOG POUR RAJOUT DE GARANTIES ============ -->
      <v-dialog v-model="popupAddGaranties" v-if="isMobile()">
        <v-card elevation="24" class="border-radius" v-if="CarToUpdate">
          <v-card-text>
            <div class="wizard-tab-content">
              <div role="tabpanel" id="Step9" aria-hidden="true" aria-labelledby="step-Step9" class="wizard-tab-container">
                <div>
                  <div class="fields">
                    <div class="field-title mb-0">
                      {{ $t('devis.devis_auto.liste_garantie_title') }}&nbsp;:
                    </div>
                    <p class="field-sub-title mb-5">{{ $t('devis.devis_auto.liste_garantie_substitle') }}</p>
                    <div class="field-group row field-bank" v-show="categorie != 'categorie 5'">
                      <div class="btn-choice sm-no-change col-sm-6">
                        <input type="checkbox" v-model="CarToUpdate.garanties" value="RESPONSABILITE CIVILE"
                          id="add_garanties_rc_mobile" name="Step9_mobile" class="field-input">
                        <label for="add_garanties_rc_mobile" class="field-label">
                          <h5 class="mt-3 text-center">{{ $t('devis.devis_auto.rc') }}</h5>
                        </label>
                      </div>
                      <div class="btn-choice sm-no-change col-sm-6">
                        <input type="checkbox" v-model="CarToUpdate.garanties" value="VOL" id="add_garanties_vol_mobile"
                          name="Step9_mobile" class="field-input">
                        <label for="add_garanties_vol_mobile" class="field-label">
                          <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.vol') }}</h3>
                        </label>
                      </div>
                      <div class="btn-choice sm-no-change col-sm-6">
                        <input type="checkbox" v-model="CarToUpdate.garanties" value="DEFENSE ET RECOURS"
                          id="add_garanties_defense_recours_mobile" name="Step9_mobile" class="field-input">
                        <label for="add_garanties_defense_recours_mobile" class="field-label">
                          <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.defense_recours') }}</h3>
                        </label>
                      </div>
                      <div class="btn-choice sm-no-change col-sm-6">
                        <input type="checkbox" v-model="CarToUpdate.garanties" value="INCENDIE"
                          id="add_garanties_incendie_mobile" name="Step9_mobile" class="field-input">
                        <label for="add_garanties_incendie_mobile" class="field-label">
                          <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.incendie') }}</h3>
                        </label>
                      </div>
                      <div class="btn-choice sm-no-change col-sm-6">
                        <input type="checkbox" v-model="CarToUpdate.garanties" value="PERSONNES TRANSPORTEES"
                          id="add_garanties_Personnes_Transportees_mobile" name="Step9_mobile" class="field-input"
                          @change="PersoTransporteModalFunction()">
                        <label for="add_garanties_Personnes_Transportees_mobile" class="field-label">
                          <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.personnes_transportee') }}</h3>
                        </label>
                      </div>
                      <div class="btn-choice sm-no-change col-sm-6">
                        <input type="checkbox" v-model="CarToUpdate.garanties" value="AVANCE SUR RECOURS"
                          id="add_garanties_avance_sur_recours_mobile" name="Step9_mobile" class="field-input"
                          @change="AvRecModalFunction()">
                        <label for="add_garanties_avance_sur_recours_mobile" class="field-label">
                          <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.avance_sur_recours') }}</h3>
                        </label>
                      </div>
                      <div class="btn-choice sm-no-change col-sm-6">
                        <input type="checkbox" v-model="CarToUpdate.garanties" value="BRIS DE GLACES"
                          id="add_garanties_bris_de_glace_mobile" name="Step9_mobile" class="field-input">
                        <label for="add_garanties_bris_de_glace_mobile" class="field-label">
                          <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.bris_de_glaces') }}</h3>
                        </label>
                      </div>
                      <div class="btn-choice sm-no-change col-sm-6" v-if="annee <= 5">
                        <input type="checkbox" v-model="CarToUpdate.garanties" value="TIERCE COMPLETE"
                          id="add_garanties_tierce_complete_mobile" name="Step9_mobile" class="field-input"
                          @change="tierceControl()">
                        <label for="add_garanties_tierce_complete_mobile" class="field-label">
                          <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.tierce_complete') }}</h3>
                        </label>
                      </div>
                      <div class="btn-choice sm-no-change col-sm-6" v-if="annee <= 5">
                        <input type="checkbox" v-model="CarToUpdate.garanties" value="TIERCE COLLISION"
                          id="add_garanties_tierce_colision_mobile" name="Step9_mobile" class="field-input"
                          @change="tierceControl()">
                        <label for="add_garanties_tierce_colision_mobile" class="field-label">
                          <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.tierce_collision') }}</h3>
                        </label>
                      </div>
                      <div class="btn-choice sm-no-change col-sm-6" v-if="annee <= 5">
                        <input type="checkbox" v-model="CarToUpdate.garanties" value="TIERCE PLAFONNEE"
                          id="add_garanties_tierce_plafonné_mobile" name="Step9_mobile" class="field-input" disabled>
                        <label for="add_garanties_tierce_plafonné_mobile" class="field-label">
                          <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.tierce_plafonne') }}</h3>
                        </label>
                      </div>
                    </div>
  
                    <div class="field-group row field-bank" v-show="categorie == 'categorie 5'">
                      <div class="btn-choice sm-no-change col-sm-6">
                        <input type="checkbox" v-model="CarToUpdate.garanties" value="RESPONSABILITE CIVILE"
                          id="add_garanties_rc_mobile_2_roues" name="Step9_mobile" class="field-input">
                        <label for="add_garanties_rc_mobile_2_roues" class="field-label">
                          <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.rc') }}</h3>
                        </label>
                      </div>
                      <div class="btn-choice sm-no-change col-sm-6">
                        <input type="checkbox" v-model="CarToUpdate.garanties" value="VOL"
                          id="add_garanties_personnes_transportee_mobile_2_roues" name="Step9_mobile" class="field-input">
                        <label for="add_garanties_personnes_transportee_mobile_2_roues" class="field-label">
                          <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.personnes_transportee') }}</h3>
                        </label>
                      </div>
                      <div class="btn-choice sm-no-change col-sm-6">
                        <input type="checkbox" v-model="CarToUpdate.garanties" value="DEFENSE ET RECOURS"
                          id="add_garanties_defense_recours_mobile_2_roues" name="Step9_mobile" class="field-input">
                        <label for="add_garanties_defense_recours_mobile_2_roues" class="field-label">
                          <h3 class="mt-3 text-center">{{ $t('devis.devis_auto.defense_recours') }}</h3>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
              </div>
              <div class="wizard-footer-right">
                <button :disabled="suivantAddGarantie" @click="addGarantiesToClosePopup()" type="button" class="wizard-btn">
                  {{ $t('devis.devis_auto.bouton_ajouter') }}
                </button>
              </div>
              <!---->
            </div>
          </v-card-text>
  
        </v-card>
      </v-dialog>
  
      <!-- ========= DIALOG POUR LES INFORMATIONS DU BENEFICIAIRES AU CAS OU C 'EST PAS CELUI QUI EST CONNECTÉ ============ -->
      <!-- ========= DIALOG POUR LES INFORMATIONS DU BENEFICIAIRES AU CAS OU C 'EST PAS CELUI QUI EST CONNECTÉ ============ -->
      <v-dialog v-model="dialogInfoBeneficiaire" persistent max-width="1000">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">{{ $t('devis.devis_auto.infos_benef_title') }}&nbsp;:</div>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="col-sm-12 field-radio field-radio-center">
                            <div class="btn-choice">
                              <input v-model="genre" type="radio" value="Femme" id="Homme" name="infosPerso"
                                class="field-input">
                              <label for="Homme" class="field-label btn-choice-hide-dot">{{
                                $t('devis.devis_auto.infos_benef_content[0]') }}</label>
                            </div>
                            <div class="btn-choice">
                              <input v-model="genre" type="radio" value="Homme" id="Femme" name="infosPerso"
                                class="field-input">
                              <label for="Femme" class="field-label btn-choice-hide-dot">{{
                                $t('devis.devis_auto.infos_benef_content[1]') }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="row mt-3">
                        <div class="col-sm-6">
                          <div class="field-group field-default">
                            <label for="prenom_benef" class="field-label">
                              {{ $t('devis.devis_auto.infos_benef_content[2]') }}*
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="prenom_beneficiaire" placeholder="Votre prenom" id="prenom_benef"
                                name="infosPerso" class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="nom_benef" class="field-label">{{ $t('devis.devis_auto.infos_benef_content[3]')
                            }}*</label>
                            <input v-model="nom_beneficiaire" placeholder="Votre nom" id="nom_benef" name="infosPerso"
                              class="field-input">
                          </div>
                        </div>
                      </div>
  
                      <div class="row mt-3">
                        <div class="col-sm-6">
                          <div class="field-group field-default">
                            <label for="num_benef" class="field-label">
                              {{ $t('devis.devis_auto.infos_benef_content[4]') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="num_beneficiaire" @keypress="onlyNumber" id="num_benef" name="infosPerso" class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="email_benf" class="field-label">{{ $t('devis.devis_auto.infos_benef_content[5]')
                            }}</label>
                            <input v-model="email_beneficiaire" placeholder="xxxxxx@xxxxx.com" id="email_benf"
                              name="infosPerso" class="field-input">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="annulerBenef()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('devis.devis_auto.bouton_retour') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="Detail_info_beneficiaire()" type="button" class="wizard-btn">
                  {{ $t('devis.devis_auto.bouton_ajouter') }}
                </button>
              </div>
              <!---->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <div v-if="dialogLoading && isMobile" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{ $t('devis.devis_auto.devis_encours')}}</span>
    </div>
  
      <!-- <v-dialog v-model="dialogLoading" persistent width="700" v-if="isMobile()">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background:#FFA409">
            <div class="wizard-tab-content" style="background:#FFA409">
              <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0" style="background:#FFA409">
                    <div class="fields text-center" style="background:#FFA409">
                      <span class="field-title font-weight-bold" style="color:#fff">{{ $t('devis.devis_auto.devis_encours')
                      }}</span>
                    </div>
                    <div class="fields text-center" style="background:#FFA409">
                      <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog> -->

      <!-- ========= DIALOG POUR CONFIRMER SUPPRESSION VEHICULE ============ -->
      <!-- ========= DIALOG POUR CONFIRMER SUPPRESSION VEHICULE ============ -->
      <v-dialog v-model="deleteConfirmationCar" width="500" persistent>
        <v-card elevation="24" class="border-radius" >
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="Popup_autre" aria-hidden="true" aria-labelledby="step-Popup_autre"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">Confirmation&nbsp;:
                      </div>
                      <p>Confirmez-vous la suppression du véhicule?</p>
                    </div>
  
                    <div class="wizard-card-footer clearfix">
                      <div class="wizard-footer-left">
                        <button @click="deleteConfirmationCar = false" type="button" class="wizard-btn">
                          <span class="fas fa-arrow-left"></span>
                          Annuler
                        </button>
                      </div>
                      <div class="wizard-footer-right">
                        <button @click="confirmDeleteCar()" type="button" class="wizard-btn">
                          confirmer
                        </button>
                      </div>
                      <!---->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

       <!-- ========= DIALOG PUISSANCE FISCALE SUPPERIEUR A 24 ============ -->
      <!-- ========= DIALOG PUISSANCE FISCALE SUPPERIEUR A 24 ============ -->
      <v-dialog v-model="forceFiscaleModal" persistent max-width="600px">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="valeurNeuf" aria-hidden="true" aria-labelledby="step-valeurNeuf"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">Puissance fiscale&nbsp;:</div>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="field-group field-default">
                            <label for="force_fiscale" class="field-label">
                              Puissance fiscale (nombre de chevaux)
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input @keypress="onlyNumber" v-model="forceFiscaleValue" placeholder="renseignez une puissance supperieure à 24"
                                id="force_fiscale" name="forceFiscale" class="field-input">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="closeForceFiscaleModal()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('devis.devis_auto.bouton_retour') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="checkForceFiscale()" type="button" class="wizard-btn">
                  {{ $t('devis.devis_auto.bouton_valider') }}
                </button>
              </div>
              <!---->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <!-- INCLUSION DU POPUP DE LOGIN AU CAS OU LE USER VOULANT FAIRE UNE VALIDATION N'EST PAS CONNECTE -->
      <login-form :visible="showLoginForm" @close="showLoginForm = false"></login-form>

      <!-- INCLUSION DU FORMULAIRE DE MODIFICATION D'UN VEHICULE DE "MES VEHICULES" -->
      <edit-vehicle-dialog
        :visible="editVehicleDialog"
        :vehicle="vehicleToEdit"
        @close="editVehicleDialog = false"
        @saved="onVehicleUpdated"
      ></edit-vehicle-dialog>
    </div>
  </template>
  
  <script>
  import dayjs from 'dayjs'
  import MarqueImage from '../../common/marqueimage'
  import MarqueVehicule from '../../common/marqueauto'
  import Marque2roues from '../../common/2roues'
  import _ from 'underscore'
  import Api from '../../services/Api'
  import store from '../../store/store'
  import LoginForm from '../auth/Login'
  import { mask } from 'vue-the-mask'
  import configAuto from '../../common/configAuto'
  import PushInDataLayer from '../../services/TagManager'
  import listeTalonFromPartenerApi from "../../common/TalonDigitalPartener.json"
  import CarteGriseOcrService from '../../services/CarteGriseOcrService'
  import EditVehicleDialog from './EditVehicleDialog.vue'
  
  export default {
    name: 'Auto',
    components: {
      LoginForm,
      EditVehicleDialog
    },
    directives: {
      mask,
    },
    data() {
      return {
        forceFiscaleModal:false,
        forceFiscaleValue : null,
        listeTalonFromPartener: listeTalonFromPartenerApi,
        deleteConfirmationCar : false,
        confirmdelete: null,
        disabledBenefInput : false,
        SelectedPack : null,
        listeGaranties : configAuto.Pack,
        MarqueAuto : MarqueImage.auto,
        MarqueMoto : MarqueImage.moto,
        GarantiesBase: [],
        Garanties2roues: [],
        dialogLoading: false,
        disabledButtonValidate: false,
        DureeMois: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        searchCarDesktop: "",
        nombreVehicule: 0,
        carDetails: {},
        disableMyCars: false,
        myCars: null,

        // OCR Carte Grise
        ocrMode: null,
        carteGriseOcrLoading: false,
        carteGriseOcrError: null,
        carteGriseRectoFile: null,
        carteGriseVersoFile: null,
        extractedCarteGriseData: null,
        ocrDataValidated: false,
        isEditingOcr: false,
        extractedCarteGriseDataBackup: null,

        headerContrat: [
          {
            text: "Marque",
            sortable: false,
            value: "marque"
          },
          {
            text: "Modele",
            sortable: false,
            value: "model"
          },
          {
            text: "Immatriculation",
            sortable: false,
            value: "Immatriculation"
          },
          {
            text: "Nombre de places",
            sortable: false,
            value: "nbplace"
          },
          {
            text: "Force",
            sortable: false,
            value: "force"
          },
          {
            text: "Date 1ère Circulation",
            sortable: false,
            value: "dateCircule"
          },
          {
            text: "Valeur actuelle",
            sortable: false,
            value: "valeur_venale"
          },
          {
            text: "Action",
            value: "action"
          }
        ],
        headerContratMobile: [
          {
            text: "Marque",
            sortable: false,
            value: "marque"
          },
          {
            text: "Modele",
            sortable: false,
            value: "model"
          },
          {
            text: "Immatriculation",
            sortable: false,
            value: "Immatriculation"
          }
        ],
        ModalListeContrat: false,
        listCars: [],
        userCars: [],
        showOffre: true,
        offre_full: false,
        PackFull_Choix: null,
        text_packStandart: false,
        text_packInter: false,
        text_packAvance: false,
        text_packFull_1: false,
        text_packFull_2: false,
        text_packFull_3: false,
        offre: 'offre_pack',
        offre_pack: true,
        offre_pack_full: false,
        offre_carte: false,
        packS: '',
        packI: '',
        packA: '',
        packStandart: {
          garanties: ['RESPONSABILITE CIVILE', 'PERSONNES TRANSPORTEES', 'DEFENSE ET RECOURS']
        },
        packIntermediaire: {
          garanties: ['RESPONSABILITE CIVILE', 'PERSONNES TRANSPORTEES', 'DEFENSE ET RECOURS', 'BRIS DE GLACES']
        },
        packAvance: {
          garanties: ['RESPONSABILITE CIVILE', 'PERSONNES TRANSPORTEES', 'DEFENSE ET RECOURS', 'BRIS DE GLACES', 'VOL', 'INCENDIE', 'AVANCE SUR RECOURS']
        },
        packFull: {
          packFullToutRisques: {
            garanties: ['RESPONSABILITE CIVILE', 'PERSONNES TRANSPORTEES', 'DEFENSE ET RECOURS', 'BRIS DE GLACES', 'VOL', 'INCENDIE', 'AVANCE SUR RECOURS', 'TIERCE COMPLETE']
          },
          packFullCollision: {
            garanties: ['RESPONSABILITE CIVILE', 'PERSONNES TRANSPORTEES', 'DEFENSE ET RECOURS', 'BRIS DE GLACES', 'VOL', 'INCENDIE', 'AVANCE SUR RECOURS', 'TIERCE COLLISION']
          }
        },
        showMarqueSelect: false,
        showMarque2roueSelect: false,
        step: 0,
        neant: 'N.A',
        annee: null,
        VNeuf: false,
        dialogInfoBeneficiaire: false,
        switch1: false,
        mask: 'XX-XXXX-XX',
        selected: [],
        genre: null,
        money: {
          thousands: ' ',
          precision: false,
          masked: false,
        },
        forceFis: false,
        dateCircul: false,
        carteNouvelle: false,
        carteAncienne: false,
        dateNouvelle: false,
        dateAncienne: false,
        itemsGenre: ['Homme', 'Femme'],
        max: 10,
        itemsFlotte: ['2', '3', '4', '5', '6', '7', '8', '9'],
        items: ['2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
        items2roues: ['1', '2'],
        PuissanceFinscaleItems: ['2', '3', '4', '5', '6', '7', '8', '9', '10', 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, '24+'],
        date: new Date().toISOString().substr(0, 10),
        menu: false,
        popupAutre: false,
        otherMarque : false,
        popupAddGaranties: false,
        datePickerAge: false,
        modal: false,
        menu1: false,
        dialog: false,
        AvRec: false,
        type_vitre: null,
        AvRecModal: false,
        AvRecAddNew: false,
        PersoTransporteModal: false,
        e1: 0,
        marque: null,
        ToastTabSucess: {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 4000,
          fitToScreen: true,
          type: 'success',
          className: 'custom-success-class'
        }, // Customized options for success toast
        ToastTabError: {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 4000,
          fitToScreen: true,
          type: 'error'
        }, // Customized options for error toast
        ToastTabErrorSpec: {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 10000,
          fitToScreen: true,
          type: 'error'
        }, // Customized options for error toast
        model: null,
        categorie: null,
        categorieFInale: null,
        volumetrie2_roues: null,
        tonnage: null,
        tonnage_carosserie: null,
        annee_mois: null,
        dialogEditItem: false,
        editVehicleDialog: false,
        vehicleToEdit: null,
        capital_AvRec: null,
        force: null,
        nbBeneficiaire: null,
        optionPersoTrans: null,
        flotte_mono: null,
        clickTCollision_TComplete: false,
        nombreVehicules: null,
        HideNbVehicule: true,
        optionUtilitaire: null,
        carosserie: null,
        option_Individuel_Accident: null,
        dateCircule: null,
        age: null,
        year: null,
        nbplace: null,
        dateEffet: new Date().toISOString().substr(0, 10),
        dateEcheance: null,
        proprietaire: '',
        prenom_beneficiaire: '',
        nom_beneficiaire: '',
        num_beneficiaire: '',
        email_beneficiaire: '',
        duree: null,
        yearDiff: null,
        tableau_info_beneficiaire: [],
        listeAssureurs: [],
        assureurs: [],
        valeur: null,
        CarToUpdate: null,
        valeur_venale: null,
        immatriculation: null,
        numeroChassis : null,
        showLoginForm: false,
  
        carburant: null,
        garanties: [],
        hideTablr: true,
        Individuel_Accident_Modal: false,
        typeAssurance: 'AUTO/MOTO',
        voidField: false,
        carburation: [
          {
            "lib": "Essence",
            "val": "Essence"
          },
          {
            "lib": "Diesel",
            "val": "Diésel"
          },
          {
            "lib": "Hybride",
            "val": "Hybride"
          },
          {
            "lib": "Electrique",
            "val": "Electrique"
          },
        ],
        ListAuto: [],
        listeMarque: MarqueVehicule,
        listeMarque2roues: Marque2roues,
        listeModeles: null,
        listeModeles2roues: null,
        selectedMarque: null,
        nbAutoAdded: 0,
        headers: [{
          text: 'Marque & Modèle',
          value: 'marque'
        },
        {
          text: 'Immatriculation',
          value: 'immatriculation'
        },
        {
          text: 'Catégorie',
          value: 'catégorie'
        },
        {
          text: 'Force',
          value: 'force'
        },
        {
          text: 'Age',
          value: 'age'
        },
        {
          text: 'Valeur neuf',
          value: 'valeur'
        },
        {
          text: 'Valeur actuelle',
          value: 'valeur_actuelle'
        },
        {
          text: 'Nbr places',
          value: 'nbplace'
        },
        {
          text: 'Actions'
        }
        ],
        editedIndex: -1,
        editedItem: {
          marque: null,
          model: null,
          categorie: null,
          force: 0,
          age: null,
          valeur: null,
          immatriculation: null,
          carburant: null,
        },
        defaultItem: {
          marque: null,
          model: null,
          categorie: null,
          force: 0,
          age: null,
          valeur: null,
          immatriculation: null,
          carburant: null,
        },
        suivant: false,
        suivantAddGarantie: false,
      }
    },
    methods: {
      // ==================== OCR Carte Grise Methods ====================
      handleCarteGriseRectoUpload: function(event) {
        var input = event.target;
        var file = input.files[0];
        if (file) {
          var validation = CarteGriseOcrService.validateFile(file);
          if (!validation.valid) {
            this.carteGriseOcrError = this.getOcrErrorMessage(validation.error);
            this.$nextTick(function() { input.value = ''; });
            return;
          }
          this.carteGriseRectoFile = file;
          this.carteGriseOcrError = null;
        }
      },

      handleCarteGriseVersoUpload: function(event) {
        var input = event.target;
        var file = input.files[0];
        if (file) {
          var validation = CarteGriseOcrService.validateFile(file);
          if (!validation.valid) {
            this.carteGriseOcrError = this.getOcrErrorMessage(validation.error);
            this.$nextTick(function() { input.value = ''; });
            return;
          }
          this.carteGriseVersoFile = file;
          this.carteGriseOcrError = null;
        }
      },

      analyzeCarteGrise: async function() {
        if (!this.carteGriseRectoFile || !this.carteGriseVersoFile) {
          this.carteGriseOcrError = this.$t('devis.devis_auto.ocr_carte_grise.error_both_required');
          return;
        }

        this.carteGriseOcrLoading = true;
        this.carteGriseOcrError = null;

        try {
          var result = await CarteGriseOcrService.scanCarteGrise(
            this.carteGriseRectoFile,
            this.carteGriseVersoFile
          );
          this.extractedCarteGriseData = result;
        } catch (error) {
          console.error('OCR Error:', error);
          this.carteGriseOcrError = this.getOcrErrorMessage(error.message);
        } finally {
          this.carteGriseOcrLoading = false;
        }
      },

      getOcrErrorMessage: function(code) {
        var messages = {
          'NO_FILE': this.$t('devis.devis_auto.ocr_carte_grise.error_no_file'),
          'INVALID_TYPE': this.$t('devis.devis_auto.ocr_carte_grise.error_invalid_type'),
          'FILE_TOO_LARGE': this.$t('devis.devis_auto.ocr_carte_grise.error_file_too_large'),
          'OCR_INCOMPLETE_DATA': this.$t('devis.devis_auto.ocr_carte_grise.error_incomplete')
        };
        return messages[code] || this.$t('devis.devis_auto.ocr_carte_grise.error_generic');
      },

      validateCarteGriseOcr: function() {
        if (!this.extractedCarteGriseData) return;
        var self = this;
        var ocrMarque = this.extractedCarteGriseData.marque;
        var ocrModele = this.extractedCarteGriseData.modele;

        if (this.extractedCarteGriseData.immatriculation) {
          this.immatriculation = this.extractedCarteGriseData.immatriculation;
        }
        if (this.extractedCarteGriseData.carburant) {
          this.carburant = this.extractedCarteGriseData.carburant;
        }
        // Set categorie FIRST so MarqueAuto is updated correctly via watcher
        if (this.extractedCarteGriseData.categorie) {
          this.categorie = this.extractedCarteGriseData.categorie;
        }
        if (this.extractedCarteGriseData.puissanceFiscale) {
          this.force = this.extractedCarteGriseData.puissanceFiscale;
        }
        if (this.extractedCarteGriseData.nombrePlaces) {
          this.nbplace = this.extractedCarteGriseData.nombrePlaces;
        }
        if (this.extractedCarteGriseData.dateCirculation) {
          this.dateCircule = this.extractedCarteGriseData.dateCirculation;
          this.yearsDiff();
        }
        if (this.extractedCarteGriseData.numeroChassis) {
          this.numeroChassis = this.extractedCarteGriseData.numeroChassis;
        }
        if (this.extractedCarteGriseData.proprietaire) {
          this.proprietaire = this.extractedCarteGriseData.proprietaire;
        }
        // Pre-fill beneficiaire fields for modal
        if (this.extractedCarteGriseData.nom) {
          this.nom_beneficiaire = this.extractedCarteGriseData.nom;
        }
        if (this.extractedCarteGriseData.prenom) {
          this.prenom_beneficiaire = this.extractedCarteGriseData.prenom;
        }

        // Set marque and model after $nextTick to ensure MarqueAuto is updated
        this.$nextTick(function() {
          if (ocrMarque) {
            // Normalize marque to uppercase to match MarqueAuto list
            var normalizedMarque = ocrMarque.toUpperCase().trim();

            // Check if marque exists in the list
            var marqueExists = self.MarqueAuto.some(function(item) {
              return item.marque === normalizedMarque;
            });

            self.marque = normalizedMarque;
            // Trigger model loading based on category
            if (self.categorie === '2_roues') {
              self.onChangeSelectedMarque2roues();
            } else {
              self.onChangeSelectedMarque();
            }

            // Set model after another tick to allow models list to be populated
            self.$nextTick(function() {
              if (ocrModele) {
                self.model = ocrModele;
              }
            });
          }
        });

        this.ocrDataValidated = true;
        // Stay on same step - user will fill remaining fields (valeur_venale) then go to packs
      },

      goToPacksFromOcr: function() {
        // Validate valeur_venale is filled
        if (!this.valeur_venale || this.valeur_venale === '0' || this.valeur_venale === '') {
          this.$toasted.show('La valeur actuelle du véhicule est obligatoire', this.ToastTabError);
          return;
        }
        // Go directly to packs (step 5)
        this.step = 5;
      },

      changeOcrMode: function() {
        // Repartir de zéro côté OCR (fichiers, données extraites, édition) avant de rouvrir le sélecteur de mode
        this.resetCarteGriseOcr();
        // Effacer aussi les champs du formulaire principal pré-remplis par OCR ou saisis en manuel
        this.immatriculation = null;
        this.marque = null;
        this.model = null;
        this.categorie = null;
        this.carburant = null;
        this.force = null;
        this.nbplace = null;
        this.dateCircule = null;
        this.numeroChassis = null;
        this.proprietaire = '';
        this.nom_beneficiaire = '';
        this.prenom_beneficiaire = '';
        this.valeur_venale = null;
        this.ocrMode = null;
      },

      reopenOcrEdit: function() {
        // Reviens à l'étape "récap + modifier" en gardant les données OCR
        this.ocrDataValidated = false;
        this.startEditCarteGriseOcr();
      },

      startEditCarteGriseOcr: function() {
        this.extractedCarteGriseDataBackup = Object.assign({}, this.extractedCarteGriseData);

        // Normaliser marque/modele pour qu'ils correspondent aux valeurs des <select>
        // (MarqueVehicule/Marque2roues sont en MAJUSCULES)
        var cat = this.extractedCarteGriseData.categorie;
        var source = cat == '2_roues' ? Marque2roues : MarqueVehicule;

        if (this.extractedCarteGriseData.marque) {
          var marqueUpper = String(this.extractedCarteGriseData.marque).toUpperCase().trim();
          var marqueExists = source.some(function(item) { return item.Marque === marqueUpper; });
          this.extractedCarteGriseData.marque = marqueExists ? marqueUpper : '';
        }

        if (this.extractedCarteGriseData.marque && this.extractedCarteGriseData.modele) {
          var modeleStr = String(this.extractedCarteGriseData.modele).toUpperCase().trim();
          var matchedType = null;
          for (var i = 0; i < source.length; i++) {
            var it = source[i];
            if (it && it.Marque === this.extractedCarteGriseData.marque && it.Type != null) {
              if (String(it.Type).toUpperCase().trim() === modeleStr) {
                matchedType = it.Type;
                break;
              }
            }
          }
          this.extractedCarteGriseData.modele = matchedType != null ? matchedType : '';
        }

        // Normaliser puissanceFiscale / nombrePlaces pour matcher les <option> (types mixtes string/number)
        this.extractedCarteGriseData.puissanceFiscale = this.matchSelectValue(this.extractedCarteGriseData.puissanceFiscale, this.PuissanceFinscaleItems);
        this.extractedCarteGriseData.nombrePlaces = this.matchSelectValue(this.extractedCarteGriseData.nombrePlaces, this.items);

        this.isEditingOcr = true;
      },

      matchSelectValue: function(value, list) {
        if (value === '' || value == null) return '';
        var str = String(value).trim();
        for (var i = 0; i < list.length; i++) {
          if (String(list[i]) === str) return list[i];
        }
        return '';
      },

      cancelEditCarteGriseOcr: function() {
        if (this.extractedCarteGriseDataBackup) {
          this.extractedCarteGriseData = Object.assign({}, this.extractedCarteGriseDataBackup);
        }
        this.extractedCarteGriseDataBackup = null;
        this.isEditingOcr = false;
      },

      saveEditCarteGriseOcr: function() {
        if (!this.extractedCarteGriseData.immatriculation) {
          this.$toasted.show('L\'immatriculation est obligatoire', this.ToastTabError);
          return;
        }
        this.extractedCarteGriseDataBackup = null;
        this.isEditingOcr = false;
      },

      resetCarteGriseOcr: function() {
        this.carteGriseRectoFile = null;
        this.carteGriseVersoFile = null;
        this.extractedCarteGriseData = null;
        this.carteGriseOcrError = null;
        this.ocrDataValidated = false;
        this.isEditingOcr = false;
        this.extractedCarteGriseDataBackup = null;
      },
      // ==================== End OCR Methods ====================

      checkPuissanceFiscale(item){
        if(item == '24+'){
          this.forceFiscaleModal = true
        }else {
           this.forceFiscaleValue = null
        }
      },
      closeForceFiscaleModal(){
        this.forceFiscaleValue = null
        this.forceFiscaleModal = false
        this.force = null
      },

      checkForceFiscale(){
        if(this.forceFiscaleValue == ''){
          this.$toasted.show('Veuillez renseigner une puissance fiscale ! ', this.ToastTabError)
        } else if(this.forceFiscaleValue < 25){
          this.$toasted.show('Veuillez renseigner une puissance fiscale superieure à 24 ! ', this.ToastTabError)
        } else {
          this.forceFiscaleModal = false
        }
      },
      confirmDeleteCar() {
        const UserCar = {
          id: this.confirmdelete._id
        }

        Api().post("flette/delete", UserCar)
          .then(response => {
            if (response.status == 200) {
              this.deleteConfirmationCar = false
              this.getUserCars()
              this.$toasted.show("Véhicule supprimé avec succès !", this.ToastTabSucess)
            }
          })
          .catch(err => { })
      },
      validateNumeroChassis() {
      const regex = /^[A-Za-z0-9-]+$/;
      if (!regex.test(this.numeroChassis)) {
        this.numeroChassis = this.numeroChassis.replace(/[^A-Za-z0-9-]/g, '');
      }
    },
      validateImmatriculation() {
      const regex = /^[A-Za-z0-9]{2}-[A-Za-z0-9]{4}-[A-Za-z0-9]{2}$/;
      if (!regex.test(this.immatriculation)) {
        this.immatriculation = this.immatriculation.replace(/[^A-Za-z0-9-]/g, '');
      }
    },
      checkToken() {
        Api().get('user/check/token')
          .then((resultat) => {
            // verifie si le token exist
            if (!resultat.data.ok) {
              store.state.isUserLoggedIn = false;
              store.dispatch("setUser", {});
              store.dispatch("setToken", {});
              this.showLoginForm = true
            }
          }).catch((err) => {
            // verifie  si le token est expiré
            if (err.response.data.ok === false) {
              store.state.isUserLoggedIn = false;
              store.dispatch("setUser", {});
              store.dispatch("setToken", {});
              this.showLoginForm = true
            }
          });
      },
  
      addGarantiesToClosePopup() {
        if (this.CarToUpdate.garanties.length >= 1) {
          this.popupAddGaranties = false
        } else {
          this.$toasted.show('Veuillez cocher une garantie au minimum ! ', this.ToastTabError)
        }
      },
  
      backToFirstStep() {
        this.step = 0
        this.myCars = null
      },
  
      closePopupCar() {
        this.ModalListeContrat = false
        while (this.listCars.length) {
          this.listCars.pop();
        }
      },
  
      getUserCars() {
        Api().post("flette/listing/", { userid: store.state.user._id })
          .then(response => {
            this.listCars = response.data.cars
          });
      },

      openEditVehicle(item) {
        this.vehicleToEdit = item
        this.editVehicleDialog = true
      },

      onVehicleUpdated() {
        this.getUserCars()
      },

      deleteUserCar(item) {
        this.deleteConfirmationCar = true
        this.confirmdelete = item
      },
  
      //Date object formater to String
      DateFormater: function (TheDate) {
        if (TheDate) {
          return dayjs(TheDate).format('DD-MM-YYYY')
        }
      },
  
      disabledBeforeToday(date) {
        const today = new Date();
        return date > today;
      },
  
      disabledAfterToday(date) {
        const today = dayjs(new Date()).add(-1, 'day')
        return date < today;
      },
  
      yearsDiffDateEffet() {
        const date1 = dayjs(this.dateEffet);
        const date2 = dayjs(new Date().toISOString().substr(0, 10));
        let daydiff = date2.diff(date1, 'days');
  
        this.ageArrivee = daydiff;
  
        if (this.ageArrivee > 0) {
          this.ageArrivee = null;
          this.annee_mois = '';
          this.$toasted.show('Erreur, date postérieure à la date actuelle! ', this.ToastTabError)
          this.dateEffet = null
  
        }
  
      },
      showGaranties() {
        this.optionPersoTrans = this.SelectedPack.optionPersoTrans
        this.capital_AvRec = this.SelectedPack.capital_AvRec
        this.garanties = this.SelectedPack.garanties

        console.log(":::::: Garanties :::::::::", this.SelectedPack.id)

      if(this.SelectedPack.id == "pack_full_tous_risques" || "pack_full_tous_collision"){
        this.ValeurNeufModalFunction()
      }
      },
      showGarantiesPackFull() {
        if (this.garanties == this.packFull.packFullToutRisques.garanties) {
          this.optionPersoTrans = 'option 1'
          this.capital_AvRec = '500000'
          this.ValeurNeufModalFunction()
  
          this.text_packFull_1 = true
          this.text_packFull_2 = false
          this.text_packFull_3 = false
        } else if (this.garanties == this.packFull.packFullCollision.garanties) {
          this.optionPersoTrans = 'option 1'
          this.capital_AvRec = '500000'
          this.ValeurNeufModalFunction()
          this.text_packFull_1 = false
          this.text_packFull_2 = true
          this.text_packFull_3 = false
        } else if (this.garanties == this.packFull.packFull_3.garanties) {
          this.text_packFull_1 = false
          this.text_packFull_2 = false
          this.text_packFull_3 = true
        }
  
      },
      show_offre() {
        if (this.offre == 'offre_pack') {
          this.offre_pack = true
          this.offre_carte = false
          this.garanties = []
        } else if (this.offre == 'offre_carte') {
          this.offre_pack = false
          this.offre_carte = true
          this.text_packStandart = false
          this.text_packInter = false
          this.text_packAvance = false
          this.text_packFull_1 = false
          this.text_packFull_2 = false
          this.text_packFull_3 = false
          this.offre_full = false
          this.garanties = []
        }
      },
      showMarque() {
        this.showMarqueSelect = true
        this.marque = null
      },
      showMarque2roue() {
        this.showMarque2roueSelect = true
        this.marque = null
      },
      passFirstStep() {
        document.getElementById("sixStep").classList.add('checked');
        document.getElementById("testup").classList.add('widthSix');
      },
  
      BacktoFirstStep() {
        this.step = 1
        document.getElementById("firstStep").classList.remove('checked');
        document.getElementById("testup").classList.remove('widthSecond');
  
      },
  
      BacktoSecondStep() {
        this.step = 2
        document.getElementById("firstStep").classList.remove('checked');
        document.getElementById("testup").classList.remove('widthThirt');
  
      },
      BacktoThirstStep() {
        this.step = 3
        document.getElementById("firstStep").classList.remove('checked');
        document.getElementById("testup").classList.remove('widthFour');
  
      },
      BacktoFourStep() {
        if (this.categorie != '2_roues') {
          if (this.myCars == 'mes_vehicule') {
            this.step = 0
            document.getElementById("firstStep").classList.remove('checked');
            document.getElementById("secondStep").classList.remove('checked');
            document.getElementById("testup").classList.remove('widthFive');
          } else {
            this.step = 4
            document.getElementById("secondStep").classList.remove('checked');
            document.getElementById("testup").classList.remove('widthFive');
          }
        } else if (this.categorie == '2_roues') {
          if (this.myCars == 'mes_vehicule') {
            this.step = 0
            document.getElementById("firstStep").classList.remove('checked');
            document.getElementById("secondStep").classList.remove('checked');
            document.getElementById("testup").classList.remove('widthFive');
          } else {
            this.step = 3
            document.getElementById("firstStep").classList.remove('checked');
            document.getElementById("testup").classList.remove('widthFour');
          }
  
        }
  
      },
      BacktoFiveStep() {
        this.step = 5
        this.ListAuto.pop()
        document.getElementById("secondStep").classList.remove('checked');
        document.getElementById("testup").classList.remove('widthSix');
  
      },
  
      prev() {
        this.step--;
      },
      next() {
        this.step++;
      },
  
      validMarqueModel() {
        if (this.categorie == '2_roues') {
          if (this.marque && this.model && this.cylindre) {
            this.popupAutre = false
            this.next()
            document.getElementById("testup").classList.add('widthThirt');
          } else {
            this.$toasted.show('Champs obligatoires ! ', this.ToastTabError)
          }
        } else {
          if (this.marque && this.model) {
            this.popupAutre = false
            this.next()
            document.getElementById("testup").classList.add('widthThirt');
          } else {
            this.$toasted.show('Champs obligatoires ! ', this.ToastTabError)
          }
        }
      },
      /*============= fonction pour controler les garanties tierce a ne cocher plus d'un ===========*/
      tierceControl() {
        if (!this.CarToUpdate) {
          let cpt = 0;
          for (let index = 0; index < this.garanties.length; index++) {
            if (this.garanties[index].trim() == 'TIERCE COLLISION' || this.garanties[index].trim() == 'TIERCE PLAFONNEE') {
              cpt = cpt + 1
            } else if (this.garanties[index].trim() == 'TIERCE COLLISION' || this.garanties[index].trim() == 'TIERCE COMPLETE') {
              cpt = cpt + 1
            } else if (this.garanties[index].trim() == 'TIERCE COMPLETE' || this.garanties[index].trim() == 'TIERCE PLAFONNEE') {
              cpt = cpt + 1
            } else if (this.garanties[index].trim() == 'TIERCE COLLISION' || this.garanties[index].trim() == 'TIERCE PLAFONNEE' || this.garanties[index].trim() == 'TIERCE COMPLETE') {
              cpt = cpt + 2
            }
          }
          if (cpt == 2) {
            this.$toasted.show("Impossible de prendre 2 garanties tierces en même temps", this.ToastTabError);
            this.suivant = true
          } else if (cpt == 3) {
            this.$toasted.show("Impossible de prendre 3 garanties tierces en même temps", this.ToastTabError);
            this.suivant = true
          } else {
            this.ValeurNeufModalFunction()
            this.suivant = false
          }
        } else {
          let cpt = 0;
          for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
            if (this.CarToUpdate.garanties[index].trim() == 'TIERCE COLLISION' || this.CarToUpdate.garanties[index].trim() == 'TIERCE PLAFONNEE') {
              cpt = cpt + 1
            } else if (this.CarToUpdate.garanties[index].trim() == 'TIERCE COLLISION' || this.CarToUpdate.garanties[index].trim() == 'TIERCE COMPLETE') {
              cpt = cpt + 1
            } else if (this.CarToUpdate.garanties[index].trim() == 'TIERCE COMPLETE' || this.CarToUpdate.garanties[index].trim() == 'TIERCE PLAFONNEE') {
              cpt = cpt + 1
            } else if (this.CarToUpdate.garanties[index].trim() == 'TIERCE COLLISION' || this.CarToUpdate.garanties[index].trim() == 'TIERCE PLAFONNEE' || this.CarToUpdate.garanties[index].trim() == 'TIERCE COMPLETE') {
              cpt = cpt + 2
            }
          }
          if (cpt == 2) {
            this.$toasted.show("Impossible de prendre 2 garanties tierces en même temps", this.ToastTabError);
            this.suivantAddGarantie = true
          } else if (cpt == 3) {
            this.$toasted.show("Impossible de prendre 3 garanties tierces en même temps", this.ToastTabError);
            this.suivantAddGarantie = true
          } else {
            this.ValeurNeufModalFunction()
            this.suivantAddGarantie = false
          }
        }
      },
  
      /*============= fonction pour controler les garanties tierce a ne cocher plus d'un ===========*/
      tierceControlAddGarantie() {
        let cpt = 0;
        for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
          if (this.CarToUpdate.garanties[index].trim() == 'TIERCE COLLISION' || this.CarToUpdate.garanties[index].trim() == 'TIERCE PLAFONNEE') {
            cpt = cpt + 1
          } else if (this.CarToUpdate.garanties[index].trim() == 'TIERCE COLLISION' || this.CarToUpdate.garanties[index].trim() == 'TIERCE COMPLETE') {
            cpt = cpt + 1
          } else if (this.CarToUpdate.garanties[index].trim() == 'TIERCE COMPLETE' || this.CarToUpdate.garanties[index].trim() == 'TIERCE PLAFONNEE') {
            cpt = cpt + 1
          } else if (this.CarToUpdate.garanties[index].trim() == 'TIERCE COLLISION' || this.CarToUpdate.garanties[index].trim() == 'TIERCE PLAFONNEE' || this.CarToUpdate.garanties[index].trim() == 'TIERCE COMPLETE') {
            cpt = cpt + 2
          }
        }
        if (cpt == 2) {
          this.$toasted.show("Impossible de prendre 2 garanties tierces en même temps", this.ToastTabError);
          this.suivant = true
        } else if (cpt == 3) {
          this.$toasted.show("Impossible de prendre 3 garanties tierces en même temps", this.ToastTabError);
          this.suivant = true
        } else {
          this.ValeurNeufModalAddGarantiesFunction()
          this.suivant = false
        }
      },
  
      optionPersonneTransControl() {
        if (this.optionPersoTrans) {
          this.PersoTransporteModal = false
        } else {
          this.$toasted.show("Veuillez choisir une option!", this.ToastTabError)
        }
      },
      /*============= fonction du switch pour l'affichage du champ beneficiaire ===========*/
      switchBenef() {
        if (!this.$store.state.isUserLoggedIn) {
          this.showLoginForm = true
        } else if (this.switch1) {
          if (!this.$store.state.isUserLoggedIn) {
            this.showLoginForm = true;
            this.switch1 = false;
            this.proprietaire = ''
          } else {
            this.disabledBenefInput = true
            this.proprietaire = this.$store.state.user.prenom + ' ' + this.$store.state.user.nom
          }
        } else {
          this.proprietaire = '';
          this.disabledBenefInput = false
          //this.dialogInfoBeneficiaire = true
        }
      },
  
      /*============= Action sur le button annuler du popup beneficiaire ===========*/
      annulerBenef() {
        this.dialogInfoBeneficiaire = false;
        //this.switch1 = true;
        //this.proprietaire = this.$store.state.user.prenom + ' ' + this.$store.state.user.nom
      },
  
  
      /*============= Action sur le button valider infos du popup beneficiaire ===========*/
      Detail_info_beneficiaire() {
        if (this.prenom_beneficiaire && this.nom_beneficiaire) {
          //if (this.num_beneficiaire && this.email_beneficiaire) {
            let Beneficiaire = {
              prenom: this.prenom_beneficiaire,
              numero: this.num_beneficiaire,
              nom: this.nom_beneficiaire,
              email: this.email_beneficiaire,
              genre: this.genre
            };
            this.tableau_info_beneficiaire.push(Beneficiaire);
            this.proprietaire = this.prenom_beneficiaire + ' ' + this.nom_beneficiaire;
            this.dialogInfoBeneficiaire = false;
          // } else {
          //   this.$toasted.show('Tous les (*) sont obligatoires ! ', this.ToastTabError)
          // }
        } else {
          this.$toasted.show('Tous les (*) sont obligatoires ! ', this.ToastTabError)
        }
      },
  
      /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
      onlyNumber($event) {
        let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
        if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
          $event.preventDefault();
        }
      },
  
      /*============= Fonction pour calculer la date 1ere mise en circulation ===========*/
      yearsDiff() {
        const date1 = dayjs(this.dateCircule);
        const date2 = dayjs(new Date().toISOString().substr(0, 10));
        let daydiff = date2.diff(date1, 'days');

        if (daydiff < 0) {
          this.age = null;
          this.annee = null;
          this.year = null;
          this.annee_mois = '';
          this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
          this.dateCircule = null
        } else {
          // Toujours calculer l'âge en années
          let year = Math.floor(daydiff / 365);
          this.age = year;
          this.annee = year;
          this.year = year;
          this.annee_mois = year > 0 ? 'an(s)' : 'mois';
        }
      },
  
      infoFiscale() {
        this.forceFis = !this.forceFis;
        this.carteNouvelle = false;
        this.carteAncienne = false;
      },
  
      infoDate() {
        this.dateCircul = !this.dateCircul;
        this.dateNouvelle = false;
        this.dateAncienne = false;
      },
  
      Option: function () {
        this.isHidden = !this.isHidden;
      },
  
      dateDiff: function () {
        if (this.dateEffet === '' && this.duree === '') this.dateEcheance = '';
        let inter = dayjs(this.dateEffet).add(this.duree, 'month').format('YYYY-MM-DD');
        this.dateEcheance = dayjs(inter).add(-1, 'day').format('YYYY-MM-DD')
        this.yearsDiffDateEffet()
      },
  
      zeroControl() {
        if (this.duree <= 0) {
          this.duree = null
        }
      },
  
      numberMonth() {
        this.zeroControl()
        if (this.duree <= 12) {
          return true
        } else {
  
          return false
        }
      },
  
      isMobile: function () {
        if (screen.width <= 760) {
          return true
        } else {
          return false
        }
      },
  
      isTablette() {
        if (screen.width > 425 && screen.width <= 768) {
          return true
        } else {
          return false
        }
      },
  
      isDesktop: function () {
        if (screen.width > 768) {
          return true
        } else {
          return false
        }
      },
  
      CloseModalVNeuf: function () {
        // let trouver = 0;
        // for (let index = 0; index < this.garanties.length; index++) {
        //   if (this.garanties[index] == 'TIERCE COMPLETE') {
        //     trouver = 1
        //   }
        // }
  
        // if (trouver == 1 && !this.valeur || this.valeur == 0) {
        //   if (this.garanties == this.packFull.packFullToutRisques.garanties) {
        //     this.garanties = []
        //     this.text_packFull_1 = false
        //   }
        //   if (this.garanties == this.packFull.packFullCollision.garanties) {
        //     this.garanties = []
        //     this.text_packFull_2 = false
        //   }
        //   this.garanties.pop();
        //   this.VNeuf = false
        // }
         if(!this.CarToUpdate) {
           if(this.offre == 'offre_carte'){
            let trouver = 0;
            for (let index = 0; index < this.garanties.length; index++) {
                if (this.garanties[index] == 'TIERCE COMPLETE') {
                  trouver = 1
                } 
              }
  
            if (trouver == 1 && !this.valeur || this.valeur == 0) {
              this.garanties.pop()
              this.VNeuf = false
            }
        }else {
           if (!this.valeur || this.valeur == 0) {
          this.garanties = []
          this.SelectedPack = null
          this.VNeuf = false
        }
        }
        }else {
           //if(this.offre == 'offre_carte'){
            let trouver = 0;
            for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
                if (this.CarToUpdate.garanties[index] == 'TIERCE COMPLETE') {
                  trouver = 1
                } 
              }
  
            if (trouver == 1 && !this.valeur || this.valeur == 0) {
              this.CarToUpdate.garanties.pop()
              this.VNeuf = false
            }
        //}
        }
      },
  
      /* le user a choisi Avance Recours un popup apprait pour renseigner le capital Avance Recours*/
      /* alors si le user ferme le popup sans pour autant avoir renseigner le capital Avance Recours */
      /* on supprime la granties Avance Recours de la liste de ces garanties en executant CloseModalAvRec()*/
      CloseModalAvRec: function () {
        if (!this.CarToUpdate) {
          let trouver = 0;
          for (let index = 0; index < this.garanties.length; index++) {
            if (this.garanties[index] == 'AVANCE SUR RECOURS') {
              trouver = 1
            }
          }
  
          if (trouver == 1 && !this.capital_AvRec || this.capital_AvRec == 0) {
            this.garanties.pop();
            this.AvRec = false
          } else {
            this.garanties.pop();
            this.AvRec = false
          }
        } else {
          let trouver = 0;
          for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
            if (this.CarToUpdate.garanties[index] == 'AVANCE SUR RECOURS') {
              trouver = 1
            }
          }
  
          if (trouver == 1 && !this.CarToUpdate.capital_AvRec || this.CarToUpdate.capital_AvRec == 0) {
            this.CarToUpdate.garanties.pop();
            this.AvRecAddNew = false
          } else {
            this.CarToUpdate.garanties.pop();
            this.AvRecAddNew = false
          }
        }
  
      },
  
      /* le user a choisi Avance Recours un popup apprait pour renseigner le capital Avance Recours*/
      /* alors si le user ferme le popup sans pour autant avoir renseigner le capital Avance Recours */
      /* on supprime la granties Avance Recours de la liste de ces garanties en executant CloseModalAvRec()*/
      CloseModalAvRecWhenAddNewGaranties: function () {
        let trouver = 0;
        for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
          if (this.CarToUpdate.garanties[index] == 'AVANCE SUR RECOURS') {
            trouver = 1
          }
        }
  
        if (trouver == 1 && !this.CarToUpdate.capital_AvRec || this.CarToUpdate.capital_AvRec == 0) {
          this.CarToUpdate.garanties.pop();
          this.AvRecAddNew = false
        } else {
          this.CarToUpdate.garanties.pop();
          this.AvRecAddNew = false
        }
      },
  
      /* le user a choisi Avance Recours un popup apprait pour renseigner le capital Avance Recours*/
      /* alors si le user ferme le popup sans pour autant avoir renseigner le capital Avance Recours */
      /* on supprime la granties Avance Recours de la liste de ces garanties en executant CloseModalAvRec()*/
      CloseModalOptionTrans: function () {
        let trouver = 0;
        for (let index = 0; index < this.garanties.length; index++) {
          if (this.garanties[index] == 'PERSONNES TRANSPORTEES') {
            trouver = 1
          }
        }
  
        if (trouver == 1 && !this.optionPersoTrans || this.optionPersoTrans == 0) {
          this.garanties.pop();
          this.PersoTransporteModal = false
        } else {
          this.garanties.pop();
          this.PersoTransporteModal = false
        }
      },
  
      /* CheckCapitalAvRe est executée pour veririfer si le user à cocher ou decocher la garantie Avance Recours */
      /* si oui on affiche le popup pour demander le de renseigner capital Avance Recours sinon le popup reste fermé*/
      CheckCapitalAvRe: function () {
        if (!this.CarToUpdate) {
          let trouver = 0;
          for (let index = 0; index < this.garanties.length; index++) {
            if (this.garanties[index] == 'AVANCE SUR RECOURS') {
              trouver = 1
            }
          }
  
          if (trouver == 1 && !this.capital_AvRec || this.capital_AvRec == 0) {
            this.$toasted.show("Capital Avance sur recours obligatoires ! ", this.ToastTabError)
          } else if (trouver == 1 && this.capital_AvRec && this.capital_AvRec != 0) {
            this.AvRec = false
            if (this.garanties == this.packFull.packFullToutRisques.garanties) {
              this.tierceControl()
            } else if (this.garanties == this.packFull.packFullCollision.garanties) {
              this.tierceControl()
            }
          }
        } else {
          let trouver = 0;
          for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
            if (this.CarToUpdate.garanties[index] == 'AVANCE SUR RECOURS') {
              trouver = 1
            }
          }
  
          if (trouver == 1 && !this.CarToUpdate.capital_AvRec || this.CarToUpdate.capital_AvRec == 0) {
            this.$toasted.show("Capital Avance sur recours obligatoires ! ", this.ToastTabError)
          } else if (trouver == 1 && this.CarToUpdate.capital_AvRec && this.CarToUpdate.capital_AvRec != 0) {
            this.AvRecAddNew = false
          }
        }
  
      },
  
      AvRecModalFunction() {
        if (!this.CarToUpdate) {
          let trouver = 0
          for (let index = 0; index < this.garanties.length; index++) {
            if (this.garanties[index] == 'AVANCE SUR RECOURS') {
              trouver = 1
            }
          }
          if (trouver == 1) {
            this.AvRec = true
          } else {
            this.capital_AvRec = null
          }
        } else {
          let trouver = 0;
          for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
            if (this.CarToUpdate.garanties[index] == 'AVANCE SUR RECOURS') {
              trouver = 1
            }
          }
          if (trouver == 1) {
            this.AvRecAddNew = true
          } else {
            this.CarToUpdate.capital_AvRec = null
          }
        }
  
      },
  
     CheckValeurNeuf: function () {
        if (!this.CarToUpdate) {
          let trouver = 0;
          for (let index = 0; index < this.garanties.length; index++) {
            if (this.garanties[index] == 'TIERCE COMPLETE' || this.garanties[index] == 'TIERCE COLLISION') {
              trouver = 1
            }
          }
  
          if (trouver == 1 && !this.valeur || this.valeur == 0) {
            this.$toasted.show("Veuiller saisir la valeur à neuf du véhicule ! ", this.ToastTabError)
          } else if (trouver == 1 && this.valeur && this.valeur != 0) {
  
           if(this.myCars == 'mes_vehicule'){
                if (this.carDetails.valeur_venale <= Number(this.valeur.replace(/[^0-9.-]+/g, ""))) {
                    this.VNeuf = false
                } else {
                  this.$toasted.show('La valeur à neuf et la actuelle du véhicule ne sont pas cohérentes !', this.ToastTabError)
                }
            }else {
                if (Number(this.valeur_venale.replace(/[^0-9.-]+/g, "")) <= Number(this.valeur.replace(/[^0-9.-]+/g, ""))) {
                    this.VNeuf = false
                } else {
                  this.$toasted.show('La valeur à neuf et la actuelle du véhicule ne sont pas cohérentes !', this.ToastTabError)
                }
            }
          }
        } else {
          let trouver = 0;
          for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
            if (this.CarToUpdate.garanties[index] == 'TIERCE COMPLETE' || this.CarToUpdate.garanties[index] == 'TIERCE COLLISION') {
              trouver = 1
            }
          }
  
          if (trouver == 1 && !this.valeur || this.valeur == 0) {
            this.$toasted.show("Veuiller saisir la valeur à neuf du véhicule ! ", this.ToastTabError)
          } else if (trouver == 1 && this.valeur && this.valeur != 0) {
  
            if (Number(this.valeur_venale.replace(/[^0-9.-]+/g, "")) <= Number(this.valeur.replace(/[^0-9.-]+/g, ""))) {
              this.VNeuf = false
            } else {
              this.$toasted.show('La valeur à neuf et la actuelle du véhicule ne sont pas cohérentes !', this.ToastTabError)
            }
          }
        }
      },
  
      CheckValeurNeufAddGaranties: function () {
        let trouver = 0;
        for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
          if (this.CarToUpdate.garanties[index] == 'TIERCE COMPLETE' || this.CarToUpdate.garanties[index] == 'TIERCE COLLISION') {
            trouver = 1
          }
        }
  
        if (trouver == 1 && !this.valeur || this.valeur == 0) {
          this.$toasted.show("Veuiller saisir la valeur à neuf du véhicule ! ", this.ToastTabError)
        } else if (trouver == 1 && this.valeur && this.valeur != 0) {
  
          if (Number(this.valeur_venale.replace(/[^0-9.-]+/g, "")) <= Number(this.valeur.replace(/[^0-9.-]+/g, ""))) {
            this.VNeuf = false
          } else {
            this.$toasted.show('La valeur à neuf et la actuelle du véhicule ne sont pas cohérentes !', this.ToastTabError)
          }
        }
      },
  
      /* On affiche le popup pour ajouter des garanties supplementaires a un vehicule(item) */
      AddGaranties(item) {
        this.CarToUpdate = item;
        this.popupAddGaranties = true
      },
  
      /*==========CETTE PARTIE EST SPECIALEMENT POUR UNE SERIE DE FONCTION PERMETTANT DE VALIDER LES MODELS POUR CHAQUE STEPPER========*/
      //Validation des elements du Stepper 1
      Stepper1Validator() {
        if (this.flotte_mono) {
          if (this.flotte_mono === 'flotte') {
            if (this.nombreVehicules) {
              //document.getElementById("firstStep").classList.add('checked');
              document.getElementById("testup").classList.add('widthFirst');
              this.next()
              this.HideNbVehicule = true
            } else {
              this.$toasted.show('Nombre de véhicules !', this.ToastTabError)
            }
          } else {
            this.next()
            //document.getElementById("firstStep").classList.add('checked');
            document.getElementById("testup").classList.add('widthFirst');
            this.HideNbVehicule = false
          }
        } else {
          this.$toasted.show('Véhicule individuel ou Flotte automobile obligatoire ', this.ToastTabError)
        }
      },
  
      getListVehicule() {
        if (!store.state.isUserLoggedIn) {
          this.$toasted.show('Identifiez-vous pour une meilleure expérience !', this.ToastTabError)
          this.showLoginForm = true
        } else {
          this.ModalListeContrat = true
          this.listCars = this.userCars
          this.myCars = 'mes_vehicule'
        }
        this.getUserCars()
      },
  
      myCarValidator() {
        if (!store.state.isUserLoggedIn) {
          if (this.myCars == 'nouveau') {
            this.step = 1
          }
        } else {
          if (this.myCars == 'nouveau') {
            this.step = 1
          }
        }
      },
  
      getCarForDevis(item) {
        this.carDetails = item

        const date1 = dayjs(this.carDetails.dateCircule);
        const date2 = dayjs(new Date().toISOString().substr(0, 10));
        let daydiff = date2.diff(date1, 'days');

        // Toujours calculer l'âge en années
        let year = Math.floor(daydiff / 365);
        this.age = year;
        this.annee = year;
        this.year = year;
        this.annee_mois = year > 0 ? 'an(s)' : 'mois';

        if (this.carDetails.categorie == 'categorie 5') {
          this.categorie = '2_roues'
          this.offre_carte = true
          this.showOffre = false;
        } else if (this.carDetails.categorie != 'categorie 5') {
          this.categorie = null
          this.offre_carte = false
          this.showOffre = true;
          this.offre_pack = true
        }
  
        this.nbAutoAdded = this.nbAutoAdded + 1;
        this.flotte_mono = 'mono'
        this.step = 5
        this.ModalListeContrat = false
        document.getElementById("firstStep").classList.add('checked');
        document.getElementById("testup").classList.add('widthFive');
      },
  
      //Validation des ellements du Stepper 2
      Stepper2Validator() {
        if (this.categorie) {
          switch (this.categorie) {
            case '2_roues':
              if (this.carburant) {
                if (this.volumetrie2_roues){
                this.next()
                //document.getElementById("secondStep").classList.add('checked');
                document.getElementById("testup").classList.add('widthSecond');
                }else {
                  this.$toasted.show('la volumetrie 2 roues est obligatoire ', this.ToastTabError)
                }
              } else {
                 this.$toasted.show('La carburation du véhicule est obligatoire', this.ToastTabError)
                
              }
              break;
  
            case 'utilitaire':
              if (this.optionUtilitaire) {
                if (this.tonnage_carosserie) {
                  if (this.carburant) {
                    this.next()
                    //document.getElementById("secondStep").classList.add('checked');
                    document.getElementById("testup").classList.add('widthSecond');
                  } else {
                    this.$toasted.show('La carburation du véhicule est obligatoire', this.ToastTabError)
                  }
                } else {
                  this.$toasted.show('Tonnage et carosserie du véhicule', this.ToastTabError)
                }
              } else {
                this.$toasted.show('Veuillez renseigner le type du véhicule', this.ToastTabError)
              }
              break;
  
            case 'tourisme':
              if (this.carburant) {
                this.next()
                //document.getElementById("secondStep").classList.add('checked');
                document.getElementById("testup").classList.add('widthSecond');
              } else {
                this.$toasted.show('La carburation du véhicule est obligatoire', this.ToastTabError)
              }
              break;
          }
        } else {
          this.$toasted.show('La categorie du véhicule est obligatoire ', this.ToastTabError)
        }
      },
  
      //Validation des elements du Stepper 3
      Stepper3Validator() {
        if (this.categorie !== '2_roues') {
          if (this.marque) {
            if (this.model) {
              this.next()
              //document.getElementById("thirstStep").classList.add('checked');
              document.getElementById("testup").classList.add('widthThirt');
            } else {
              this.$toasted.show('Veuillez choisir le model du véhicule! ', this.ToastTabError)
            }
          } else {
            this.$toasted.show('Veuillez choisir la marque du véhicule! ', this.ToastTabError)
          }
        } else {
          if (this.marque) {
            if (this.model) {
              this.next()
              document.getElementById("firstStep").classList.add('checked');
              document.getElementById("testup").classList.add('widthFour');
  
            } else {
              this.$toasted.show('Veuillez choisir le model du véhicule! ', this.ToastTabError)
            }
          } else {
            this.$toasted.show('Veuillez choisir la marque du véhicule! ', this.ToastTabError)
          }
        }
  
      },
  
      //Validation des elements du Stepper 4
      Stepper4Validator() {
        this.Deduction_tonnage_carosserie();
        if (this.categorie !== '2_roues') {
          if (this.force) {
            if (this.dateCircule) {
              if (this.nbplace) {
                this.Stepper5Validator()
              } else {
                this.$toasted.show('Veuiller saisir le nombre de place du véhicule! ', this.ToastTabError)
              }
  
            } else {
              this.$toasted.show("Veuiller saisir la date 1ère mise en circulation du véhicule!", this.ToastTabError)
            }
          } else {
            this.$toasted.show('Veuiller saisir la puissance du véhicule! ', this.ToastTabError)
          }
        } else {
            if (this.dateCircule) {
                this.offre_carte = true
          this.showOffre = false;
                this.Stepper5Validator()
            } else {
              this.$toasted.show("Veuiller saisir la date 1ère mise en circulation du véhicule!", this.ToastTabError)
            }
        }
  
      },
  
      //Validation des elements du Stepper 5
      Stepper5Validator() {
        this.Deduction_tonnage_carosserie()
        if (!this.$store.state.isUserLoggedIn) {
          this.switch1 = false
        }
        if (this.categorieFInale == 'categorie 5') {
          if (this.immatriculation) {
            if(this.numeroChassis == null){
              this.next()
              document.getElementById("firstStep").classList.add('checked');
              document.getElementById("testup").classList.add('widthFour');
            } else if(this.numeroChassis != "" && this.numeroChassis.length < 17) {
              this.$toasted.show('Le numéro de châssis du véhicule doit etre au moins 17 caracteres!', this.ToastTabError)
            } else {
              this.next()
              document.getElementById("firstStep").classList.add('checked');
              document.getElementById("testup").classList.add('widthFour');
            }
          } else {
            this.$toasted.show('Veuiller saisir l\'immatriculation du véhicule!', this.ToastTabError)
          }
        } else {
          if (this.valeur_venale && Number(this.valeur_venale.replace(/[^0-9.-]+/g, "")) >= configAuto.valeurNeufMinimal_Autre_categorie) {
            if (this.immatriculation) {
              if(this.numeroChassis == null){
              this.next()
              document.getElementById("firstStep").classList.add('checked');
              document.getElementById("testup").classList.add('widthFour');
            } else if(this.numeroChassis != "" && this.numeroChassis.length < 17) {
              this.$toasted.show('Le numéro de châssis du véhicule doit etre au moins 17 caracteres!', this.ToastTabError)
            } else {
              this.next()
              document.getElementById("firstStep").classList.add('checked');
              document.getElementById("testup").classList.add('widthFour');
            }
            } else {
              this.$toasted.show("Veuiller saisir l'immatriculation du véhicule!", this.ToastTabError)
            }
          } else {
  
            this.$toasted.show('Veuiller saisir la valeur actuelle du véhicule!', this.ToastTabError)
          }
        }
      },
  
      /*==========Fonction de deduction de la categorie du vehicule selon ces options ========*/
      Deduction_tonnage_carosserie() {
        if (this.categorie == 'tourisme') {
          this.categorieFInale = 'categorie 1'
        } else if (this.categorie == 'utilitaire' && this.optionUtilitaire == 'Pour Compte') {
          this.categorieFInale = 'categorie 2';
          if (this.tonnage_carosserie == "Autre carosserie jusqu'à 3,5 tonnes") {
            this.tonnage = '3,5 Tonnes';
            this.carosserie = 'autres carosseries'
          } else if (this.tonnage_carosserie == 'Autre carosserie plus de 3,5 tonnes') {
            this.tonnage = 'Plus de 3,5 Tonnes';
            this.carosserie = 'autres carosseries'
          } else if (this.tonnage_carosserie == 'carosserie tourisme') {
            this.tonnage = '3,5 Tonnes';
            this.carosserie = 'carosserie tourisme'
          }
        } else if (this.categorie == 'utilitaire' && this.optionUtilitaire == 'Pour Tiers') {
          this.categorieFInale = 'categorie 3';
          if (this.tonnage_carosserie == "Autre carosserie jusqu'à 3,5 tonnes") {
            this.tonnage = '3,5 Tonnes';
            this.carosserie = 'autres carosseries'
          } else if (this.tonnage_carosserie == 'Autre carosserie plus de 3,5 tonnes') {
            this.tonnage = 'Plus de 3,5 Tonnes';
            this.carosserie = 'autres carosseries'
          }
        } else if (this.categorie == '2_roues') {
          this.categorieFInale = 'categorie 5'
        }
      },
  
      /*==========Fonction de nettoyage du formulaire apres recuperation des datas========*/
      ClearForm: function () {
        this.marque = '';
        this.model = '';
        this.categorie = '';
        this.force = '';
        this.age = '';
        this.nbplace = '';
        this.valeur = '';
        this.valeur_venale = '';
        this.immatriculation = '';
        this.carburant = '';
        this.option_Individuel_Accident = null;
        this.optionPersoTrans = null;
        this.capital_AvRec = null;
        this.garanties = ['RESPONSABILITE CIVILE']
      },
  
      /*==========Fonction permettant de remplacer les carburations par leurs equivalences========*/
      AutreCarburation(carburantChecked) {
        if (carburantChecked == 'Hybride' || carburantChecked == 'Electrique') {
          return 'Essence'
        } else {
          return carburantChecked
        }
      },
  
      /*=================Creation d'une liste de vehicules pour affichage Recap===============*/
      ListAutoCreate: function () {
        this.Deduction_tonnage_carosserie();
        const Oneauto = {
          categorie: this.categorieFInale,
          tonnage: this.tonnage,
          optionUtilitaire: this.optionUtilitaire,
          volumetrie2_roues: this.volumetrie2_roues,
          optionPersoTrans: this.optionPersoTrans,
          carburation: this.AutreCarburation(this.carburant),
          type_vitre: this.type_vitre,
          marque: this.marque,
          carosserie: this.carosserie,
          model: this.model,
          force: this.force,
          dateCircule: this.dateCircule,
          age: this.age,
          annee_mois: this.annee_mois,
          nbplace: Number(this.nbplace),
          valeur: Number(this.valeur.replace(/[^0-9.-]+/g, "")),
          valeur_venale: Number(this.valeur_venale.replace(/[^0-9.-]+/g, "")),
          immatriculation: this.immatriculation,
          numeroChassis: this.numeroChassis,
          flotte_mono: this.flotte_mono,
          option_Individuel_Accident: this.option_Individuel_Accident,
          garanties: this.garanties
        };
        if (this.capital_AvRec != null) {
          Oneauto.capitalAvRec = Number(this.capital_AvRec.replace(/[^0-9.-]+/g, ""))
        }
        if (this.categorie == '2_roues') {
          Oneauto.force = this.neant;
          //Oneauto.dateCircule = this.neant;
          Oneauto.valeur = this.neant;
          Oneauto.valeur_venale = this.neant;
          Oneauto.nbplace = 2
        }

         if(this.forceFiscaleValue != null){
          Oneauto.force = this.forceFiscaleValue
        }
  
        this.hideTablr = false;
        this.ListAuto.push(Oneauto);
  
        this.nbAutoAdded = this.nbAutoAdded + 1;
  
        //this.ClearForm();
        if (this.nombreVehicules > 1) {
          if (this.nbAutoAdded < this.nombreVehicules) {
            this.step = 2
            document.getElementById("testup").classList.add('widthSecond');
            document.getElementById("firstStep").classList.remove('checked');
            document.getElementById("testup").classList.remove('widthFour', 'widthThirt', 'widthSecond');
          }
          if (this.nbAutoAdded == this.nombreVehicules) {
            this.step = 6
            document.getElementById("secondStep").classList.add('checked');
            document.getElementById("testup").classList.add('widthFive');
          }
        } else {
          this.voidField = true
        }
      },
  
      /*=================Creation d'une liste de vehicules pour affichage Recap===============*/
      ListAutoCreateForCars: function () {
        this.Deduction_tonnage_carosserie();
        const Oneauto = {
          categorie: this.carDetails.categorie,
          tonnage: this.carDetails.tonnage,
          optionUtilitaire: this.carDetails.optionUtilitaire,
          volumetrie2_roues: this.carDetails.volumetrie2_roues,
          optionPersoTrans: this.optionPersoTrans,
          carburation: this.carDetails.carburation,
          type_vitre: this.carDetails.type_vitre,
          marque: this.carDetails.marque,
          carosserie: this.carDetails.carosserie,
          model: this.carDetails.model,
          force: this.carDetails.force,
          dateCircule: this.carDetails.dateCircule,
          age: this.carDetails.age,
          annee_mois: this.carDetails.annee_mois,
          nbplace: this.carDetails.nbplace,
          valeur: this.carDetails.valeur,
          valeur_venale: this.carDetails.valeur_venale,
          immatriculation: this.carDetails.immatriculation,
          numeroChassis: this.carDetails.numeroChassis,
          flotte_mono: this.carDetails.flotte_mono,
          option_Individuel_Accident: this.carDetails.option_Individuel_Accident,
          garanties: this.garanties
        };
        if (this.capital_AvRec != null) {
          Oneauto.capitalAvRec = Number(this.capital_AvRec.replace(/[^0-9.-]+/g, ""))
        }

        if (this.valeur != null) {
          Oneauto.valeur = Number(this.valeur.replace(/[^0-9.-]+/g, ""))
        }
        if (this.categorie == '2_roues') {
          Oneauto.force = this.neant;
          //Oneauto.dateCircule = this.neant;
          Oneauto.valeur = this.neant;
          Oneauto.valeur_venale = this.neant;
          Oneauto.nbplace = 2
        }
  
        this.hideTablr = false;
        this.ListAuto.push(Oneauto);
  
        this.nbAutoAdded = this.nbAutoAdded + 1;
  
        //this.ClearForm();
        if (this.nombreVehicules > 1) {
          if (this.nbAutoAdded < this.nombreVehicules) {
            this.step = 2
            document.getElementById("testup").classList.add('widthSecond');
            document.getElementById("firstStep").classList.remove('checked');
            document.getElementById("testup").classList.remove('widthFour', 'widthThirt', 'widthSecond');
          }
          if (this.nbAutoAdded == this.nombreVehicules) {
            this.step = 6
            document.getElementById("secondStep").classList.add('checked');
            document.getElementById("testup").classList.add('widthFive');
          }
        } else {
          this.voidField = true
        }
      },
  
      /*=================Recuperation des partenaires assureurs==============*/
      getListePartenaire: function () {
        Api().get('partenaire/partners/auto')
          .then(response => {
            this.listeAssureurs = response.data.partenaires
          })
      },
  
      /*=================Crée le tableau de la liste des véhicules==============*/
      createTable: function () {
        if (this.nbAutoAdded == this.nombreVehicules && this.myCars != 'mes_vehicule') {
          if (this.garanties.length >= 1) {
              if(!this.garanties.includes('RESPONSABILITE CIVILE')){
              this.$toasted.show('La Responsabilité Civile est obligatoire ! ', this.ToastTabError)
              return
            }
            this.step = 6
            document.getElementById("secondStep").classList.add('checked');
            document.getElementById("testup").classList.add('widthFive');
          } else {
            this.$toasted.show('Veuillez cocher une garantie au minimum ! ', this.ToastTabError)
          }
  
        } else if (!this.nombreVehicules && this.myCars != 'mes_vehicule') {
            if(!this.garanties.includes('RESPONSABILITE CIVILE')){
              this.$toasted.show('La Responsabilité Civile est obligatoire ! ', this.ToastTabError)
              return
            }
          if (this.garanties.length >= 1) {
            if (this.ListAuto.length == 0) {
              this.ListAutoCreate()
            }
            this.step = 6
  
            document.getElementById("secondStep").classList.add('checked');
            document.getElementById("testup").classList.add('widthFive');
          } else {
            this.$toasted.show('Veuillez cocher une garantie au minimum ! ', this.ToastTabError)
          }
        } else if (this.myCars == 'mes_vehicule') {
          if (this.garanties.length >= 1) {
              if(!this.garanties.includes('RESPONSABILITE CIVILE')){
              this.$toasted.show('La Responsabilité Civile est obligatoire ! ', this.ToastTabError)
              return
            }
            document.getElementById("secondStep").classList.add('checked');
            document.getElementById("testup").classList.add('widthFive');
            this.ListAutoCreateForCars()
            this.step = 6
          } else {
            this.$toasted.show('Veuillez cocher une garantie au minimum ! ', this.ToastTabError)
          }
        }
  
        // if (store.state.isUserLoggedIn) {
        //   this.proprietaire = this.$store.state.user.prenom + ' ' + this.$store.state.user.nom
        // }
      },
  
      /*=================Verification de la session de l'utilisateur et envoie des donnees==============*/
      SendData: function () {
        if (!store.state.isUserLoggedIn) {
          this.showLoginForm = true
        } else if (store.state.isUserLoggedIn && this.proprietaire) {
          if (this.dateEffet && this.duree) {
            if (this.assureurs.length > 0) {
              /*========== Attemp to save user in the flette ===========*/
              this.SaveUserFlette(store.state.user._id)
              /*========================================================*/
  
              document.getElementById("thirstStep").classList.add('checked');
              document.getElementById("testup").classList.add('widthSix');
              const OneautoToSave = {
                userid: store.state.user._id,
                dateEffet: this.dateEffet,
                createur: store.state.user._id,
                proprietaire: {
                  prenom: '',
                  nom: '',
                  genre: ''
                },
                dateEcheance: this.dateEcheance,
                dateSouscription: dayjs(new Date()).format('YYYY-MM-DD'),
                plateforme: 'Front',
                branche: "Automobile",
                duree: this.duree,
                vehicule: this.ListAuto,
                assureurs: this.assureurs,
              };
  
              if (this.numberMonth() == true) {
                if (this.switch1) {
                  OneautoToSave.proprietaire.prenom = this.$store.state.user.prenom;
                  OneautoToSave.proprietaire.nom = this.$store.state.user.nom
  
                  this.disabledButtonValidate = true
                  this.dialogLoading = true
                  
                  Api().post('devis/add', OneautoToSave)
                    .then(result => {
                      if (result.data.message) {
                        let GtmVal = {
                          branche: 'automobile',
                          entry_point: localStorage.getItem('quoteCreationEntryPoint'),
                          insurer_number: this.assureurs.length,
                          event: 'quote_creation'
                        }
                         let devisOffer = result.data.result.devis
                        if(devisOffer.length >= 1){
                          if(this.otherMarque == true){
                            this.setOtherVehicle(devisOffer)
                        }
                        }
                        PushInDataLayer(GtmVal)
                        this.notifMessage = result.data.message;
                        this.$store.dispatch('setDevis', result.data);
                          this.dialogLoading = false, 
                          this.disabledButtonValidate = false, 
                          this.$router.push({ name: 'listDevis' })
                      }
                    }).catch(error => {
                      this.$toasted.show(error.response.data.message, this.ToastTabError)
                      this.dialogLoading = false
                      this.disabledButtonValidate = false
                    })
  
                } else {
                  if (this.tableau_info_beneficiaire.length === 0 && this.nom_beneficiaire && this.prenom_beneficiaire) {
                    this.tableau_info_beneficiaire.push({
                      prenom: this.prenom_beneficiaire,
                      numero: this.num_beneficiaire,
                      nom: this.nom_beneficiaire,
                      email: this.email_beneficiaire,
                      genre: this.genre
                    });
                    this.proprietaire = this.prenom_beneficiaire + ' ' + this.nom_beneficiaire;
                  }
                  if (this.tableau_info_beneficiaire.length > 0) {
                    OneautoToSave.proprietaire = this.tableau_info_beneficiaire[0]
  
                    this.disabledButtonValidate = true
                    this.dialogLoading = true
                    Api().post('devis/add', OneautoToSave)
                      .then(result => {
                        if (result.data.message) {
                          let GtmVal = {
                            branche: 'automobile',
                            entry_point: localStorage.getItem('quoteCreationEntryPoint'),
                            insurer_number: this.assureurs.length,
                            event: 'quote_creation'
                          }
                           let devisOffer = result.data.result.devis
                        if(devisOffer.length >= 1){
                          if(this.otherMarque == true){
                            this.setOtherVehicle(devisOffer)
                        }
                        }
                          PushInDataLayer(GtmVal)
                          this.notifMessage = result.data.message;
                          this.$store.dispatch('setDevis', result.data);
                            this.dialogLoading = false, 
                            this.disabledButtonValidate = false, 
                            this.$router.push({ name: 'listDevis' })
                        }
                      }).catch(error => {
                        this.$toasted.show(error.response.data.message, this.ToastTabError)
                        this.dialogLoading = false
                        this.disabledButtonValidate = false
                      })
                  } else {
                    this.dialogInfoBeneficiaire = true
                  }
                }
              } else {
                this.$toasted.show("Le nombre de mois ne doit pas être supérieur a 12!", this.ToastTabError);
                this.duree = '';
              }
            } else {
              this.$toasted.show('Choisissez au moins un assureur !', this.ToastTabError)
            }
          } else {
            this.$toasted.show("Durée et date d'échéance obligatoires ! ", this.ToastTabError)
          }
        } else {
          this.$toasted.show("Nom complet du bénéficiaire obligatoire !", this.ToastTabError)
        }
      },
  
      editAuto(item) {
        this.editedIndex = this.ListAuto.indexOf(item);
        this.editedItem = item;
        this.dialogEditItem = true
      },
  
      close() {
        this.dialogEditItem = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1
        }, 300)
      },
  
      onChangeSelectedMarque() {
        if (typeof this.marque == 'string') {
          if (this.marque == 'AUTRE') {
            this.popupAutre = true;
            this.otherMarque = true;
            this.marque = ''
          } else {
            let selMarque = _.where(MarqueVehicule, {
              'Marque': this.marque
            });
            this.listeModeles = selMarque
            this.listeModeles[0] = "AUTRE";
            this.selectedMarque = this.marque
          }
        } else if (typeof this.marque == 'object') {
          if (this.marque == "AUTRE") {
            this.popupAutre = true;
            this.otherMarque = true;
            this.marque = ''
          } else {
            let selMarque = _.where(MarqueVehicule, {
              'Marque': this.marque
            });
            this.listeModeles = selMarque;
            this.listeModeles[0] = "AUTRE";
            this.selectedMarque = this.marque;
            this.marque = this.selectedMarque
          }
        }
      },
  
      onChangeSelectedModele: function (mark) {
        if (typeof mark == 'string') {
          if (mark == "AUTRE") {
            this.popupAutre = true;
            this.otherMarque = true;
            this.model = ''
          } else {
            let selMarque = _.where(MarqueVehicule, {
              'Type': mark
            });
            this.listeModeles = selMarque;
            this.selectedMarque = mark.Type;
            this.next()
            document.getElementById("testup").classList.add('widthThirt');
          }
        } else if (typeof mark == 'object') {
          if (mark.Type == "AUTRE") {
            this.popupAutre = true;
            this.otherMarque = true;
            this.model = ''
          } else {
            let selMarque = _.where(MarqueVehicule, {
              'Type': mark.Type
            });
            this.listeModeles = selMarque;
            this.selectedMarque = mark.Type;
            this.model = this.selectedMarque;
            this.next()
            document.getElementById("testup").classList.add('widthThirt');
          }
        }
      },
  
      onChangeSelectedMarque2roues() {
        if (typeof this.marque == 'string') {
          if (this.marque == "AUTRE") {
            this.popupAutre = true;
            this.otherMarque = true;
            this.marque = ''
          } else {
            let selMarque = _.where(Marque2roues, {
              'Marque': this.marque
            });
            this.listeModeles2roues = selMarque;
            this.listeModeles2roues[0] = "AUTRE"
            this.selectedMarque = this.marque
          }
        } else if (typeof this.marque == 'object') {
          if (this.marque == "AUTRE") {
            this.popupAutre = true;
            this.otherMarque = true;
            this.marque = ''
          } else {
            let selMarque = _.where(Marque2roues, {
              'Marque': this.marque
            });
            this.listeModeles2roues = selMarque;
            this.listeModeles2roues[0] = "AUTRE";
            this.selectedMarque = this.marque;
            this.marque = this.selectedMarque
  
          }
        }
      },
  
      onChangeSelectedModele2roues: function (mark) {
        if (typeof mark == 'string') {
          if (mark == "AUTRE") {
            this.popupAutre = true;
            this.otherMarque = true;
            this.model = ''
          } else {
            let selMarque = _.where(MarqueVehicule, {
              'Type': mark
            });
            this.listeModeles = selMarque;
            this.selectedMarque = mark.Type;
            this.e1 = 5
          }
        } else if (typeof mark == 'object') {
          if (mark.Type == "AUTRE") {
            this.popupAutre = true;
            this.otherMarque = true;
            this.model = ''
          } else {
            let selMarque = _.where(MarqueVehicule, {
              'Type': mark.Type
            });
            this.listeModeles = selMarque;
            this.selectedMarque = mark.Type;
            this.model = this.selectedMarque;
            this.e1 = 5
          }
        }
      },
  
      PersoTransporteModalFunction() {
        if (!this.CarToUpdate) {
          let trouver = 0;
          for (let index = 0; index < this.garanties.length; index++) {
            if (this.garanties[index] == 'PERSONNES TRANSPORTEES') {
              trouver = 1
            }
          }
          if (trouver == 1) {
            this.PersoTransporteModal = true
          } else {
            this.optionPersoTrans = null
          }
        } else {
          let trouver = 0;
          for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
            if (this.CarToUpdate.garanties[index] == 'PERSONNES TRANSPORTEES') {
              trouver = 1
            }
          }
          if (trouver == 1) {
            this.PersoTransporteModal = true
          } else {
            this.CarToUpdate.optionPersoTrans = null
          }
        }
      },
  
      ValeurNeufModalFunction() {
        if (!this.CarToUpdate) {
          let trouver = 0;
          for (let index = 0; index < this.garanties.length; index++) {
            if (this.garanties[index] == 'TIERCE COMPLETE') {
              trouver = 1
            } else if (this.garanties[index] == 'TIERCE COLLISION') {
              trouver = 2
            }
          }
          if (trouver == 1 || trouver == 2) {
            this.VNeuf = true
          } else {
            this.valeur = this.neant
          }
        } else {
          let trouver = 0;
          for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
            if (this.CarToUpdate.garanties[index] == 'TIERCE COMPLETE') {
              trouver = 1
            } else if (this.CarToUpdate.garanties[index] == 'TIERCE COLLISION') {
              trouver = 2
            }
          }
          if (trouver == 1 || trouver == 2) {
            this.VNeuf = true
          } else {
            this.valeur = this.neant
          }
        }
      },
  
      ValeurNeufModalAddGarantiesFunction() {
        let trouver = 0;
        for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
          if (this.CarToUpdate.garanties[index] == 'TIERCE COMPLETE') {
            trouver = 1
          } else if (this.CarToUpdate.garanties[index] == 'TIERCE COLLISION') {
            trouver = 2
          }
        }
        if (trouver == 1 || trouver == 2) {
          this.VNeuf = true
        } else {
          this.valeur = this.neant
        }
      },
  
      Individuel_Accident_ModalFunction() {
        if (this.Individuel_Accident_Modal == false) {
          this.Individuel_Accident_Modal = true
        } else {
          this.Individuel_Accident_Modal = false
        }
      },
  
      SaveUserFlette(userid) {
        Api().post('flette/addarray', { car: this.ListAuto, user: userid })
          .then((result) => { console.log(result.data.msg) })
          .catch((err) => { console.log(err) });
      }
    },
  
    computed: {
      progressClasses() {
        let result = 'progress '
        if (this.currentStep && this.currentStep.label === 'complete') {
          return result += 'progress--complete'
        }
        return result += `progress--${this.steps.indexOf(this.currentStep) + 1}`
      },
  
      formTitle() {
        return this.editedIndex === -1 ? 'Nouveau véhicule' : 'Modification du véhicule'
      },

      /*=================Marques uniques pour l'édition OCR carte grise ==============*/
      ocrEditMarques() {
        const cat = this.extractedCarteGriseData && this.extractedCarteGriseData.categorie
        const source = cat == '2_roues' ? Marque2roues : MarqueVehicule
        const seen = new Set()
        for (const item of source) {
          if (item && item.Marque) seen.add(item.Marque)
        }
        return Array.from(seen).sort()
      },

      /*=================Modèles uniques filtrés par la marque OCR carte grise ==============*/
      ocrEditModeles() {
        if (!this.extractedCarteGriseData || !this.extractedCarteGriseData.marque) return []
        const source = this.extractedCarteGriseData.categorie == '2_roues' ? Marque2roues : MarqueVehicule
        const seen = new Set()
        for (const item of source) {
          if (item && item.Marque === this.extractedCarteGriseData.marque && item.Type) {
            seen.add(item.Type)
          }
        }
        return Array.from(seen).sort()
      },

      /*=================proprieté pour filtrer les packs en fonction de l'âge du véhicule ==============*/
      filteredGaranties() {
        // Si l'âge du véhicule est > 5 ans, exclure "Tout Risques"
        if (this.age && this.age > 5) {
          return this.listeGaranties.filter(pack => pack.id !== 'pack_full_tous_risques');
        }
        return this.listeGaranties;
      },

      /*=================proprieté permettant de selectionner touts les assureurs à la fois ==============*/
      selectAll: {
        get: function () {
          return this.listeAssureurs ? this.selected.length == this.listeAssureurs.length : false;
        },
        set: function (value) {
          const assureurs = [];

          if (value) {
            this.listeAssureurs.forEach(function (assure) {
              assureurs.push(assure.societe);
            });
          }
          this.assureurs = assureurs;
        }
      }
    },
  
    watch: {
      dialog(val) {
        val || this.close()
      },
  
      model(val) {
        if (typeof val == 'object') {
          this.model = val.Type
        } else if (typeof val == 'string') {
          this.model = val
        }
      },
  
      showLoginForm(val) {
        if (val == false) {
          if (store.state.isUserLoggedIn) {
            this.getUserCars()
            this.proprietaire = this.$store.state.user.prenom + ' ' + this.$store.state.user.nom
          }
        }
      },
  
      assureurs(val)
      {
        let checker  = false
        for(let v of val){
          if(v=="SANLAM" && this.duree < 6){
            for(let a of this.ListAuto)
            {
                for(let g of a.garanties)
                {
                  if(g.toUpperCase()=="AVANCE SUR RECOURS")
                  {
                    checker  = true
                  }
                }
            }
          }
        }
  
        if(checker){
          this.$toasted.show("Pour SANLAM, la garantie AVANCE SUR RECOURS  n'est posible qu'à partir de 6 mois de durée !", this.ToastTabErrorSpec)
        }
  
      }
    },
  
    mounted: function () {
      window.scrollTo(0, 0);
      this.checkToken()
      if (store.state.isUserLoggedIn) {
        this.getUserCars()
      } else {
        console.log("the user isn't connected")
      }
      this.getListePartenaire()
      esk('track', 'Conversion');
  
    },
    created() {
      this.GarantiesBase = configAuto.Garanties;
      this.Garanties2roues = configAuto.Garanties2roues
    }
  }
  </script>
  
  <style lang="less" scoped>
  @import "../../assets/css/button.css";
  @import "../../assets/css/devis_css.css";
  
  .shadow_card {
    box-shadow: 9px 12px 18px rgb(0 0 0 / 5%);
  }
  
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    font-size: 15px;
  }
  
  .form {
    background-color: #fff;
    padding: 1.5rem;
  }
  
  .form .page {
    height: auto;
  }
  
  button.next {
    position: absolute;
    bottom: 0;
    right: 0;
    margin-right: 1.5rem;
    margin-bottom: 1rem;
  }
  
  button.previous {
    position: absolute;
    bottom: 0;
    left: 0;
    margin-left: 1.5rem;
    margin-bottom: 1rem;
  }
  
  
  button.edit {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  
  h4 {
    color: #29323a;
    margin-bottom: 15px;
    font-weight: 600;
  }
  
  
  
  
  html {
    background-color: #1a1a1a;
    overflow: hidden;
  }
  
  .middle {
    width: auto;
    text-align: center;
    /* Made by */
  }
  
  .middle h1 {
    font-family: "Inter", sans-serif;
    color: #fff;
  }
  
  .middle input[type="radio"] {
    display: none;
  }
  
  .middle input[type="radio"]:checked+.box {
    background-color: rgba(255, 164, 9, 0.07);
    transition: all .33s ease;
    border: 2px solid #ffa409;
    color: #29323a;
  }
  
  .middle input[type="radio"]:checked+.box span {
    color: #29323a;
    transform: translateY(70px);
  }
  
  .middle input[type="radio"]:checked+.box span:before {
    transform: translateY(0px);
    opacity: 1;
  }
  
  .middle .box {
    width: 220px;
    height: 150px;
    border-radius: 12px;
    background-color: #fff;
    transition: all 250ms ease;
    will-change: transition;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    position: relative;
    box-shadow: 0 4px 8px rgb(172 186 200 / 10%);
    font-size: 10px;
    border: 1px solid #d9dee3;
    font-family: Open Sans, sans-serif;
    font-weight: 900;
  }
  
  .middle .box:hover {
    background-color: rgba(255, 164, 9, 0.07);
    transition: all .33s ease;
    border: 2px solid #ffa409;
  }
  
  .middle .box:hover span {
    color: #29323a;
  }
  
  .middle .box:active {
    transform: translateY(10px);
  }
  
  .middle .box span {
    position: absolute;
    transform: translate(0, 60px);
    left: 0;
    right: 0;
    padding-top: 15%;
    transition: all 300ms ease;
    font-size: 1.5em;
    user-select: none;
    color: #29323a;
  }
  
  .middle .box span:before {
    font-size: 1.2em;
    font-family: FontAwesome;
    display: block;
    transform: translateY(-80px);
    opacity: 0;
    transition: all 300ms ease-in-out;
    font-weight: normal;
    color: #fff;
  }
  
  .middle p {
    color: #fff;
    font-family: "Inter", sans-serif;
    font-weight: 400;
  }
  
  .middle p a {
    text-decoration: underline;
    font-weight: bold;
    color: #fff;
  }
  
  .middle p span:after {
    content: "\f0e7";
    font-family: FontAwesome;
    color: yellow;
  }
  
  .widthFirst {
    background-color: var(--custom-color-primary) !important;
    height: 5px;
    border-radius: 5px;
    transition: width .33s ease;
    width: 8.55556%;
  }
  
  .widthSecond {
    background-color: var(--custom-color-primary) !important;
    height: 5px;
    border-radius: 5px;
    transition: width .33s ease;
    width: 16.11112%;
  }
  
  .widthThirt {
    background-color: var(--custom-color-primary) !important;
    height: 5px;
    border-radius: 5px;
    transition: width .33s ease;
    width: 24.11112%;
  }
  
  .widthFour {
    background-color: var(--custom-color-primary) !important;
    height: 5px;
    border-radius: 5px;
    transition: width .33s ease;
    width: 33.11112%;
  }
  
  .widthFive {
    background-color: var(--custom-color-primary) !important;
    height: 5px;
    border-radius: 5px;
    transition: width .33s ease;
    width: 65%;
  }
  
  .widthSix {
    background-color: var(--custom-color-primary) !important;
    height: 5px;
    border-radius: 5px;
    transition: width .33s ease;
    width: 100%;
  }
  
  .paralax-cover-image {
    background-image: url('../../assets/img/assurance/auto.jpg');
    position: relative;
    background-size: contain !important;
    background-position: 50%;
    min-height: 230px;
    width: 100%;
    margin: 0 0 0;
    display: flex;
    /*padding: 20px;*/
    align-items: center;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
  
  }
  
  .paralax-cover-image p {
    color: rgb(255, 255, 255);
    font-size: 20px;
    font-weight: 300;
  }
  
  .paralax-cover-image .paralax-cover-image-text,
  .paralax-cover-image h2 {
    color: #fff;
    font-size: 2em;
    line-height: 1.25;
    z-index: 1;
    margin-bottom: 0;
    max-width: 610px;
    text-align: center;
    margin-left: 8.5%;
  }
  
  .paralax-cover-image.has-background-dim:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  .paralax-cover-image {
    background-attachment: fixed;
    background-position: 50% 40px;
  }
  
  
  
  .paralax-cover-image_mobile {
    background-image: url('../../assets/img/assurance/auto_mobile.jpg');
    position: relative;
    background-size: contain;
    background-position: 50%;
    min-height: 150px;
    width: 100%;
    margin: 0 0 0;
    display: flex;
    //padding: 20px;
    align-items: center;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
  
  }
  
  .paralax-cover-image_mobile p {
    color: rgb(255, 255, 255);
    font-size: 20px;
    font-weight: 300;
    padding-bottom: 20Px;
  }
  
  .paralax-cover-image_mobile .paralax-cover-image-text_mobile,
  .paralax-cover-image_mobile h2 {
    color: #fff;
    font-size: 2em;
    line-height: 1.25;
    z-index: 1;
    margin-bottom: 0;
    max-width: 610px;
    text-align: center;
    margin-left: 8.5%;
  }
  
  .paralax-cover-image_mobile.has-background-dim_mobile:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  .paralax-cover-image_mobile {
    // background-attachment: fixed;
    background-position: 100% 40px;
  }
  
  
  .hero {
    position: relative;
    background-size: cover;
    background-position: center center;
    height: 680px;
    min-height: 320px;
    max-height: 100%;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    justify-content: center;
    -ms-flex-pack: center;
    padding: 20px;
  }
  
  .hero .content_home {
    position: relative;
    min-height: 280px;
    width: 100%;
    margin-left: 8.5%;
    z-index: 2;
    /*//background: red;*/
  }
  
  .hero .content_home p {
    color: rgb(255, 255, 255);
    font-size: 20px;
    font-weight: 300;
    width: 100%;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  
  
  /*== start of code for tooltips ==*/
  .tool {
    cursor: help;
    position: relative;
  }
  
  
  /*== common styles for both parts of tool tip ==*/
  .tool::before,
  .tool::after {
    left: 50%;
    opacity: 0;
    position: absolute;
    z-index: -100;
  }
  
  .tool:hover::before,
  .tool:focus::before,
  .tool:hover::after,
  .tool:focus::after {
    opacity: 1;
    transform: scale(1) translateY(0);
    z-index: 100;
  }
  
  
  /*== pointer tip ==*/
  .tool::before {
    border-style: solid;
    border-width: 1em 0.75em 0 0.75em;
    border-color: #565C61 transparent transparent transparent;
    bottom: 105%;
    content: "";
    margin-left: -0.5em;
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26), opacity .65s .5s;
    transform: scale(.6) translateY(-90%);
  }
  
  .tool:hover::before,
  .tool:focus::before {
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26) .2s;
  }
  
  
  
  /*== speech bubble ==*/
  .tool::after {
    background: #565C61;
    border-radius: .25em;
    bottom: 120%;
    color: #EDEFF0;
    font-size: 15px;
    content: attr(data-tip);
    margin-left: -8.75em;
    padding: 1em;
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26) .2s;
    transform: scale(.6) translateY(50%);
    width: 17.5em;
  
  }
  
  .tool:hover::after,
  .tool:focus::after {
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26);
  }
  
  @media (max-width: 760px) {
    .tool::after {
      font-size: .75em;
      margin-left: -5em;
      width: 10em;
    }
  }
  
  // css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}

.lightning-box {
    position: absolute;
    bottom: 15px;
    width: 30px;
    right: 10px!important;
}



.insurers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

@media (max-width: 768px) {
  .insurers-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}

.insurer-card {
  position: relative;
  border-radius: 12px;
  background: #ffffff;
  border: 2px solid #e2e8f0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.insurer-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border-color: #cbd5e0;
}

.insurer-card.selected {
  border-color: #ffa409;
  background: linear-gradient(135deg, #fff7ed 0%, #ffffff 100%);
  box-shadow: 0 4px 20px rgba(255, 164, 9, 0.2);
}

.insurer-card.all-insurers {
  background: linear-gradient(135deg, #ffa409 0%, #ff8c00 100%);
  border-color: #ffa409;
  color: white;
}

.insurer-card.all-insurers.selected {
  background: linear-gradient(135deg, #e69500 0%, #cc7a00 100%);
  transform: scale(1.02);
}

.insurer-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.insurer-label {
  display: flex;
  align-items: center;
  padding: 1.25rem;
  cursor: pointer;
  width: 100%;
  height: 100%;
  position: relative;
  transition: all 0.3s ease;
}

.insurer-icon {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7fafc;
  border-radius: 12px;
  margin-right: 1rem;
  transition: all 0.3s ease;
}

.insurer-card.selected .insurer-icon {
  background: rgba(255, 164, 9, 0.1);
}

.insurer-card.all-insurers .insurer-icon {
  background: rgba(255, 255, 255, 0.2);
}

.insurer-logo {
  max-width: 45px;
  max-height: 45px;
  object-fit: contain;
  filter: brightness(1);
  transition: all 0.3s ease;
}

.insurer-card.all-insurers .insurer-logo {
  filter: brightness(0) invert(1);
}

.insurer-info {
  flex: 1;
  min-width: 0;
}

.insurer-name {
  font-size: 1rem;
  font-weight: 500;
  color: #2d3748;
  margin: 0 0 0.25rem 0;
  line-height: 1.2;
  word-break: break-word;
}

.insurer-card.all-insurers .insurer-name {
  color: white;
}

.insurer-badge {
  display: inline-block;
  font-size: 0.85rem;
  font-weight: 500;
  color: #718096;
  background: #edf2f7;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.insurer-card.all-insurers .insurer-badge {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.insurer-card.selected .insurer-badge {
  background: rgba(255, 164, 9, 0.2);
  color: #b45309;
}

.selection-indicator {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  opacity: 0;
  transform: scale(0.8);
}

.insurer-card.selected .selection-indicator {
  opacity: 1;
  transform: scale(1);
  background: #ffa409;
  color: white;
}

.selection-indicator i {
  font-size: 0.75rem;
}

.selection-summary {
  background: linear-gradient(135deg, #e6fffa 0%, #f0fff4 100%);
  border: 1px solid #9ae6b4;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
}

.summary-content {
  display: flex;
  align-items: center;
  color: #2f855a;
  font-weight: 500;
}

.summary-content i {
  margin-right: 0.5rem;
  font-size: 1.1rem;
}

/* Animation d'entrée */
.insurer-card {
  animation: slideInUp 0.6s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Animation pour les cartes sélectionnées */
.insurer-card.selected {
  animation: pulse 0.6s ease-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.02);
  }
  100% {
    transform: scale(1);
  }
}

/* Responsive amélioré */
@media (max-width: 480px) {
  .insurer-label {
    padding: 1rem;
  }
  
  .insurer-icon {
    width: 50px;
    height: 50px;
    margin-right: 0.75rem;
  }
  
  .insurer-logo {
    max-width: 35px;
    max-height: 35px;
  }
  
  .insurer-name {
    font-size: 1.4rem;
  }
  
  .modern-title {
    font-size: 1.1rem;
  }
}

/* Amélioration de l'accessibilité */
.insurer-card:focus-within {
  //outline: 2px solid #ffa409;
  outline-offset: 2px;
}

.insurer-input:focus + .insurer-label {
  box-shadow: 0 0 0 3px rgba(255, 164, 9, 0.3);
}

/* États de chargement */
.insurers-grid.loading .insurer-card {
  opacity: 0.6;
  pointer-events: none;
}

/* Bouton désactivé pour l'option Tous Risques si véhicule > 5 ans */
.btn-choice.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
  background-color: #f5f5f5 !important;
  border-color: #ddd !important;
}

.btn-choice.disabled input,
.btn-choice.disabled label {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-choice.disabled::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
  border-radius: inherit;
}

/* OCR Carte Grise Styles Mobile */
.ocr-upload-section .upload-box {
  border: 2px dashed #d9dee3;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.ocr-upload-section .upload-box:hover {
  border-color: #ffa409;
  background: #fff8f0;
}

.ocr-upload-section .upload-box.upload-success {
  border-color: #28a745;
  background: #f0fff4;
}

.ocr-upload-section .upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ocr-recap-section .form-control {
  border-radius: 8px;
  border: 1px solid #d9dee3;
}

.ocr-recap-section .form-control:focus {
  border-color: #ffa409;
  box-shadow: 0 0 0 0.2rem rgba(255, 164, 9, 0.25);
}

.ocr-actions-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}

.btn-ocr-retry-mobile {
  padding: 10px 20px;
  border-radius: 25px;
  border: 2px solid #6c757d;
  background: transparent;
  color: #6c757d;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-ocr-retry-mobile:hover {
  background: #6c757d;
  color: white;
}

.btn-ocr-validate-mobile {
  padding: 12px 25px;
  border-radius: 25px;
  border: none;
  background: linear-gradient(135deg, #ffa409 0%, #ff8c00 100%);
  color: white;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 164, 9, 0.4);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.btn-ocr-validate-mobile:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 164, 9, 0.5);
}

.analyze-cg-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #ffa409;
  color: #fff;
  border: none;
  border-radius: 50px;
  padding: 12px 28px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 2px 10px rgba(255, 164, 9, 0.25);
}

.analyze-cg-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(255, 164, 9, 0.4);
}

.analyze-cg-btn:disabled {
  background-color: #d3d3d3;
  box-shadow: none;
  cursor: not-allowed;
}

@media (max-width: 760px) {
  .input-group.rate-loan {
    display: flex;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    flex-wrap: nowrap;
  }
  .input-group.rate-loan .field-select,
  .input-group.rate-loan .field-input {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    flex: 1 1 0;
    box-sizing: border-box;
  }
}
  </style>
  